import moment from "moment";
import { getWords, MoneyFormatv3 } from "./MoneyFormat";
import { billingCurrencyOptions } from "../utils/Data/StaticData";
import QRCode from "qrcode";
import { trimEdgesOnly } from "../utils/common";
import { isValidUPI } from "./shared";
import API_ENDPOINTS from "../apiEndpoints";
import dayjs from "dayjs";
import { formatDate, formatUnixTimestamp } from "./dayJs";
import { boolean } from "yup";

export const PosPrint = async ({
  data,
  items,
  totNetAmount,
  totGstCess,
  totDiscount,
  totGST,
  registrationType,
  totAmount,
  companyDetails,
  InvoiceSettings,
  companyState,
  additionalDiscount,
  tcsAmount,
  totTaxAmt,
  totNetAmt,
}) => {
  console.log({
    data,
    items,
    totNetAmount,
    totGstCess,
    totDiscount,
    totGST,
    registrationType,
    totAmount,
    companyDetails,
    InvoiceSettings,
    companyState,
     additionalDiscount,
  tcsAmount,totTaxAmt,
      totNetAmt,
  },"*********details");
  let qrupi = isValidUPI(InvoiceSettings.upi_id)
    ? await QRCode.toDataURL(`upi://pay?pa=${InvoiceSettings.upi_id}`, {
        margin: 0,
      })
    : "";
  let currencySymbol = billingCurrencyOptions.find(
    (elem) => data?.currency?.value == elem.value
  )?.sign;
  let RegisterationType =
    companyDetails?.relatedcompanydetailsnew?.[0]?.registrationtype;


const renderRow1 = () => {
  return `
    <tr style="border-top:solid 1px gray;">
      <td style="border-right:solid 1px gray"></td>
      <td style="text-align:right;max-width:250px;border-right:solid 1px gray;">
        <div>Gross value</div>
        ${ Number(totDiscount) > 0? `<div>Discount</div>` : ``}
        <!-----${ Number(totGST) > 0? `<div>Tax</div>` : ``}---->
        ${ Number(additionalDiscount) > 0 ? `<div>Additional Discount if any</div>`: ``}
        ${Number(tcsAmount) > 0 ? `<div>Tcs</div>` : ``}
      </td>

      <td style="border-right:solid 1px gray;text-align:center"></td>
      <td style="text-align:right;border-right:solid 1px gray"></td>
      <td style="text-align:right;border-right:solid 1px gray"></td>

      ${
        RegisterationType !== 1 && RegisterationType != 3
          ? `
            <td style="border:none;padding:0px" colspan="2">
              <table style="width:100%">
                 <tr>
                        <td style="text-align:center;width:25%;height:100%">  ${'\u00A0'}                     
                        </td>
                        <td class="right" style="width:75%;text-align:right;height:100%">   ${'\u00A0'}                        
                        </td>
                      </tr>
              </table>
            </td>
          `
          : ``
      }

      ${
        totGstCess > 0 && RegisterationType != 1
          ? `<td class="right" style="border:none;border-left:solid 1px gray"></td>`
          : ``
      }

      <td style="text-align:right;border-left:solid 1px gray">
           <div>${currencySymbol}&nbsp;${MoneyFormatv3((totAmount - totDiscount).toFixed(2))}</div>
            ${
          Number(totDiscount) > 0
            ? `<div>${currencySymbol}&nbsp;${MoneyFormatv3(Number(totDiscount).toFixed(2))}</div>`
            : ``
            }
           <!----- ${
          Number(totGST) > 0
            ? `<div>${currencySymbol}&nbsp;${MoneyFormatv3((Number(totGST) + Number(totGstCess)).toFixed(2))}</div>`
            : ``
            }---->
            ${
          Number(additionalDiscount) > 0
            ? `<div>(-${currencySymbol}&nbsp;${MoneyFormatv3(Number(additionalDiscount).toFixed(2))})</div>`
            : ``
            }
            ${
          Number(tcsAmount) > 0
            ? `<div>${currencySymbol}&nbsp;${MoneyFormatv3(Number(tcsAmount).toFixed(2))}</div>`
            : ``
            }
            
        </td>
    </tr>
  `;
};


  const renderRow = () => {
  let row = "";
  if (items && items.length > 0) {
    items.forEach((item, index) => {
      if (item.name?.label)
        row += `
          <tr style="min-height:100px;box-sizing: border-box;">
            <td style="vertical-align:baseline;border-right:solid 1px gray">${index + 1}</td>
            <td style="text-align:left;max-width:250px;border-right:solid 1px gray">
              ${item.name?.label}
            </td>
            <td style="border-right:solid 1px gray;text-align:center">${Number(item.qty)}</td>
            <td style="text-align:right;border-right:solid 1px gray">${MoneyFormatv3(item.rate)}</td>
            <td style="text-align:right;border-right:solid 1px gray">${MoneyFormatv3(item.dicount)}</td>
            ${
              RegisterationType !== 1 && RegisterationType != 3
                ? `
                  <td style="text-align:right;border-right:solid 1px gray">${MoneyFormatv3(item.taxableAMount)}</td>
                  ${[3, 5].includes(data?.taxability?.value) ? `` :
                    `
                    <td style="border:none;padding:0px" colspan="2">
                    <table style="width:100%">
                      <tr>
                        <td style="text-align:center;width:25%;border-right:solid 1px gray">
                          ${item.GSTRate !== -1 ? `${item.GSTRate}` : `NIL`}
                        </td>
                        <td class="right" style="width:75%;border-right:solid 1px gray;text-align:right">
                          ${
                            data.placeOfSupply !== companyState
                              ? `${item.GSTRate !== -1 ? `
                                  ${MoneyFormatv3(
                                  (
                                    (Number(item.taxableAMount) * Number(item.GSTRate)) / 100
                                  ).toFixed(2)
                                )}
                                ` : `\u00A0${(0.00).toFixed(2)}`} `
                              : "0.00"
                          }
                        </td>
                      </tr>
                    </table>
                  </td>
                  ${
                    totGstCess > 0 && RegisterationType != 1
                      ? `<td class="right" style="border:none;text-align:right;border-right:solid 1px gray">
                          ${item.GSTCess != 0 ? MoneyFormatv3(item.GSTCess) : "0.00"}
                         </td>`
                      : ``
                  }
                    
                    `}
                `
                : ``
            }
            <td style="text-align:right">
              ${MoneyFormatv3(Number(item.netAmount).toFixed(2))}
            </td>
          </tr>

          ${
            registrationType !== 3 &&
            item.HSN?.value &&
            InvoiceSettings.hsnsacode
              ? `
                <tr>
                  <td style="border-right:solid 1px gray"></td>
                  <td class= "hsnFont" style="text-align:left;max-width:250px;border-right:solid 1px gray">
                    HSN / SAC ${item.HSN?.value}
                  </td>

                 <td style="border-right:solid 1px gray;text-align:center"></td>
                 <td style="text-align:right;border-right:solid 1px gray"></td>
                 <td style="text-align:right;border-right:solid 1px gray"></td>
                ${
                  RegisterationType !== 1 && RegisterationType != 3 ? `
                  <td style="text-align:right;border-right:solid 1px gray"></td>

                  ${[3, 5].includes(data?.taxability?.value) ? `` : 
                    `
                    <td style="border:none;padding:0px" colspan="2">
                    <table style="width:100%">
                      <tr>
                        <td style="text-align:center;width:25%;border-right:solid 1px gray;height:100%">  ${'\u00A0'}                     
                        </td>
                        <td class="right" style="width:75%;border-right:solid 1px gray;text-align:right;height:100%">   ${'\u00A0'}                        
                        </td>
                      </tr>
                    </table>
                  </td>
                  ${
                   totGstCess > 0 && RegisterationType != 1 ? `<td class="right" style="border:none;text-align:right;border-right:solid 1px gray"> </td>` : ``
                  }
                    `}

                  ` : ``
                }

                 <td style="text-align:right">
              
            </td>    
                </tr>
              `
              : ``
          }
        `;
    });
    return row;
  }
};


const renderRow2 = () => {
  return `
    <tr style="border-top:solid 1px gray;font-weight:bold">
      <td colspan=${ (RegisterationType === 3) || (RegisterationType === 1) ? "5" : "7"} style="text-align:left">
        Gross Total : ${getWords(
                 (
                  Number(data.receivedAmount || 0) +  Number(data?.bankReceivedAmount || 0)).toFixed(2),
                  data?.currency?.code
                )}
      </td>
      <td style="border-left:solid 1px gray;text-align:right"><span>${currencySymbol}&nbsp;${MoneyFormatv3((Number(totNetAmount)).toFixed(2))}</td>
    </tr>
  `;
}

const renderRow4 = () => {
  return `
    <tr style="border-top:solid 1px gray;font-weight:bold;box-sizing: border-box;">
      <td colspan="4" style="text-align:left;padding:0; margin:0;">
      <span style="display:flex;width:100%; margin:0; padding:0; line-height:2;">
         ${(RegisterationType == 3 )|| (data.reverseChargeFlag === 1) ? `<span style="width:65%;border-right:solid 2px gray"><strong>Note: Amount of GST subject to Reverse Charge</strong></span>` : `` }
          <span  style="border-left:solid 1px gray; padding:0px 5px;text-align:right;${ (RegisterationType == 3 || data?.reverseChargeFlag === 1) ? 'width:35%;' : 'width:100%;' }">Total</span>
      </span>
      </td>
       <td style="border-left:solid 1px gray;text-align:right"><span>${currencySymbol}&nbsp;${MoneyFormatv3((Number(totDiscount)).toFixed(2))}</td> 
       ${RegisterationType !== 1 &&   RegisterationType != 3 ? `
        <td style="border-left:solid 1px gray;text-align:right"><span>${currencySymbol}&nbsp;${MoneyFormatv3((Number(totTaxAmt)).toFixed(2))}</td>
        ${[3, 5].includes(data?.taxability?.value) ? `` : `
           <td  colspan="2" style="border-left:solid 1px gray;text-align:right"><span>${currencySymbol}&nbsp;${MoneyFormatv3((Number(totGST)).toFixed(2))}</td>
          `}
        ` : ``} 
      <td style="border-left:solid 1px gray;text-align:right"><span>${currencySymbol}&nbsp;${MoneyFormatv3((Number(totNetAmt)).toFixed(2))}</td>
    </tr>
  `;
}

  return `
    <html>
  <head>
    <meta name="viewport" />
    <style rel="stylesheet">

@media print {
  @page {
    margin: 0;
  }

  .header,
  .footer {
    display: none;
  }
}
    .trbody{
      font-size: 12px;
     }
     .trhead{
       font-size: 14px;
     }
       thead td{
       font-size: 14px;
     }
     
     tfoot td{
     font-size:14px;
     }
       tbody td {
      font-size: 12px;
     }
   .firsttable thead td{
    font-size: 12px;
  }
   .firsttable tbody td {
   font-size: 10px;
  }
   .thirdDiv thead td {
    font-size: 12px;
  }
  
  .thirdDiv tbody td {
    font-size: 10px;
  }
  
  .thirdDiv tfoot td {
    font-size: 14px;
  }
  .firstDiv{
  font-size:12px;
  }
  table, th, td {
  
  border-collapse: collapse;
  }
  .fourthTable thead td {
  font-size: 12px;
  }
  .fourthTable tbody td {
  font-size: 10px;
  }
  
  .postable thead td{
    padding:4px;
  }
  .postable thead td{
    padding:4px;
  }
    .hsnFont {
     font-size:12px
    }
   </style>
  </head>
  <body>

  <div style=" display: flex;flex-direction:column;padding:0px 0px 10px 0px ">
    <span style="font-size: 18px; font-weight: bolder;  padding:2px 0px 5px 0px">
     ${
        (RegisterationType === 3 || RegisterationType === 1)
          ? InvoiceSettings.bosinvoiceheading
          : (((data.voucherNumber)?.includes("PBOS") || [2,3,5].includes(data?.taxability?.value))
              ? InvoiceSettings.bosinvoiceheading
              : InvoiceSettings.invoiceheading)
      }
    </span>
      ${
      RegisterationType == 3
      ? `( We are under composition scheme. Not Eligible to collect Tax on supplies )`
      : ""
      }
  </div>
  <div style= "border: solid 1px gray">
   
  <div style="min-height: 100px;  width:100%;">
  <div style="width: 100%; float: center;">
    <div style="display: flex; flex-direction:column; padding: 0px 0px 0px 0px;border: solid 1px gray; border-top:none;border-left:none;border-right:none">
    <div style="display:flex; flex-direction:row-reverse; justify-content:space-between;padding:0px 10px;">
    <div style="border-left:solid 1px gray; flex:0 0 25%; display:flex; align-items: center; justify-content: center;" >
    ${
      InvoiceSettings?.companylogo
        ? `
    ${
      companyDetails?.relatedcompanydetailsnew?.[0].companylogourl ==
        `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/` ||
      companyDetails?.relatedcompanydetailsnew?.[0].companylogourl == ""
        ? `
   
    `
        : `
    <img F1 src="${companyDetails?.relatedcompanydetailsnew?.[0].companylogourl}"
    alt="CompanyLogo" width="80px" height="80px">
    `
    }
        `
        : ``
    }
      </div >

      <div style="font-size:12px;border-left:solid 1px gray; flex:0 0 25%;display:flex;align-items:center;justify-content:center " >          
           <div style="padding:5px;display:flex;flex-direction:column;gap:5px;align-items:flex-start; justify-content:flex-start;">
           
            <span style="font-weight:bold">${
             data?.voucherNumber
               ? `Inv.No : <span style="white-space:nowrap;">${data.voucherNumber}</span>`
               : ``
           }</span>
              <span style="white-space:nowrap;font-size:12px;font-weight:bold">${
                InvoiceSettings?.invoicedate
                  ? `Inv.Date : &nbsp;${
                      data.invoiceDate === ""
                        ? formatDate(new Date())
                        : formatDate(data.invoiceDate)
                    }`
                  : ``
              }</span>
              <!-------
              ${ InvoiceSettings?.customername ? `<div>Customer Name : ${data?.partyName} </div>`: `` }
              ${InvoiceSettings?.customercontactnumber? `<div style="font-size: 10px; padding-bottom: 5px;">Customer Contact Number : ${data?.partyContactNumber} </div>`: ``}
              ------>
              <!----<div style="font-size:12px;font-weight:bold">payment date :${data.invoiceDate === ""? moment(new Date()).format("DD-MM-YYYY"): moment(data.invoiceDate).format("DD-MM-YYYY")}</div>--->

               ${companyDetails.statename ? `<div style="font-size:12px;font-weight:bold">Place of Supply : ${companyDetails.statename}</div>` :  ``}           
               ${data?.taxability?.label ? `<div style="font-size:12px;font-weight:bold">Taxability : ${data?.taxability?.value === 3 ? `Non-Taxable` : `${data?.taxability?.label}`}</div>` : ``}  
              <div style="font-size:12px;font-weight:bold">Reverse Charge :${data.reverseChargeFlag == 1 ? "Yes" : "No"}</div>        
              </div>
      </div>


      <div style="word-break:break-word;text-align:left; flex:0 0 50%;" >
      ${
        InvoiceSettings?.companyname
          ? `<span style="font-size: 15px; padding-bottom: 5px;
     font-weight:bold;">
     ${companyDetails?.companyname}
    </span><br/>
    `
          : ""
      }
  
    <span style="font-size: 12px;max-width:50%;font-weight:normal ">
          ${
            companyDetails?.line1?.replace(/[**,]+/g, "")
              ? companyDetails?.line1?.replace(/[**,]+/g, " ") + ", "
              : ""
          }</span>   <span style="font-size: 12px;font-weight:normal">${
    companyDetails?.city ? companyDetails?.city + ", " : ""
  }${
    companyDetails?.district?.replace("District", "")
      ? companyDetails?.district?.replace("District", "") + ", "
      : ""
  }${
    companyDetails?.statename?.replace("District", "")
      ? companyDetails?.statename?.replace("District", "") + ", "
      : ""
  }${companyDetails?.countrycode?.replace("State", "")}</span>
          <span style="font-size: 12px;font-weight:normal
         ">${
           companyDetails?.pincode &&
           ", " + companyDetails?.pincode?.split("**").join("\n")
         }
    </span>
      ${
        RegisterationType !== 1
          ? `
  
   
    ${
      InvoiceSettings?.companygstin &&
      companyDetails?.relatedcompanyentity?.[0]?.gstin
        ? `  <br/> <span style="font-size: 12px;font-weight:normal">
    GSTIN : ${
      companyDetails?.relatedcompanyentity?.[0]?.gstin == undefined
        ? ""
        : companyDetails?.relatedcompanyentity?.[0]?.gstin
    }  </span> `
        : ``
    }
  `
          : ""
      }
     ${
       companyDetails?.relatedcompanydetailsnew?.[0]?.pannumber?.length &&
       InvoiceSettings?.companypan
         ? `<span style="font-size: 12px; margin-left:10px;font-weight:normal">PAN :${companyDetails?.relatedcompanydetailsnew?.[0]?.pannumber}</span>`
         : ``
     }


    ${
      companyDetails?.relatedcompanydetailsnew?.[0]?.cinregistrationnumber
        ?.length && InvoiceSettings?.companycin
        ? `<br/><span style="font-size: 12px;font-weight:normal">CIN : ${companyDetails?.relatedcompanydetailsnew?.[0]?.cinregistrationnumber}</span>`
        : ``
    }   
    ${
      companyDetails?.relatedcompanydetailsnew?.[0]?.websiteurl?.length &&
      InvoiceSettings?.companywebsite
        ? `<br/><span style="font-size: 12px;font-weight:normal">WEB : ${companyDetails?.relatedcompanydetailsnew?.[0]?.websiteurl}</span>`
        : ``
    }
    ${
      companyDetails?.relatedemailcontacts?.[0]?.emailaddress?.length &&
      InvoiceSettings?.companyemail
        ? `<br/><span style="font-size: 12px;font-weight:normal">MAIL : ${companyDetails?.relatedemailcontacts?.[0]?.emailaddress}</span>`
        : ``
    }
    ${
      companyDetails?.relatedphonecontacts?.[0]?.phonenumber?.length &&
      InvoiceSettings?.companycontactnumber
        ? `<span style="font-size: 12px;margin-left:10px;font-weight:normal">MOB : ${companyDetails?.relatedphonecontacts?.[0]?.phonenumber}</span>`
        : ``
    }
  
  
    </div>


    </div>
  
    </div>
    </div>


  <div style=" margin-left: auto; margin-right: auto; width:100%;margin-left: auto; margin-right: auto; padding-top:0px;">
       <!-------
       <div >
         <div style=" display: flex;flex-direction:column; justify-content: center;padding:0px 0px 10px 0px ;align-items:center">
               <span style="font-size: 18px; font-weight: bolder;  padding:2px 0px 5px 0px">
               ${
                   RegisterationType == 3 || RegisterationType == 1
                     ?InvoiceSettings.bosinvoiceheading
                     : InvoiceSettings.invoiceheading
               }
               </span>
               ${
                 RegisterationType == 3
                   ? `( We are under composition scheme. Not Eligible to collect Tax on supplies )`
                   : ""
               }
           </div>
           ------>

           <div style="display: flex;flex-direction:row; justify-content: end; padding: 10px;display:none">
              ${
                InvoiceSettings?.invoicedate
                  ? `
               <div style="display: flex; flex-direction:row;gap:15px; ">
                   <span style="font-size: 15px;  padding-bottom: 5px; text-align:right;">
                      Invoice Date :
                   </span>
                   <span style="font-size: 15px; font-weight: bold; text-align:right;">
                       ${moment(new Date(data.invoiceDate)).format(
                         "DD-MM-YYYY"
                       )}
                   </span>
               </div>`
                  : ""
              }
           </div>
           <div style=" ">
  <div style="display: flex; flex-direction:column; ">
  ${
    InvoiceSettings?.invoicenumber
      ? `
  <div style="font-size: 15px; padding-bottom: 5px;display:none">
    Invoice No: <span style="font-size: 15px; font-weight: bold">
    ${data.voucherNumber}
  </span>
  </div>`
      : ``
  }
  
  </div>
            <div style="display: flex;flex-direction:row; justify-content: space-between;padding:0px 10px;display:none">
            <!-----
              <div style="display: flex; flex-direction:column;font-size:12px ">
                  ${
                  InvoiceSettings?.customername
                  ? `<span style="font-size: 12px; padding-bottom: 5px;">
                    Customer Name : ${data?.partyName}
                  </span>`
                  : ``  
                  }
              </div> --->
            </div>
              <div style="display:none">
              <div style="font-size: 15px;  padding-bottom: 5px">
                  ${
                  data.paymentType === "Credit"
                  ? "Due Date"
                  : "Payment Date"
                  } :   <span style="font-size: 15px; font-weight: bold; text-align:right;">
                  ${
                  data.paymentType === "Credit"
                  ? `${data.dueDate}`
                  : `${
                  data.invoiceDate === ""
                  ? moment(new Date()).format("DD-MM-YYYY")
                  : moment(data.invoiceDate).format("DD-MM-YYYY")
                  }`
                  }
                  </span>
                </div>               
              </div>
              </div>

              <div style="background-color:rgba(224, 155, 213, 0.77);width:100%"> <span style="font-size:13px;font-weight:bold;padding-left:10px">Customer Details</span></div>

               ${(data?.partyName !== "") || (data?.partyContactNumber !== "")  ? `<div style="display: flex;flex-direction:row; justify-content: space-between;padding:5px 10px;width:60%">
             
             ${data?.partyName !== "" ? `
              <div style="display: flex; flex-direction:column;font-size:12px ">
                 <span style="font-size: 12px; padding-bottom: 5px;">
                    Customer Name : ${data?.partyName}
                  </span>
              </div>
              ` : ``}

              ${
                 data?.partyContactNumber !== "" ? `
                <div style="display: flex; flex-direction:column; ">
                    <span style="font-size: 12px; padding-bottom: 5px;">
                    Ph. No: ${data?.partyContactNumber}
                     </span>
                </div> 
                 ` : ``
              }
             </div>` :  ``}
              

         </div>
     </div> 
     
                      <!-------section----->
  
    <div style="margin-left: auto; margin-right: auto; width:100%; margin: 0px 0px;border:solid 1px gray;border-left:none;border-right:none">
        <table width="100%" class="postable" style="text-align: center; cellpadding="5"; cellspacing="0";">
            <thead style="background-color: rgba(224, 155, 213, 0.77); font-weight: bold;box-sizing: border-box;">
                <tr>
                    <td style="width:30px;border-right:solid 1px gray;text-align:center">Sl</td>
                    <td style="text-align:center;border-right:solid 1px gray">Item Name</td>
                    <td style="border-right:solid 1px gray;text-align:center">Qty</td>
                    <td style="text-align:right;border-right:solid 1px gray;text-align:center">Rate</td>
                    <td style="text-align:right;border-right:solid 1px gray;text-align:center">Discount</td>
                    ${
                      RegisterationType !== 1 &&   RegisterationType != 3
                        ? `
                   <td style="text-align:right;border-right:solid 1px gray;text-align:center">Taxable Amount</td>

                   ${[3, 5].includes(data?.taxability?.value) ? `` : 
                    `
                    <td colspan="2" style="padding:0px;height: 45px;
                    vertical-align: unset;">
                    <div style="height:100%;">
                    <table  style="width:100%;height:100%;">
                    <tr>
                    <td colspan="2" style="text-align:center;vertical-align: middle;font-weight:bold;border-bottom:solid 1px gray;border-right:solid 1px gray">C&SGST</td>
                    </tr>
                    <tr style="border:none;width:100%">
                      <td style="text-align:center;width:25%;border:none;vertical-align: middle;font-weight:bold;border-right:solid 1px gray">&nbsp;%&nbsp;</td>
                      <td style="text-align:center;width:75%;vertical-align: middle;font-weight:bold;border-right:solid 1px gray">Amount</td>
                    </tr>
                  </table>
                  </div>
                  </td>
                ${totGstCess > 0 ? ` <td style="border-right:solid 1px gray">GST Cess</td>` : ``}
                    `
                   }`
                        : ``
                    }
  
                    <td style="text-align:center">Total</td>
                </tr>
            </thead>
            <tbody>
                ${renderRow()}
                ${renderRow4()}
            </tbody>
        </table>
    </div>
      <div style = "font-size:12px;display:flex;border-bottom:solid 1px gray;align-items:center;gap:10px;height:fit-content;padding:0px">

      <!-----
        <div>Received in Cash: ${(Number(data.receivedAmount)).toFixed(2)}</div>     
        <div>
          Total: ${currencySymbol}&nbsp;${MoneyFormatv3((Number(data.receivedAmount || 0) +Number(data?.bankReceivedAmount || 0) ).toFixed(2) )}
        </div> 
        ---->   
        
        
        <div style="width:100%">
          <div style="display:flex;border-bottom:solid 1px gray;width:100%"> 
            <div style="width:25%;border-right:solid 1px gray;padding-left:5px;box-sizing: border-box;">
              <div style = "display:flex;flex-direction:column;gap:3px;">
                ${(Number(data.receivedAmount)) ? ` <span>Amount Received in Cash</span>` : ``}
                ${(Number(data?.bankReceivedAmount)) ? ` <span>Amount Received in Bank</span>` : ``}
              </div>
            </div>
            <div style="width:25%;border-right:solid 1px gray;padding-right:5px; box-sizing: border-box;text-align:right">
              <div style = "display:flex;flex-direction:column;gap:3px;">
                ${(Number(data.receivedAmount)) ? `<strong> ${currencySymbol}&nbsp;${MoneyFormatv3((Number(data.receivedAmount)).toFixed(2))}</strong>` : ``} 
                ${(Number(data.bankReceivedAmount)) ? `<strong> ${currencySymbol}&nbsp;${MoneyFormatv3((Number(data?.bankReceivedAmount)).toFixed(2))}</strong>` : ``} 
              </div>
            </div>
            <div style= "width:50%;display:flex;padding:0px 5px; box-sizing: border-box;">
              <div style="display:flex;flex-direction:column;gap:3px;width:50%;border-right:solid 1px gray">
                  ${ Number(additionalDiscount) > 0 ? `<span>Additional Discount</span>` : ``}
                  ${tcsAmount > 0? `<span>TCS</span>` : ``}
                  ${ Number(data.roundOff)  ? `<span>Roundoff</span>` : ``}

              </div>
              
             <div style="display:flex;flex-direction:column;gap:3px;width:50%;align-items:flex-end">
                ${Number(additionalDiscount) > 0 
                    ? `<div><strong>${currencySymbol} (-${MoneyFormatv3(Number(additionalDiscount).toFixed(2))})</strong></div>`  
                    : ``}
                ${tcsAmount  >0
                    ? `<div><strong>${currencySymbol} ${MoneyFormatv3(Number(tcsAmount).toFixed(2))}</strong></div>`  
                    : ``}
                ${Number(data.roundOff)  
                    ? `${data.roundoff >= 0 ? `<div><strong>${currencySymbol} ${MoneyFormatv3(Number(data.roundOff).toFixed(2))}</strong></div>`  :   `<div><strong>${currencySymbol} (${MoneyFormatv3(Number(data.roundOff).toFixed(2))})</strong></div>`}`  
                    : ``}
             </div>
            </div>
         </div>
          <div style="display:flex;"> 
            <div style="width:25%;border-right:solid 1px gray;height:25px;display:flex;align-items:center;padding-left:5px; box-sizing: border-box;">Total Amount Received</div>
            <div style="width:25%;border-right:solid 1px gray;height:25px;display:flex;align-items:center;justify-content:flex-end;padding-right:5px; box-sizing: border-box;"><strong> ${currencySymbol}&nbsp;${MoneyFormatv3((Number(data.receivedAmount || 0) +Number(data?.bankReceivedAmount || 0) ).toFixed(2) )}</strong></div>
            <div style="width:25%;border-right:solid 1px gray;height:25px;display:flex;align-items:center;padding-left:5px; box-sizing: border-box;">Net Total</div>
            <div style="width:25%;height:25px;display:flex;align-items:center;justify-content:flex-end;padding-right:5px; box-sizing: border-box;"><strong> ${currencySymbol}&nbsp;${MoneyFormatv3((Number(totNetAmount)).toFixed(2))}</strong></div>
          </div>
        </div>
      </div>
      <div style="font-size: 12px; margin-top: 10px;padding-left:10px ">
        <strong> In Words :  ${getWords(( Number(data.receivedAmount || 0) +  Number(data?.bankReceivedAmount || 0)).toFixed(2), data?.currency?.code)} Only </strong>
      </div>
      <div>
          <div style="font-size: 12px; margin-top: 10px;padding-left:10px ">
            Description : <strong> ${data.remarks} </strong>
          </div>
      </div>
      <div>
        ${isValidUPI(InvoiceSettings.upi_id) ? ` <div style="flex:1;justify-content:center;display:flex;padding:1px;align-items:center;padding:0px 10px">
          <div style="flex:1;font-size:14px">
          Payment QR Code<br/>
          UPI ID :${InvoiceSettings.upi_id}
          </div style="flex:1;justify-content:center">
          
          <div>
          <img src="${qrupi}" width="80" height="80" />
          </div>
        
          </div>` : ``}
        </div>

      <div style="display:flex;align-items:flex-end;padding-right:10px;font-size:12px;margin-top:30px;flex-direction:column">
        ${InvoiceSettings?.regularinvoicesignaturefilename ? `<img src="${InvoiceSettings?.regularinvoicesignaturefilename}" width="120" height="50" />` : ``}  
        <div style="font-size:14px;font-weight:bold">${
          InvoiceSettings?.signaturetext
          ? InvoiceSettings?.signaturetext
          : "Authorized Signature"
          }
        </div>
         ${companyDetails?.companyname ? `<div style= "margin-top:10px;font-size:16px"> <strong>${companyDetails?.companyname}</strong></div>` : ``}
      </div>



  
                          <!------section------------>
        <div style="padding: 0px 10px;display:none" >
            <div style="display: flex; flex-direction:column; line-height: 1;">
                <div style="display: flex; flex-direction:row; justify-content: space-between;
                            font-size: 12px;  margin-top: 5px;">
                    <span>Gross Value</span>
                    <span>${currencySymbol}&nbsp;${MoneyFormatv3(
    totAmount.toFixed(2)
  )}</span>
                </div>
           
                <div style="display: flex; flex-direction:row; justify-content: space-between;
                            font-size: 12px;  margin-top: 5px;">
                    <span>Discount</span>
                    <span>${currencySymbol}&nbsp;${
    Number(totDiscount) > 0
      ? MoneyFormatv3(Number(totDiscount).toFixed(2))
      : "0.00"
  }</span>
                </div>
                  <div style="display: flex; flex-direction:row; justify-content: space-between;
                            font-size: 12px;  margin-top: 5px;">
                    <span>Add Discount if any,</span>
                    <span>${currencySymbol}&nbsp;${
    Number(additionalDiscount) > 0
      ? MoneyFormatv3(Number(additionalDiscount).toFixed(2))
      : "0.00"
  }</span>
                </div>
               ${
                 RegisterationType !== 1
                   ? `
                <div style="display: flex; flex-direction:row; justify-content: space-between;
                            font-size: 12px;  margin-top: 5px;">
                    <span>Tax</span>
                    <span>${currencySymbol}&nbsp;${
                       totGST
                         ? MoneyFormatv3((Number(totGST) + Number(totGstCess)).toFixed(2))
                         : "0.00"
                     }</span>
                </div>`
                   : ``
               }
      
             <div style="display: flex; flex-direction:row; justify-content: space-between;
                            font-size: 12px;  margin-top: 5px;">
                    <span>Round Off</span>
                    <span>${currencySymbol}&nbsp;${MoneyFormatv3(
                 Number(data.roundOff)
               )}</span>
                </div>
                
       
                <div style="display: flex; flex-direction:row; justify-content: space-between;
                            font-size: 12px;  margin-top: 5px;">
                    <span>Tcs</span>
                    <span>${currencySymbol}&nbsp;${
                       tcsAmount
                         ? MoneyFormatv3(Number(tcsAmount).toFixed(2))
                        
                         : "0.00"
                     }</span>
                </div>

                <div style="display: flex; flex-direction:row; justify-content: space-between;
                            font-size: 14px;  
                           padding-top: 5px; padding-bottom: 5px;">
                    <strong>Gross Total</strong>
                    <strong style="text-align: right;">
                        <span>${currencySymbol}&nbsp;${MoneyFormatv3(
    (Number(totNetAmount)).toFixed(2)
  )}</span>
    ${
      data.receivedAmount
        ? `<p style="margin-top:2px">Amount Received in Cash: ${currencySymbol}&nbsp;${MoneyFormatv3(
            data.receivedAmount
          )}</p>`
        : ""
    }
    ${
      data?.bankReceivedAmount
        ? `<p style="margin-top:2px">Amount Received in Bank: ${currencySymbol}&nbsp;${MoneyFormatv3(
            data?.bankReceivedAmount
          )}</p>`
        : ""
    }
${
  data.receivedAmount || data?.bankReceivedAmount
    ? `
   <p style="margin-top:2px">Total Amount Received</span>
    <span>${currencySymbol}&nbsp;${MoneyFormatv3(
        (
          Number(data.receivedAmount || 0) +
          Number(data?.bankReceivedAmount || 0)
        ).toFixed(2)
      )}</span>
</p>
`
    : ""
}
                    </strong>
                </div>
            </div>
    </div>
                                        <!--------section-------->
    <div style="padding:0px 10px;display:none">
              <div style="display:flex;justify-content: space-between;font-size: 14px;">
                <span>IN WORDS </span> <strong>
                ${getWords(
                 (
                  Number(data.receivedAmount || 0) +  Number(data?.bankReceivedAmount || 0)).toFixed(2),
                  data?.currency?.code
                )}
                </strong>
            </div>
      <!--    <div style="display:flex;justify-content: space-between;font-size: 12px;">
            <span>Cash Received: </span> 
           <span>${currencySymbol}&nbsp;${MoneyFormatv3(totNetAmount)}</span>
             </div>
             -->
            <div style="font-size: 12px; margin-top: 10px; ">
            Description : <strong> ${data.remarks} </strong>
            </div>
            ${
              isValidUPI(InvoiceSettings.upi_id)
                ? `
                <div style="flex:1;justify-content:center;display:flex;padding:1px;align-items:center">
                <div style="flex:1;">
                Payment QR Code<br/>
                UPI ID :${InvoiceSettings.upi_id}
                </div style="flex:1;justify-content:center">
                
                <div>
                
                <img src="${qrupi}" width="100" height="100" />
                </div>
              
                </div>
                `
                : ""
            }
        </div>
          <div style="margin-left: auto; margin-right: auto; width:100%; display:flex; flex-direction:row;justify-content: space-between; page-break-inside: avoid;">
        <div style=" padding:5px 0px;box-sizing:border-box;">
            <div display:flex; flex-direction:column;>
                <div style="text-align: center;">
                    <strong style="visibility:hidden" class="trhead">Received The Item In Good Condition</strong>
                </div>
                <div class="trbody" style="margin-top: 15px; text-align: center;">
                ${
                  InvoiceSettings?.regularinvoicesignaturefilename?.length
                    ? `<div style="height:30px" ></div>`
                    : ""
                }
                    <div  style="visibility:hidden" >Customer Name and Signature</div>
                </div>
            </div>
        </div>
                                                        <!------section---->
        <div style="display:flex;justify-contetnt:space-around;background-color:red;width:100%;display:none">
             <div style="font-size: 12px; margin-top: 10px; ">
            Description : <strong> ${data.remarks} </strong>
            </div>
            <div display:flex; flex-direction:column;>
                <div class="trhead" style="text-align: center;">
                    <strong>For ${companyDetails?.companyname.toUpperCase()}</strong>
                </div>
                <div class="trbody" style="margin-top: 15px; text-align: center;">
                    ${
                      InvoiceSettings?.regularinvoicesignaturefilename?.length
                        ? `<img height="30px"  replaceherestart  src="${InvoiceSettings?.regularinvoicesignaturefilename}"  replacehereend  />`
                        : ``
                    }
                    <div>${
                      InvoiceSettings?.signaturetext
                        ? InvoiceSettings?.signaturetext
                        : "Authorized Signature"
                    }</div>
                   
                  
                </div>
            </div>
        </div>
    </div>
    </div>
  </body>
  </html>
  
    `;
};

export const PurchaseTaxablePrint = ({
  invTransArr,
  data,
  totGstCess,
  totGST,
  totNetAmount,
  totDiscount,
  totAmount,
  tabelTotAmount,
  totTaxableAmount,
  bankDetails,
  registrationType,
  stateOfSupply,
  countryName,
  stateName,
  suppierAddressDetals,
  companyDetails,
  nonItems,
  items,
  units,
  nonItemwiseTableAmount,
  journalhtmlItems,
  journalhtmlNonItems,
  totGstRate,
  journelReady,
  companyState,
  fromType,
  partyType
}) => {
  companyDetails = JSON.parse(JSON.stringify(companyDetails));
  console.log("companyDetails:", companyDetails);
  console.log("companyDetails.line1:", companyDetails.line1);
  console.log("Type of line1:", typeof companyDetails.line1);
  console.log({ companyDetails });
  let itemEntry = true;
  let currencySymbol = billingCurrencyOptions.find(
    (elem) => data?.currency?.value == elem.value
  )?.sign;

  console.log({
    invTransArr,
    data,
    totGstCess,
    totGST,
    totNetAmount,
    totDiscount,
    totAmount,
    tabelTotAmount,
    totTaxableAmount,
    bankDetails,
    registrationType,
    stateOfSupply,
    countryName,
    stateName,
    suppierAddressDetals,
    companyDetails,
    nonItems,
    items,
    units,
    nonItemwiseTableAmount,
    journalhtmlItems,
    journalhtmlNonItems,
    totGstRate,
    journelReady,
    companyState,
  },"*********dataaa");

  console.log(companyDetails.companyname);
  const taxability = data?.taxability?.value;
  const renderJournel = () => {
    {
      let ren = "";
      invTransArr = invTransArr.sort((p1) =>
        p1.debitAmt !== 0 ? -1 : p1.creditAmt == 0 ? 0 : 1
      );
      invTransArr.map((ele, ind) => {
        ren += `<tr key={ind}>
                        ${
                          ele.debitAmt == 0 && ele.creditAmt == 0
                            ? ``
                            : `
                                <td
                                    size="small"
                                    sx={{
                                        fontWeight: "bold",
                                        color: ele.debitAmt !== 0 ? "#396afc" : "#20e0cf",
                                        width: "300px",
                                        height: "0px",
                                    }}
                                >
                                    ${
                                      ele.debitAmt !== 0
                                        ? ele.accountName + " " + "Dr"
                                        : "To" + " " + ele.accountName
                                    }
                                </td>
                                <td
                                    align="right"
                                    size="small"
                                    sx={{
                                        fontWeight: "bold",
                                        color: "#396afc",
                                        width: "30px",
                                        height: "0px",
                                    }}
                                >
                                    ${
                                      ele.debitAmt == 0
                                        ? " "
                                        : MoneyFormatv3(
                                            Number(ele.debitAmt).toFixed(2),
                                            "en-IN"
                                          )
                                    }
                                </td>
                                <td
                                    align="right"
                                    size="small"
                                    sx={{
                                        fontWeight: "bold",
                                        color: "#20e0cf",
                                        width: "30px",
                                        height: "0px",
                                    }}
                                >
                                    ${
                                      ele.creditAmt == 0
                                        ? " "
                                        : MoneyFormatv3(
                                            Number(ele.creditAmt).toFixed(2),
                                            "en-IN"
                                          )
                                    }
                                </td>
                           `
                        }
                    </tr>`;
      });
      return ren ?? "";
    }

    return;
    if (journelReady) {
      return journelReady;
    }
    let row = "";
    if (itemEntry) {
      journalhtmlItems?.map((item) => {
        if (item.editable === false)
          row += `<tr style="color:#396afc;font-weight: bold;">
                           <td width="60%">${
                             item.purchaseAccount?.label
                           } Dr</td>
                           <td width="20%" align="center">${MoneyFormatv3(
                             Number(item.amountTaxable).toFixed(2),
                             "en-IN"
                           )}</td>
                           <td width="20%" align="center"></td>
                         </tr>
                         `;
      });
    } else {
      //nonItems.map((ele) => {
      journalhtmlNonItems?.map((ele) => {
        if (ele.editable === false)
          row += `<tr style="color:#396afc;font-weight: bold;">
                         <td width="60%"> ${ele.ledgerAccount?.label} Dr</td>
                  
                         <td width="20%" align="center">${MoneyFormatv3(
                           Number(ele.amountTaxable).toFixed(2),
                           "en-IN"
                         )}</td>
                         <td width="20%" align="center"></td>
                       </tr>`;
      });
    }
    return row;
  };
  let isNonItemExist = !!nonItems;
  let isItemExist = !!items;
  console.log(isNonItemExist, isItemExist);
  let colspan = 11;
  if (data.placeOfSupply.value !== companyState) {
    colspan -= 1;
  } else {
    console.log(
      nonItems,
      nonItems?.filter((item) => item.new).length,
      nonItems?.filter((item) => item.new)
    );
    // if (nonItems?.filter(((item) => !item.new)).length == 0) {
    //     colspan -= 1
    // }
  }
  if (totGstCess == 0) {
    colspan -= 1;
  }

  const cItem = (p) => {
    if (items && items.length > 0) {
      if (p === "discount") {
        let total = 0;
        for (let i = 0; i < items.length; i++) {
          total += parseFloat(items[i].dicount);
        }
        return total;
      } else if (p === "igst" || p === "cgst" || p === "sgst") {
        let total = 0;
        for (let i = 0; i < items.length; i++) {
          total +=
            (Number(items[i].taxableAMount) * Number(items[i].GSTRate)) / 100;
        }
        return total;
      } else if (p === "total") {
        let total = 0;
        for (let i = 0; i < items.length; i++) {
          total +=
            (Number(items[i].taxableAMount) * Number(items[i].GSTRate)) / 100 +
            items[i].taxableAMount +
            Number(items[i].GSTCess);
        }
        return total;
      } else if (p === "taxablevalue") {
        let total = 0;
        for (let i = 0; i < items.length; i++) {
          total += Number(items[i].taxableAMount);
        }
        return total;
      } else if (p === "gstcess") {
        let total = 0;
        for (let i = 0; i < items.length; i++) {
          total += Number(items[i].GSTCess);
        }
        return total;
      }
    } else {
      return 0;
    }
  };

  const cNon = (p) => {
    if (nonItems && nonItems.length > 0) {
      if (p === "discount") {
        let total = 0;
        for (let i = 0; i < nonItems.length; i++) {
          total += parseFloat(nonItems[i].dicount ?? 0);
        }
        return total;
      } else if (p === "igst" || p === "cgst" || p === "sgst") {
        let total = 0;
        for (let i = 0; i < nonItems.length; i++) {
          total +=
            (Number(nonItems[i].taxableAMount) * Number(nonItems[i].GSTRate)) /
            100;
        }
        return total;
      } else if (p === "total") {
        let total = 0;
        console.log(nonItems);
        for (let i = 0; i < nonItems.length; i++) {
          total +=
            (Number(nonItems[i].taxableAMount) * Number(nonItems[i].GSTRate)) /
              100 +
            nonItems[i].taxableAMount +
            Number(items[i].GSTCess);
        }
        console.log(total);
        return total;
      } else if (p === "taxablevalue") {
        let total = 0;
        for (let i = 0; i < nonItems.length; i++) {
          total += Number(nonItems[i].taxableAMount);
        }
        return total;
      } else if (p === "gstcess") {
        let total = 0;
        for (let i = 0; i < nonItems.length; i++) {
          total += Number(nonItems[i].GSTCess);
        }
        return total;
      }
    } else {
      return 0;
    }
  };
  const calculate = (p) => {
    if (items && items.length > 0) {
      let total = 0;
      total = cItem(p) + cNon(p);
      return total;
    }
  };
  const renderRow = () => {
    let row = "";
    let all = [];
    if (items?.length > 0) {
      all = items.map((elem) => {
        elem.type = "item";
        return elem;
      });
    }
    if (nonItems?.length > 0) {
      all = [
        ...all,
        ...nonItems.map((elem) => {
          elem.type = "nonitem";
          return elem;
        }),
      ];
    }
    console.log(all);
    all = all.filter((elem) => {
      if (elem.type == "nonitem" && elem?.ledgerAccount?.label) {
        return elem;
      } else if (elem.type == "item" && elem?.itemCode?.label) {
        return elem;
      }
    });

    if (all.length > 0) {
      all.forEach((item, index) => {
        console.log(item, units);
        let unit = units.find((e) => e.value == item.units) || "";
        if (item?.name?.label?.length && item.type == "item") {
          row += `
        <tr fc="startpatternhereto983y47" style="min-height: 100px">
            <td fc="countable" style="border-right:solid 1px gray">${index + 1}</td>
            <td fc="countable" style="border-right:solid 1px gray;max-width: 190px;word-break: break-word;overflow:hidden;text-align:left;font-weight:bold" colspan="4">${
              item.name?.label
            }</td>
        
          ${(items?.some(e => e?.HSN?.value)  || nonItems?.some(e => e?.HSN?.value))?`<td fc="countable" style="border-right:solid 1px gray;text-align:center">${item.HSN.value}</td>` : ``}
            <td fc="countable" class="right" style="border-right:solid 1px gray;text-align:right">${
              item.rate != 0 ? MoneyFormatv3(item.rate) : "0.00"
            }</td>
            <td fc="countable" style="border-right:solid 1px gray">${item.qty}</td>
            <td fc="countable" style="border-right:solid 1px gray">${unit?.UQC || ""}</td>
            <td fc="countable" class="right" style="border-right:solid 1px gray;text-align:right">${
              Number(item.amount) > 0
                ? MoneyFormatv3(Number(item.amount))
                : "0.00"
            }</td>

            ${
              calculate("discount") > 0
                ? `   <td fc="countable" class="right" style="border-right:solid 1px gray;text-align:right">${
                    item.dicount != 0 ? MoneyFormatv3(item.dicount) : "0.00"
                  }</td>`
                : ``
            }
              ${
               ( registrationType !== 1 && registrationType !== 3 ) 
                  ? `${data?.taxability?.value !== 3 ? `
                    <td fc="countable" class="right" style="border-right:solid 1px gray;text-align:right">${
                      item.amount != 0 
                        ? MoneyFormatv3(Number(item.taxableAMount))
                        : "0.00"
                    }</td> ` : ``}
            ${
              registrationType != 3 && ![3, 5].includes(data?.taxability?.value)
                ? `
                    <td fc="countable" style="border:none;padding:0px"   >
                    <table style="width:100%;table-layout:auto">
                    <tr>
                    <td style="text-align:center;width:30%;padding:0px;border-right:solid 1px gray"> 
                    ${item.GSTRate !== -1 ? `${item.GSTRate}` : `NIL`}
                    </td>
                    <td class="right" style="width:70%;text-align:right;border-right:solid 1px gray;text-align:right"> 
                    ${
                      item.GSTRate !== -1 ? `${MoneyFormatv3(
                      taxability === 7
                        ? 0
                        : (
                            (Number(item.taxableAMount) *
                              Number(item.GSTRate)) /
                            100
                          ).toFixed(2)
                    )}` : `0.00`
                    }
                    
                </td>
                </tr>
                </table>
                    </td>`
                : ``
            }
                ${
                  totGstCess > 0 && registrationType != 3 && ![3, 5].includes(data?.taxability?.value)
                    ? `<td fc="countable" class="right" style="border:none;border-right:solid 1px gray;text-align:right" >${
                        item.GSTCess != 0 ? MoneyFormatv3(item.GSTCess) : "0.00"
                      }</td>`
                    : ``
                }`
                  : ``
              }
              
                <td fc="countable" class="right "  style="border:none;text-align:right;font-weight:bold" >${MoneyFormatv3(
                  Number(item.netAmount).toFixed(2)
                )}</td>
        </tr fc="endpatternhereto983y47">`;
        } else if (item.type === "nonitem") 
          
          {
          row += `
                  <tr fc="startpatternhereto983y4790" style="min-height: 100px;vertical-align:top">
                      <td 1 fc="countable" style="border-right:solid 1px gray">${index + 1}</td>
                      <td 
                        fc="countable" 
                        style="text-align:left; border-right:1px solid gray; word-break:break-word; white-space:normal;font-weight:bold" 
                        colspan="4"
                        >
                        ${item.ledgerAccount.label}<br/> 
                        ${item.description.length ? `(${item.description})` : ``}
                      </td>
                      
                      ${(items?.some(e => e?.HSN?.value)  || nonItems?.some(e => e?.HSN?.value))?`<td fc="countable" style="border-right:solid 1px gray;text-align:center">${item.HSN.value}</td>` : ``}
                      <td fc="countable" style="border-right:solid 1px gray;text-align:right">${item.taxableAMount != 0 ? MoneyFormatv3(item.taxableAMount) : "0.00"}</td>
                      <td fc="countable" style="border-right:solid 1px gray"></td>
                      <td fc="countable" style="border-right:solid 1px gray"></td>
                      <td fc="countable" style="border-right:solid 1px gray;text-align:right">${item.taxableAMount != 0 ? MoneyFormatv3(item.taxableAMount) : "0.00"}</td>
            ${
              calculate("discount") > 0
                ? `   <td fc="countable" class="right" style="border:none;border-right:solid 1px gray;text-align:right">${
                    item.dicount != 0 ? MoneyFormatv3(item.dicount) : "0.00"
                  }</td>`
                : ``
            }

                       ${
                        ( registrationType !== 1 &&  registrationType !== 3)
                           ? `
                      ${
                        registrationType != 3
                          ? `${data?.taxability?.value !== 3 ?  `<td 5 fc="countable" class="right" style="border-right:solid 1px gray;text-align:right">${MoneyFormatv3(
                              item.taxableAMount,
                              "en-IN"
                            )}</td>` : ``}`
                          : '                      <td fc="countable"></td>                '
                      }
                      ${
                        registrationType != 3 && ![3, 5].includes(data?.taxability?.value)
                          ? `
                           <td fc="countable" style="border:none;padding:0px;height: 40px;width:120px">
                            <table style="width:100%; height: 100%;table-layout:auto">
                              <tr style="height: 100%;width:120px;vertical-align:top">
                                <td style="text-align:center;width:30%;padding:0px;border-right:1px solid gray;height:100%; background:#f9f9f9;"> 
                                  ${item.GSTRate !== -1 ? `${item.GSTRate}` : `NIL`}
                                </td>
                                <td class="right" style="width:70%; height:100%;text-align:right"> 
                                 ${
                                    item.GSTRate !== -1 ? `${MoneyFormatv3(
                                    (
                                      (Number(item.taxableAMount) * Number(item.GSTRate)) / 100
                                    ).toFixed(2)
                                  )}` : `0.00`


                                 }
                                  
                                </td>
                              </tr>
                            </table>
                          </td>`
                          : ""
                      }
                       ${
                        registrationType != 3 && ![3, 5].includes(data?.taxability?.value) && totGstCess > 0
                           ? `<td 9 fc="countable" class="right" style="border-right:solid 1px gray;text-align:right;border-left:solid 1px gray">${
                               Number(item?.GSTCess).toFixed(2) != 0
                                 ? MoneyFormatv3(
                                     Number(item?.GSTCess).toFixed(2),
                                     "en-IN"
                                   )
                                 : "0.00"
                             }</td> `
                           : ``
                       }`
                           : ``
                       }
              <td 10 fc="countable" class="right" style="border-left:solid 1px gray;text-align:right;font-weight:bold">${MoneyFormatv3(
                Number(item?.netAmount).toFixed(2),
                "en-IN"
              )}</td>
                  </tr fc="endpatternhereto983y4790">`;
        }
      });
    }
    return row;
  };
  const renderRowParticulars = () => {
    let row = "";

    let arr = itemEntry ? items : nonItems;
    console.log(items, nonItems, arr);
    if (arr && arr?.length > 0 && itemEntry) {
      arr.forEach((item, index) => {
        row += `
          <tr style="min-height: 100px">
              <td>Taxable</td>
              <td>${MoneyFormatv3(item.amount)}</td>
           <td style="display:none;">${MoneyFormatv3(item.dicount)}</td>
              <td>${item.GSTRate}</td>
              ${
                data.placeOfSupply.value === companyState
                  ? `
              <td>${
                data.placeOfSupply.value === companyState
                  ? MoneyFormatv3(
                      (
                        (Number(item.taxableAMount) * Number(item.GSTRate)) /
                        200
                      ).toFixed(2)
                    )
                  : "0.00"
              }
                  </td>
                  <td>${
                    data.placeOfSupply.value === companyState
                      ? MoneyFormatv3(
                          (
                            (Number(item.taxableAMount) *
                              Number(item.GSTRate)) /
                            200
                          ).toFixed(2)
                        )
                      : "0.00"
                  }</td>
              `
                  : `<td>${
                      data.placeOfSupply.value !== companyState
                        ? MoneyFormatv3(
                            (
                              (Number(item.taxableAMount) *
                                Number(item.GSTRate)) /
                              100
                            ).toFixed(2)
                          )
                        : "0.00"
                    }</td>`
              }
              
                  ${
                    totGstCess != 0
                      ? ` <td  >${MoneyFormatv3(item.GSTCess)}</td>`
                      : ``
                  }
                  <td>${MoneyFormatv3(Number(item.netAmount).toFixed(2))}</td>
          </tr>`;
      });
      console.log(row);
      return row;
    } else if (arr && arr?.length > 0 && !itemEntry) {
      arr.forEach((item, index) => {
        row += `
          <tr style="min-height: 100px">
              <td>Taxable</td>
              <td>${MoneyFormatv3(item.taxAMount)}</td>
              <td style="display:none;">${MoneyFormatv3(item.dicount)}</td>
              <td>${item.GSTRate}</td>
              ${
                data.placeOfSupply.value === companyState
                  ? `
              <td>${
                data.placeOfSupply.value === companyState
                  ? MoneyFormatv3(
                      (
                        (Number(item.taxAMount) * Number(item.GSTRate)) /
                        200
                      ).toFixed(2)
                    )
                  : "0.00"
              }
                  </td>
                  <td>${
                    data.placeOfSupply.value === companyState
                      ? MoneyFormatv3(
                          (
                            (Number(item.taxAMount) * Number(item.GSTRate)) /
                            200
                          ).toFixed(2)
                        )
                      : "0.00"
                  }</td>
              `
                  : `<td>${
                      data.placeOfSupply.value !== companyState
                        ? MoneyFormatv3(
                            (
                              (Number(item.taxAMount) * Number(item.GSTRate)) /
                              100
                            ).toFixed(2)
                          )
                        : "0.00"
                    }</td>`
              }
              
                  ${
                    totGstCess != 0
                      ? ` <td  >${MoneyFormatv3(item.GSTCess)}</td>`
                      : ``
                  }
                  <td>${MoneyFormatv3(Number(item.netAmount).toFixed(2))}</td>
          </tr>`;
      });
      console.log(row);
      return row;
    } else {
      return "";
    }
  };

  function bugFix() {
    const safeString = (value, sub = "") =>
      typeof value === "string" && value ? value + sub : "";

    return `
      <span style="font-size: 12px; max-width: 50%;">
        ${safeString(companyDetails?.line1, ", ").replace(/[**]+/g, " ")}
      </span>   
      <span style="font-size: 12px;">
        ${safeString(companyDetails?.city, ", ")}
        ${safeString(companyDetails?.district, ", ").replace("District", "")}
        ${safeString(companyDetails?.statename, ", ").replace("District", "")}
        ${safeString(companyDetails?.countrycode, ", ").replace("State", "")}
      </span>
      <span style="font-size: 12px;">
        ${safeString(companyDetails?.pincode).split("**").join("\n")}
      </span>
    `;
  }

  return `
  <html>
  <head>
   <meta name="viewport" />
   <style rel="stylesheet">

@media print {
  @page {
    margin: 0;
  }

  .header,
  .footer {
    display: none;
  }
}
.moneyAlign{
    text-align:right
   }
   .firsttable thead td{
    font-size: 12px;
  }
   .firsttable tbody td {
   font-size: 10px;
   border:none;
   padding:1px 5px;
 }
   .thirdDiv thead td {
    font-size: 9px;
    padding:0px;
  }
  
  .thirdDiv tbody td {
    font-size: 10px;
    border:none;
    padding:1px;
    
  }

  .thirdDiv tfoot td {
    font-size: 10px;
    text-align:right;
  }
.firstDiv{
  font-size:12px;
}
table, th, td {

  border-collapse: collapse;
}
.fourthTable thead td {
  font-size: 12px;
}
.fourthTable tbody td {
  font-size: 10px;
  border:none;
}
.hsnTable tbody td {
  font-size: 10px;
  border:none;
}
.firsttable td {
  width: 50%;
}
   </style>
  </head>
  <body>
  <div style="padding-left:25px">
   ${fromType === "debitNote"? `<strong>Debit Note</strong>` :fromType === "creditNote" ? `<strong>Credit Note</strong> `:` <strong>Purchase</strong>`}
  </div>
  <div style="min-height: 285px; margin-left: auto; margin-right: auto; width:95%;
  margin-left: auto; margin-right: auto; padding-top: 0px;border:solid 1px black;">
  <div style="width: 100%; float: center;">
  <div style="display: flex; flex-direction:column; padding:0px 0px">
  <div style="display:flex; flex-direction:row-reverse; justify-content:space-between;padding:0px 10px;border-bottom:solid 1px black">
  <div style=" flex:0 0 25%; display:flex; align-items: center; justify-content: center;" >
  ${
    companyDetails?.relatedcompanydetailsnew?.[0].companylogourl ==
      `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/` ||
    companyDetails?.relatedcompanydetailsnew?.[0].companylogourl == ""
      ? `
  
  `
      : `
  <img src="${companyDetails?.relatedcompanydetailsnew?.[0].companylogourl}"
  alt="CompanyLogo" width="80px" height="80px">
  `
  }
   </div >

  <div style="flex:0 0 25%;display:flex;flex-direction:column;gap:5px;font-size:12px;font-weight:bold;border-right:solid 1px gray;align-items:flex-start;padding:0px 10px;box-sizing: border-box">
    <div>Inv.No : ${data.seriesVouchers?.label}</div>
    <div>Inv.Date : ${data.invoiceDate === ""? formatDate(new Date()): formatDate(data.invoiceDate)}</div>
    <!---<div>${ data.creditPeriod !== "0" ? `Credit Period : ${data.creditPeriod}` : ` `}</div>--->
    <div>${ data.dueDate != "Invalid date" ? `Due Date : ${formatDate(data.dueDate)}`: ``}</div>
       ${
              data?.orderNumber?.length 
                ? 
                `<table style="width: 100%; border-collapse: collapse;">
                    <tr style="vertical-align: top;">
                      <td style="white-space: nowrap; width:30%;font-size:12px;text-align: left;">
                        Supp.Inv.No:
                      </td>
                      <td style="
                        width:70%;
                        text-align: left;
                        word-break: break-word;
                        white-space: normal;
                        font-size:12px
                      ">
                      ${data.orderNumber}
                      </td>
                    </tr>
                  </table>
                 <!----- <span>C Order Number :</span> <span> ${data.orderNumber} </span> -----> 
                  `
                : ``
            }
         ${
              data?.customerOrderDate?.length ? 
                `<span>Supp.Inv.Dt : ${formatDate(data.customerOrderDate)} </span> `
                : ``
            }







    ${data?.taxability?.label ? `<div style="font-size:12px;font-weight:bold">Taxability :${data?.taxability?.label}</div>` : ``}
    <div>Reverse Charge : ${ data.reverseChargeFlag == 1 ? "Yes" : "No"}</div>
  </div>



  <div style="word-break:break-word;flex:0 0 50%;border-right:solid 1px gray" >
  <span style="font-size: 15px; padding-bottom: 5px;
   font-weight:bold;">
   ${companyDetails?.companyname}
  </span><br/>
  
 ${bugFix()}
    ${
      registrationType !== 1
        ? `
  <br/>
  ${
    companyDetails?.relatedcompanyentity?.[0].gstin
      ? `
  <span style="font-size: 12px;
  ">
  <strong>GSTIN : </strong> ${companyDetails?.relatedcompanyentity?.[0].gstin}
  </span>`
      : ""
  }`
        : ``
    }
    <span style="font-size:12px;margin-left:10px">PAN: ${companyDetails.relatedcompanydetailsnew[0].pannumber} </span><br/>
    <span style="font-size:12px">MAIL: ${companyDetails.relatedemailcontacts[0].emailaddress} </span> <span style="font-size:12px;margin-left:10px">MOB: ${companyDetails.relatedphonecontacts[0].phonenumber}</span>
  </div>
  </div>

  </div>
  </div>



  <div class="firstDiv" ">
      <table border="1" class="firsttable" cellpadding="5" cellspacing="0" width="100%"
      style="margin-left: auto; margin-right: auto; margin-top:auto;border-left:none;border-right:none;border-bottom:none">
  <thead style="; font-weight: bold;background:rgba(224, 155, 213, 0.77)">
      <tr style="">
      <td style="border-right:solid 1px rgba(224, 155, 213, 0.77)">${partyType === "CUSTOMER" ? `Customer Details` : `Supplier Details`}</td>
      <td style="border-left:solid 1px rgba(224, 155, 213, 0.77)"></td>
      </tr>
  </thead>
  <tbody>
    <tr><td style="height:5px;border:none" colspan="*" rowspan="*" ></td></tr>
    <tr>
      <td style="">${partyType === "CUSTOMER" ? `Customer Name :` : `Supplier Name :`} ${data?.partyName?.legalName || ""}</td>
      <td style="">${partyType === "CUSTOMER" ? `Customer Address :` : `Supplier Address :`} ${
              data?.partyName?.label != ""
                ? `
                <span>
                  ${
                    suppierAddressDetals.supplierAddress !== ""
                      ? suppierAddressDetals.billingAddress?.replace(/[**,]+/g, ",") || ""
                      : data.supplierAddress?.replace(/[**,]+/g, ",") || ""
                  }
                </span>
                ${
                  suppierAddressDetals.stateCD !== "" || stateName !== ""
                    ? `
                  <span
            
                  >
                    ${
                      suppierAddressDetals.stateCD?.label
                        ? suppierAddressDetals.stateCD.label + ", "
                        : stateName.label
                        ? stateName.label + ", "
                        : ""
                    }
                    ${countryName.label || ""}${suppierAddressDetals.pincode ? `-${suppierAddressDetals.pincode}` : ``}
                  </span>`
                    : `
                  <span
            
                  >
                    ${countryName.label || ""}${suppierAddressDetals.pincode ? `-${suppierAddressDetals.pincode}` : ``}
            
                  </span>`
                }
            `
                : ``
      }</td>  
    </tr>
    <tr>
    <!------
      <td style="white-space:nowrap">Voucher Date : ${
        data.invoiceDate === ""
          ? moment(new Date()).format("DD-MM-YYYY")
          : moment(data.invoiceDate).format("DD-MM-YYYY")
      }</td>
      ----->
      ${data.originalInvoiceNumber?.label ? `<td style="white-space:nowrap">${partyType === "CUSTOMER" ? `Sales Inv.No :` : `Purchase Inv.No :`}  ${data.originalInvoiceNumber?.label}</td>` : ``}
      ${data.gstin ? `<td>Supplier GSTIN : ${data.gstin} </td>` : ``}

      <!----<td style="">Reverse Charge (Y/N) : ${
        data.reverseChargeFlag == 1 ? "Yes" : "No"
      }</td>--->
    </tr>
    <!-----
    <tr>
      <td style="">Contact Person :</td>
       <td style="">${partyType === "CUSTOMER" ? `Customer Invoice No : ${data.orderNumber}` :`Supplier Invoice No : ${data.orderNumber}` }</td>
    </tr> --->
    <tr>
      ${data.partyInvNo ? `<td style="white-space:nowrap">${partyType === "CUSTOMER" ? `Customer Order.No :` : `Supp.Inv.No :`}  ${data.partyInvNo}</td>` : ``}
    </tr>
    <tr>
     <!---- <td style="">Supplier GSTIN : ${data.gstin}</td> --->
      <td style="">Place of Supply : ${data?.placeOfSupply?.label} </td>
    </tr>

  <!---
  <tr><td style="height:5px;border:none" colspan="*" rowspan="*" ></td></tr>
   <tr style="min-height: 100px">
   <td style="font-weight: bold;">Voucher No : <span style="white-space:nowrap">${
     data.voucherNumber
   }</span></td>
   <td style="">Supplier Name : ${data?.partyName?.legalName || ""}</td>
   </tr>
  <tr style="min-height: 100px">
  <td style="white-space:nowrap">Voucher Date : ${
    data.invoiceDate === ""
      ? moment(new Date()).format("DD-MM-YYYY")
      : moment(data.invoiceDate).format("DD-MM-YYYY")
  }</td>
  <td style="">Supplier Address : ${
    data?.partyName?.label != ""
      ? `
      <span>
        ${
          suppierAddressDetals.supplierAddress !== ""
            ? suppierAddressDetals.billingAddress?.replace(/[**,]+/g, ",") || ""
            : data.supplierAddress?.replace(/[**,]+/g, ",") || ""
        }
      </span>
      ${
        suppierAddressDetals.stateCD !== "" || stateName !== ""
          ? `
        <span
  
        >
          ${
            suppierAddressDetals.stateCD?.label
              ? suppierAddressDetals.stateCD.label + ", "
              : stateName.label
              ? stateName.label + ", "
              : ""
          }
          ${countryName.label || ""}
        </span>`
          : `
        <span
  
        >
          ${countryName.label || ""}
  
        </span>`
      }
  `
      : ``
  }</td>
  </tr>
  ${
    data.reverseChargeFlag == 1
      ? `
  <tr style="min-height: 100px">
  <td style="">Reverse Charge (Y/N) : ${
    data.reverseChargeFlag == 1 ? "Yes" : "No"
  }</td>
    <td></td>
  </tr>`
      : ``
  }
  <tr style="min-height: 100px">
  <td style="">${
    data.creditPeriod !== "0" ? `Credit Period : ${data.creditPeriod}` : ` `
  }</td>
  <td style="">Contact Person :</td>
  </tr>
  <tr style="min-height: 100px">
  <td style=""></td>
  <td style="">Supplier Invoice No : ${data.orderNumber}</td>
  </tr>
  <tr style="min-height: 100px">
  <td  style="">${
    data.dueDate != "Invalid date"
      ? `Due Date : ${moment(data.dueDate).format("DD-MM-YYYY")}`
      : ``
  }</td>
  <td style="">Supplier GSTIN : ${data.gstin}</td>
  </tr>
  ${
    registrationType !== 3
      ? `  <tr style="min-height: 100px">
  <td></td>
<td style="">Place of Supply : ${data?.placeOfSupply?.label} </td>
  </tr>`
      : ``
  }
  <tr><td style="height:5px;border:none" colspan="*" rowspan="*" ></td></tr>
-->
  </tbody>
  </table>
  </div>
  <div style="margin-top:10px"class="thirdDiv" >

<table border="1" t="1" cellpadding="5" cellspacing="0" width="100%"
            style="margin-left: auto; margin-right: auto; text-align: center;">
        <thead style="background:rgba(224, 155, 213, 0.77); font-weight: bold;">
            <tr>
                <td style="width:30px">Sl .No</td>
                <td colspan="4" style="min-width:80px;max-width:240px;text-overflow:ellipsis">Item Name</td>
                ${(items?.some(e => e?.HSN?.value)  || nonItems?.some(e => e?.HSN?.value))? `<td>HSN</td>`: ``}
                <td>Rate</td>
                <td>Qty</td>
                <td>Unit</td>
                <td>Amount</td>
                ${calculate("discount") > 0 ? `<td>Discount</td>` : ``}
                 ${
                   registrationType !== 1 &&  registrationType != 3
                     ? `${data?.taxability?.value !== 3 ? `<td style="width:90px;">Taxable Amount</td>` : ``}
        ${
          registrationType != 3 && ![3, 5].includes(data?.taxability?.value)
            ? `
          <td style="padding:0px;height: 45px;width:120px;vertical-align: unset;">
          <div style="height:100%;">
          <table  style="width:100%;height:100%;">
          <tr>
          <td colspan="2" style="text-align:center">
            ${
              companyDetails.statecode == data.placeOfSupply.value
                ? `C&SGST`
                : `IGST`
            }
          </td>
          </tr>
          <tr style="border-top:1px solid;border-color: inherit">
              <td style="text-align:center;width:30%;border-right: 1px solid;border-color: inherit">&nbsp;%&nbsp;</td>
              <td style="text-align:center;width:70%">Amount</td>
            </tr>
          </table>
          </div>
        </td>
        ${totGstCess != 0 ? `<td style="width:60px">GST Cess</td>` : ``}
        `
            : ""
        }

<!---

         <td  style="padding:0px;height: 45px;width:100px; vertical-align: unset;">
            <div style="height:100%;">
            <table  style="width:100%;height:100%;table-layout:auto">
            <tr>
            <td colspan="2" style="text-align:center;vertical-align: middle;font-weight:bold;border-left:none;border-right:none;border-top:none;text-align:center">GST</td>
            </tr>
            <tr style="border-top:1px solid;border-color: inherit">
              <td style="text-align:center;width:20%;border-right: 1px solid;border-color: inherit;vertical-align: middle;font-weight:bold;border: none">&nbsp;%&nbsp;</td>
              <td style="text-align:center;width:80%;vertical-align: middle;font-weight:bold;border-top:none;border-right:none;border-bottom:none;">Amount</td>
            </tr>
          </table>
          </div>
          </td>
-->
      
                 `
                     : ``
                 }
                <td style="text-align:center;width:80px">Net Amount</td>
            </tr>
           
        </thead>
        <tbody>
  <!--<tr><td style="height:5px;border:none" colspan="*" rowspan="*" ></td></tr>-->

            ${renderRow()}
        
     </tbody >
     
 
  </table > 
    
    
<table width="100%"  class="item-table" border style="margin-top:auto" >
  <tfoot style="font-weight: bold;" countablefooter>
            <tr fc="start3u434459">
                <td fc="tstp" colspan="${colspan} fc="tstpend" style="text-align: right;" countfooter><div style="display:flex;justify-content:space-between;height:100%">
                     ${ data.reverseChargeFlag == 1 ? ` <div style="width:fit-content;white-space:nowrap;"><strong>Note: Amount of GST subject to Reverse Charge</strong></div>` : ``} 
                     <span style="text-align:right;padding:0px 5px;width:100%">TOTAL</span>
                  </div>
                </td>
                 ${
                   registrationType !== 1
                     ? `${
                         registrationType != 3
                           ? `${
                               data?.taxability?.value !== 3
                                 ? `<td class="right" style="width:88px" countfooter>${MoneyFormatv3(
                                     totTaxableAmount.toFixed(2),
                                     "en-IN"
                                   )}</td>`
                                 : ""
                             }`
                           : ""
                       }
                ${
                  registrationType != 3 && ![3, 5].includes(data?.taxability?.value)
                    ? `
                  <td colspan="1" class="right" style="padding:0px;height: 30px;width:120px;
                " countfooter>
              ${MoneyFormatv3(Number(totGST).toFixed(2), "en-IN")}
                </td>
                `
                    : ``
                }           
                ${
                  totGstCess != 0 && registrationType != 3 && ![3, 5].includes(data?.taxability?.value)
                    ? `<td class="right" style="width:58px" countfooter>${MoneyFormatv3(
                        totGstCess.toFixed(2),
                        "en-IN"
                      )}</td>`
                    : ``
                }`
                     : ``
                 }

                 <td colspan="1" class="right" style="width:78px" countfooter>${MoneyFormatv3(
                   nonItemwiseTableAmount.toFixed(2),
                   "en-IN"
                 )}</td>
            </tr>
        </tfoot countablefooterend >
</table>
    </div>

    
    <div style="display:flex;">
        <div style="border-right:solid 1px black;width:50%;">
          <div style="border-bottom:solid 1px black;font-size:12px;padding:5px;background:rgba(224, 155, 213, 0.77)">
            <p><strong>  Total Invoice  amount in words </strong></p>
          </div>
          <div style="font-size:12px;padding:5px">
            ${getWords(
              Number(totNetAmount.toFixed(2)),
              data?.currency?.code
            )}Only
          </div>
        </div>

        <div style="font-size:12px;width:50%;padding:5px 0px">
        <!------
          <div style="display:flex;justify-content:space-between;padding:5px">
            <span>Tax</span>
            <span>${currencySymbol}&nbsp;${
            Number(totGST) + Number(totGstCess) > 0
            ? MoneyFormatv3((Number(totGST) + Number(totGstCess)).toFixed(2), "en-IN")
            : "0.00"
            }</span>
          </div>
        ---->


         ${Number(data.tdsAmount) > 0 ? `
            <div style="display:flex;justify-content:space-between;padding:0px 5px">
                <span>TDS Amount</span>
                <span>${currencySymbol}&nbsp;(-${MoneyFormatv3(
                  Number(data.tdsAmount).toFixed(2),
                  "en-IN"
                )})</span>
            </div>` : `` }

           ${Number(data.tcsAmount) > 0 ? `
            <div style="display:flex;justify-content:space-between;padding:0px 5px">
                <span>TCS Amount</span>
                <span>${currencySymbol}&nbsp;${MoneyFormatv3(
                  Number(data.tcsAmount).toFixed(2),
                  "en-IN"
                )}</span>
            </div>` : `` }

          <div style="display:flex;justify-content:space-between;padding:0px 5px">
              ${
              Number(data.adjustments) != 0
                ? `<div style="display: flex; flex-direction:row; justify-content: space-between; font-size: 12px;width:100%">
                         ${Number(data.adjustments) != 0
                               ? `<span>Additional Discount</span>
                                  <span>${currencySymbol}&nbsp;${Number(data.adjustments) != 0? `(-&nbsp;${MoneyFormatv3(Number(data.adjustments).toFixed(2))})`: "0.00"}</span>`: ``}
                  </div>`
              : ""
              }
          </div>

          ${Number(data.roundOff)  ? `
            <div style="display:flex;justify-content:space-between;padding:0px 5px">
                <span>Roundoff</span>
                ${data.roundOff >= 0 ? `
                  <span>${currencySymbol}&nbsp;${MoneyFormatv3(
                  Number(data.roundOff).toFixed(2),
                  "en-IN"
                )}</span>`   : 
                
                ` <span>${currencySymbol}&nbsp;(${MoneyFormatv3(
                  Number(data.roundOff).toFixed(2),
                  "en-IN"
                )})</span>`}      
            </div>` : `` }

          <div style="display:flex;justify-content:space-between;padding:0px 5px">
            <span>Net Payable</span
            <span style="font-weight:bold">${currencySymbol}&nbsp;${MoneyFormatv3(
            Number(totNetAmount.toFixed(2)),
            "en-IN"
            )}</span>
          </div>
        </div>
    </div>



    <!-----commented-->

    <div style="display: grid;grid-template-columns: 3fr 2fr ;margin-left: auto; margin-right: auto; width:100%;
    margin-top: 15px; padding-bottom: 10px;
   box-sizing:border-box;display:none
   ">
       <div >
           <div style="font-size: 12px; margin-top: 10px; margin-bottom: 25px;max-width: 100%;">
            <div style="border-bottom:solid 1px black"><strong>  Total Invoice  amount in words </strong></div>
            <div>
               ${getWords(
                 Number(totNetAmount.toFixed(2)),
                 data?.currency?.code
               )}
           </div>
           <div style=" margin-top: 10px; margin-bottom: 25px; width:70%">
           <table class="fourthTable" style="display:none" border="1" cellpadding="5" width="100%"
                  style="text-align: center; margin-left: 10px">
               <thead>
               <tr>
               <td colspan="8" style="font-weight: bold;" >GST RATE WISE SUMMARY
               </td>
               </tr>
                   <tr style="font-weight: bold;">
                       <td>Particulars</td>
                       <td>Amount</td>
                       <td>Rate (%)</td>
                       ${
                         data?.placeOfSupply?.value === companyState
                           ? `   <td>CGST</td>
                       <td>SGST</td>
                       `
                           : `
                       <td>IGST</td>`
                       }
                       ${totGstCess != 0 ? ` <td>GST Cess</td>` : ""}
                       <td>TOTAL</td>

                   </tr>
               </thead>
               <tbody>
               ${renderRowParticulars()}
                   <tr style="display:none;" >
                       <td>Taxable</td>
                       <td>${MoneyFormatv3(
                         totTaxableAmount.toFixed(2),
                         "en-IN"
                       )}</td>
                       <td>${Number(totGstRate).toFixed(2)}</td>
                       ${
                         data.placeOfSupply.value === companyState
                           ? ` 
                       <td>${
                         data.placeOfSupply.value === companyState
                           ? MoneyFormatv3(
                               (Number(totGST) / 2).toFixed(2),
                               "en-IN"
                             )
                           : "0.00"
                       }</td>
                      <td>${
                        data.placeOfSupply.value === companyState
                          ? MoneyFormatv3(
                              (Number(totGST) / 2).toFixed(2),
                              "en-IN"
                            )
                          : "0.00"
                      }</td>`
                           : `<td>${
                               data.placeOfSupply.value !== companyState
                                 ? MoneyFormatv3(
                                     Number(totGST).toFixed(2),
                                     "en-IN"
                                   )
                                 : "0.00"
                             }</td>`
                       }
                   </tr>
                   
               </tbody>
               <tfoot>
               <tr style="font-weight:600;" >
                   <td>Total</td>
                   <td>${MoneyFormatv3(
                     totTaxableAmount.toFixed(2),
                     "en-IN"
                   )}</td>
                   <td></td>
                   ${
                     data.placeOfSupply.value === companyState
                       ? ` <td>${
                           data.placeOfSupply.value === companyState
                             ? MoneyFormatv3(
                                 (Number(totGST) / 2).toFixed(2),
                                 "en-IN"
                               )
                             : "0.00"
                         }</td>
                   <td>${
                     data.placeOfSupply.value === companyState
                       ? MoneyFormatv3((Number(totGST) / 2).toFixed(2), "en-IN")
                       : "0.00"
                   }</td>`
                       : `<td>${
                           data.placeOfSupply.value !== companyState
                             ? MoneyFormatv3(Number(totGST).toFixed(2), "en-IN")
                             : "0.00"
                         }</td>`
                   }
                  ${
                    totGstCess != 0
                      ? `<td>${MoneyFormatv3(
                          Number(totGstCess).toFixed(2),
                          "en-IN"
                        )}</td>`
                      : ""
                  }
                   <td>${MoneyFormatv3(
                     (
                       Number(totNetAmount.toFixed(2)) -
                       Number(data.tdsAmount) +
                       Number(data.adjustments)
                     ).toFixed(2),
                     "en-IN"
                   )}</td>
               </tr>
               </tfoot>
           </table>
           </div>    
       </div>


       <div >
           <div style="display: flex; flex-direction:column; line-height: 1; ">
               <div style="display: none; flex-direction:row; justify-content: space-between;
                           font-size: 12px; padding-left: 15px;  margin-top: 5px;">
                   <span>Taxable Amount</span>
                   <span>${currencySymbol}&nbsp;${
    Number(totTaxableAmount) > 0
      ? MoneyFormatv3(totTaxableAmount.toFixed(2), "en-IN")
      : "0.00"
  }</span>
               </div>
               <div style="display: flex; flex-direction:row; justify-content: space-between;
                           font-size: 12px; padding-left: 15px;  margin-top: 5px;">
                   <span>Tax</span>
                   <span>${currencySymbol}&nbsp;${
    Number(totGST) + Number(totGstCess) > 0
      ? MoneyFormatv3((Number(totGST) + Number(totGstCess)).toFixed(2), "en-IN")
      : "0.00"
  }</span>
               </div>
               ${
                 Number(data.tdsAmount) > 0
                   ? `
      <div style="display: flex;
       flex-direction:row;
      justify-content: space-between;
                           font-size: 12px;
                            padding-left: 15px;
                              margin-top: 5px;">
        <span>TDS Amount, If Applicable</span>
        <span>${currencySymbol}&nbsp;${
                       Number(data.tdsAmount) > 0
                         ? MoneyFormatv3(
                             Number(data.tdsAmount).toFixed(2),
                             "en-IN"
                           )
                         : "0.00"
                     }</span>
      </div> `
                   : ""
               }
      ${
        Number(data.tcsAmount) > 0
          ? `
      <div style="display: flex;
       flex-direction:row;
      justify-content: space-between;
                           font-size: 12px;
                            padding-left: 15px;
                              margin-top: 5px;">
        <span>TCS Amount, If Applicable</span>
        <span>${currencySymbol}&nbsp;${
              Number(data?.tcsAmount) > 0
                ? MoneyFormatv3(Number(data?.tcsAmount).toFixed(2), "en-IN")
                : "0.00"
            }</span>
      </div> `
          : ""
      }

             ${
               Number(data.adjustments) != 0
                 ? `<div style="display: flex; flex-direction:row; justify-content: space-between;
                           font-size: 12px; padding-left: 15px; margin-top: 5px;">
                           ${
                             Number(data.adjustments) != 0
                               ? `<span>Adjustment</span>
      <span>${currencySymbol}&nbsp;${
                                   Number(data.adjustments) != 0
                                     ? Number(data.adjustments).toFixed(2)
                                     : "0.00"
                                 }</span>`
                               : ``
                           }
    </div>`
                 : ""
             }

            ${
              Number(data.roundOff) != 0
                ? `<div style="display: flex; flex-direction:row; justify-content: space-between;
            font-size: 12px; padding-left: 15px; margin-top: 5px;">
            ${
              Number(data.roundOff) != 0
                ? `<span>Discount/Roundoff</span>
<span>${currencySymbol}&nbsp;${
                    Number(data.roundOff) != 0
                      ? Number(data.roundOff).toFixed(2)
                      : "0.00"
                  }</span>`
                : ``
            }
</div>`
                : ""
            }


               <div style="display: none; flex-direction:row; justify-content: space-between;
                           font-size: 12px; padding-left: 15px;  margin-top: 5px;">
                   <span>Discount</span>
                   <span>${currencySymbol}&nbsp;${
    Number(totAmount) - Number(totTaxableAmount) > 0
      ? MoneyFormatv3(
          (Number(totAmount) - Number(totTaxableAmount)).toFixed(2),
          "en-IN"
        )
      : "0.00"
  }</span>
               </div>
                          <!--
                          <div style = "display: flex; flex-direction:row; justify-content: space-between;
                          font-size: 12px; padding - left: 15px; padding - right: 15px; margin - top: 5px; ">
                          <span > CGST</span >
                          <span>${currencySymbol}&nbsp;${
                          data.placeOfSupply.value === companyState
                          ? MoneyFormatv3((Number(totGST) / 2).toFixed(2), "en-IN")
                          : "0.00"
                          }</span>
                          </div >
                          <div style="display: flex; flex-direction:row; justify-content: space-between;
                          font-size: 12px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
                          <span>SGST</span>
                          <span>${currencySymbol}&nbsp;${
                          data.placeOfSupply.value === companyState
                          ? MoneyFormatv3((Number(totGST) / 2).toFixed(2), "en-IN")
                          : "0.00"
                          }</span>
                          </div>
                          <div style="display: flex; flex-direction:row; justify-content: space-between;
                          font-size: 12px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
                          <span>IGST</span>
                          <span>${currencySymbol}&nbsp;${
                          data.placeOfSupply.value !== companyState
                          ? MoneyFormatv3(Number(totGST).toFixed(2), "en-IN")
                          : "0.00"
                          }</span>
                          </div>-->

      <div style="display: flex; flex-direction:row; justify-content: space-between;font-size: 15px; padding-left: 15px;  margin-top: 4px;">
        <strong>Net Payable</strong>  
        <strong>${currencySymbol}&nbsp;${MoneyFormatv3(
          Number(totNetAmount.toFixed(2)),
          "en-IN"
          )}</strong>
      </div>
      </div >
       </div >
   </div >

<!----commented--->
    <div style="margin-left: auto; margin-right: auto; width:100%; box-sizing: border-box;
      border: double; border-width: 1px; border-color: black; margin-top: 15px;display:none;">
      <div >
        <div style="font-size: 14px; margin-top: 10px; margin-bottom: 5px; padding-left: 10px; font-weight:bold">
          Bank Details
        </div>
        <div>
          <div style="display: flex; flex-direction:column; line-height: 1.8;">
            <div style="display: flex; flex-direction:row; justify-content: space-between;
               font-size: 12px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
              <span style="font-weight:bold;">Account Name : ${
                bankDetails?.BankAccountName == undefined
                  ? ""
                  : bankDetails?.BankAccountName
              }</span>
              <span style="font-weight:bold;"></span>
            </div>
            <div style="display: flex; flex-direction:row; justify-content: space-between;
               font-size: 12px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
              <span style="font-weight:bold;">Account Number : ${
                bankDetails?.BankAccountNumber == undefined
                  ? ""
                  : bankDetails?.BankAccountNumber
              }</span>
              <span style="font-weight:bold;"></span>
            </div>
            <div style="display: flex; flex-direction:row; justify-content: space-between;
               font-size: 12px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
              <span style="font-weight:bold;">Bank : ${
                bankDetails?.BankName == undefined ? "" : bankDetails?.BankName
              }</span>
              <span style="font-weight:bold;"></span>
            </div>
            <div style="display: flex; flex-direction:row; justify-content: space-between;
               font-size: 12px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
              <span style="font-weight:bold;">IFSC Code : ${
                bankDetails?.IFSCCode == undefined ? "" : bankDetails?.IFSCCode
              }</span>
              <span style="font-weight:bold;">
              </span>
            </div>
          </div>
        </div>

      </div>
    </div> 
    <div style="font-size:10px">
    <div >

    Payment Type : ${data.paymentType}
    ${
      data.paymentType == "Credit"
        ? `
    
    <div>
    
    Credit Period : ${data.creditPeriod}<br/>
    Due Date : ${moment(data.dueDate).format("DD-MM-YYYY")}
    
    </div>
    
    `
        : ``
    }
    </div>

    ${
      data?.paymentType == "Bank"
        ? `
    <div> Paid Amount : ${data.receivedAmount}  </div>
    <div> Bank Reference No : ${data.bankReferenceNo}  </div>
    <div> Bank : ${data?.receivedAccount?.label ?? ""}  </div>
    
    </div>
    `
        : ``
    }
    ${
      data?.paymentType == "Cash"
        ? `
    <div>
    Paid Amount : ${data?.receivedAmount}
    </div>
    `
        : ``
    }
    </div>
    
${
  data?.remarks?.length
    ? `
<div style="font-size: 14px; ">
  <div  style="background-color: #DADBDD; font-weight:bold;padding:5px; box-sizing: border-box;">Description</div>

              <p style="padding-left: 5px;"> ${data.remarks}</p>
          </div>

          `
    : ``
}
   <div style="width:100%; margin-top:12px;display:none"><span style="font-size: 14px;
   text-align: center; font-weight:bold;">
    Journal Entry
   </span>
                          </div>
   <div style="margin-left: auto; margin-right: auto; display:none;
               border: 1px solid black;  margin-top: 15px;padding:5px;">
               <table cellpadding="2" cellspacing= "0" width="100%" 
               style="margin-left: auto; margin-right: auto; margin-top: 10px;">
               <thead>
               </thead>
               <tbody style="font-size:12px;">
               <tr style="font-weight: bold;">
               <td width="60%">Particulars</td>
               <td width="20%" align="right">Debit(₹)</td>
               <td width="20%" align="right">Credit(₹)</td>
             </tr>
               ${renderJournel()}
                 
               </tbody>
             </table>
   </div>
   </div>
   </div>
   ${
  [
    data.ewayBillNo,
    data.vehicleNumber,
    data.transportMode,
    data.dateOfDispatch
  ].filter(Boolean).length > 0 
    ? `
      <div style="margin-left:23px;margin-top:10px">
        <div style="font-size:13px;font-weight:bold;">Dispatch Details</div>
        <div style="display:flex;gap:10px;font-size:11px">
          ${data.dateOfDispatch ? `<span>Date of dispatch: ${formatDate(data.dateOfDispatch)}</span>` : ""}
          ${data.transportMode ? `<span>Mode of transportation: ${data.transportMode}</span>` : ""}
          ${data.vehicleNumber ? `<span>Vehicle Number: ${data.vehicleNumber}</span>` : ""}
          ${data.ewayBillNo ? `<span>E-way Bill Number: ${data.ewayBillNo}</span>` : ""}
        </div>
      </div>
    `
    : ''
}
    
  </body >
  </html >
    `;
};

const ParseTable = (longString, nonItems) => {
  const startPattern = nonItems
    ? 'fc="startpatternhereto983y4790"'
    : 'fc="startpatternhereto983y47"';
  const endPattern = nonItems
    ? 'fc="endpatternhereto983y4790"'
    : 'fc="endpatternhereto983y47"';
  function extractSubstring(longString, startPattern, endPattern) {
    const startIndex = longString.indexOf(startPattern);
    if (startIndex === -1) return ""; // start pattern not found

    const endIndex = longString.indexOf(
      endPattern,
      startIndex + startPattern.length
    );
    if (endIndex === -1) return ""; // end pattern not found after start pattern

    return longString.substring(startIndex, endIndex + endPattern.length);
  }
  function findColspanValue(inputString) {
    var colspanPattern = /colspan="(\d+)"/;
    var match = inputString.match(colspanPattern);
    if (match) {
      return parseInt(match[1]);
    } else {
      return 1;
    }
  }
  function countFcCountable(substring) {
    let count = 0;

    // Regular expression to match <td fc="countable" ...> and capture the colspan value if present
    const regex =
      /<td[^>]*fc="countable"[^>]*?(?:colspan="(\d+)")?[^>]*?(?=(?:\/>|>))/gi;
    let match;

    while ((match = regex.exec(substring)) !== null) {
      console.log(match[0]);
      const colspan = parseInt(findColspanValue(match[0]), 10);
      count += colspan;
    }

    // Check for the last fc="countable" that may not have a proper closing tag
    // const lastPattern = /<td[^>]*fc="countable"[^>]*fc="endpatternhereto983y47"[^>]*$/gi;
    // if (lastPattern.test(substring)) {
    //     count += 1;
    //     console.log(" 1", lastPattern.test(substring))
    // }

    return count;
  }

  // Example usage:

  function insertColspan(longString, count) {
    const startPattern = 'fc="tstp"';
    const endPattern = 'fc="tstpend"';

    const startIndex = longString.indexOf(startPattern);
    if (startIndex === -1) return longString; // start pattern not found

    const endIndex = longString.indexOf(
      endPattern,
      startIndex + startPattern.length
    );
    if (endIndex === -1) return longString; // end pattern not found after start pattern

    // Construct the new string with the colspan value inserted
    const before = longString.substring(0, startIndex + startPattern.length);
    const after = longString.substring(endIndex);
    const middle = ` colspan="${count}" `;

    return before + middle + after;
  }

  const substring = extractSubstring(longString, startPattern, endPattern);
  const footString = extractSubstring(
    longString,
    "countablefooter",
    "countablefooterend"
  );
  console.log(footString);
  console.log(substring);

  let count = countFcCountable(substring);
  let countFooter = (footString.match(/countfooter/g) || []).length;
  console.log(countFooter, count);
  countFooter -= 1;
  count = count - countFooter;
  // const countFooter = countFooter()
  console.log('Count of fc="countable":', count);
  let result = insertColspan(longString, count);
  // console.log(result);
  return result;
};
export const SalesTaxablePrint = async ({
  items,
  nonItems,
  InvoiceSettings,
  companyDetails,
  data,
  partyDetails,
  itemEntry,
  registrationType,
  totGST,
  totGstCess,
  totNetAmount,
  totTaxableAmount,
  totAmount,
  tabelTotAmount,
  nonItemwiseTableAmount,
  bankDetails,
  units,
  billingAddressDetails,
  deliveryAddressDetails,
  stateName,
  countryName,
  stateOfSupply,
  companyState,
  totDiscount,
  eInvoiceDetails,
  vehicleNumber,
  transportMode,
  dateOfDispatch,
  ewayBillNo,
}) => {
  // payment transaction arr // setinvarr//setpayarr
  console.log({
    items,
    nonItems,
    InvoiceSettings,
    companyDetails,
    data,
    partyDetails,
    itemEntry,
    registrationType,
    totGST,
    totGstCess,
    totNetAmount,
    totTaxableAmount,
    totAmount,
    tabelTotAmount,
    nonItemwiseTableAmount,
    bankDetails,
    units,
    billingAddressDetails,
    deliveryAddressDetails,
    stateName,
    countryName,
    stateOfSupply,
    companyState,
    totDiscount,
  },"**********sales details");
  // console.log({ items, nonItems });

  console.log(items,"!!!!itemss")

  let RegisterationType =
    companyDetails?.relatedcompanydetailsnew?.[0]?.registrationtype;

  InvoiceSettings = JSON.parse(JSON.stringify(InvoiceSettings));
  console.log("here", { RegisterationType });
  console.log("Invoice settings", InvoiceSettings);

  let qrupi = isValidUPI(InvoiceSettings?.upi_id)
    ? await QRCode.toDataURL(`upi://pay?pa=${InvoiceSettings?.upi_id}`, {
        margin: 0,
      })
    : "";

  let qrupi1 = isValidUPI(eInvoiceDetails?.ein_upi)
    ? await QRCode.toDataURL(`upi://pay?pa=${eInvoiceDetails?.ein_upi}`, {
        margin: 0,
      })
    : "";
  let currencySymbol = billingCurrencyOptions.find(
    (elem) => data?.currency?.value == elem.value
  )?.sign;
  currencySymbol = currencySymbol || "";
  console.log(currencySymbol);
  let isNonItemExist = nonItems?.length ? true : false;
  let isItemExist = items?.length ? true : false;
  let colspan = 10;
  if (data.placeOfSupply.value !== companyState) {
    colspan -= 1;
  }
  if (!InvoiceSettings?.hsnsaCode) {
    colspan -= 2;
  }
  if (RegisterationType != 3 && InvoiceSettings?.hsnsaCode) {
    // colspan -= 1
  } else {
    // colspan -= 1
  }
  console.log(
    RegisterationType,
    InvoiceSettings,
    data.placeOfSupply,
    companyState,
    totGstCess
  );

  const renderRows = () => {
    // hsn table row
    let temps = [...items, ...nonItems];
    // temps = temps.filter((elem) => elem.new != true);
    const groupedData = temps.reduce((acc, item) => {
      const key = `${item.GSTRate}-${JSON.stringify(item.HSN)}`;

      if (!acc[key]) {
        acc[key] = [];
      }

      acc[key].push(item);

      return acc;
    }, {});



    const resultArray = Object.values(groupedData);
    let final = [];
    resultArray.forEach((itemx) => {
      let temp = {
        CGST: 0,
        CGST: 0,
        IGST: 0,
        taxableAMount: 0,
        netAmount: 0,
        GSTCess: 0,
      };
      itemx.forEach((element) => {
        temp.CGST += element.CGST;
        temp.CGST += element.CGST;
        temp.IGST += element.IGST;
        temp.taxableAMount += element.taxableAMount;
        temp.netAmount += element.netAmount;
        temp.GSTCess += Number(element.GSTCess);
      });
      final = [...final, { ...temp ,...itemx[0]}];
    });
    let row = "";
    if (final && final.length > 0) {
      final.forEach((item, index) => {
        if (item?.HSN?.label) {
          row += `
                <tr style="min-height: 100px">
                  <!-- <td style="text-align: center;;border-right:solid 1px gray">${index + 1}</td> -->
                  <td style="text-align:left;border-right:solid 1px gray;text-align:center;white-space:nowrap;">${item?.HSN?.value}</td>
                  ${RegisterationType != 3
              ? `<td style="text-align: center;;border-right:solid 1px gray">${item.GSTRate !== -1 ? `${item.GSTRate}` : `NIL`}</td>`
              : ""
            }
                  <td class="right" style=";border-right:solid 1px gray">${item.taxableAMount != 0
              ? MoneyFormatv3(item.taxableAMount, "en-IN")
              : "0.00"
            }</td>
                ${RegisterationType != 3
              ? data.placeOfSupply.value === companyState
                ? `
                  <td class="right" style=";border-right:solid 1px gray">${data.placeOfSupply.value === companyState
                  ?  
                  `
                    ${item.GSTRate !== -1 ? `${ MoneyFormatv3(
                    (
                      (Number(item.taxableAMount) *
                        Number(item.GSTRate)) /
                      200
                    ).toFixed(2)
                  )}` : `0.00`}
                  `
                  : "0.00"
                }</td>
                  <td class="right" style=";border-right:solid 1px gray">${data.placeOfSupply.value === companyState
                  ?
                 ` ${item.GSTRate !== -1 ? `${ MoneyFormatv3(
                    (
                      (Number(item.taxableAMount) *
                        Number(item.GSTRate)) /
                      200
                    ).toFixed(2)
                  )}` : `0.00`}`
                
                  : "0.00"
                }</td>`
                : `
                      <td class="right" style=";border-right:solid 1px gray">${data.placeOfSupply.value !== companyState
                  ? 
                   `${item.GSTRate !== -1 ? `${ MoneyFormatv3(
                    (
                      (Number(item.taxableAMount) *
                        Number(item.GSTRate)) /
                      100
                    ).toFixed(2)
                  )}` : `0.00`}`
                  : "0.00"
                }</td>`
              : ""
            }
                ${totGstCess != 0 && RegisterationType != 3
              ? `<td class="right" style=";border-right:solid 1px gray">${item.GSTCess != 0 ? MoneyFormatv3(item.GSTCess) : "0.00"
              }</td>`
              : ``
            }
                  <td class="right" style=";border-right:solid 1px gray">${Number(item.netAmount) != 0
              ? MoneyFormatv3(Number(item.netAmount).toFixed(2))
              : "0.00"
            }</td>
              </tr>`;
        }
      });
      return row;
    } else {
      return row;
    }
  };

  const renderRow = () => {
    let row = "";
    let all = [];
    if (items?.length > 0) {
      all = items.map((elem) => {
        elem.type = "item";
        return elem;
      });
    }
    if (nonItems?.length > 0) {
      all = [
        ...all,
        ...nonItems.map((elem) => {
          elem.type = "nonitem";
          return elem;
        }),
      ];
    }
    console.log(all);
    all = all.filter((elem) => {
      if (elem.type == "nonitem" && elem?.ledgerAccount?.label) {
        return elem;
      } else if (elem.type == "item" && elem?.itemCode?.label) {
        return elem;
      }
    });

    if (all.length > 0) {
      all.forEach((item, index) => {
        console.log(item, units);
        let unit = units.find((e) => e.value == item.units) || ''
        if (item?.name?.label?.length && item.type == "item") {
          row += `
        <tr fc="startpatternhereto983y47" style="min-height: 100px">
            <td fc="countable" style="border:none;border-right:solid 1px black;text-align:center">${index + 1}</td>
            <td fc="countable" style="border:none;max-width: 190px;word-break: break-word;overflow:hidden;text-align:left;border-right:solid 1px black" colspan="4"><strong>${item.name?.label
            }</strong></td>
           ${InvoiceSettings?.hsnsacode
              ? `<td fc="countable" style="border:none;max-width: 140px;word-break: break-word;overflow:hidden;border-right:solid 1px black;text-align:center;white-space:nowrap" >${item?.HSN?.value ? item?.HSN?.value : ""
              }</td>`
              : ``
            }
            ${
              items.some((item) =>item.itemType) ? `
                   <td fc="countable" class="right" style="border:none;border-right:solid 1px black">${item.rate != 0 ? MoneyFormatv3(item.rate) : "0.00"
            }</td>
            <td fc="countable" style="border:none;border-right:solid 1px black;text-align:center">${item.qty}</td>
            <td fc="countable" style="border:none;border-right:solid 1px black">${unit?.UQC || '' || ''}</td>
            ${(calculate("discount") > 0) ? `
              <td fc="countable" class="right" style="border:none;border-right:solid 1px black">${Number(item.amount) > 0
              ? MoneyFormatv3(Number(item.amount))
              : "0.00"
            }</td>`  : ``}
              ` : ``
            }
            ${calculate("discount") > 0
              ? `   <td fc="countable" class="right" style="border:none;border-right:solid 1px black">${item.dicount != 0 ? MoneyFormatv3(item.dicount) : "0.00"
              }</td>`
              : ``
            }
            ${RegisterationType != 1
              ? `
                ${RegisterationType != 3 ? `
            <td fc="countable" taxablemount class="right" style="border:none;border-right:solid 1px black">${item.taxableAMount != 0
                  ? MoneyFormatv3(Number(item.taxableAMount))
                  : "0.00"
                }</td>` : ''}

            ${registrationType != 3 && ![2,3, 5].includes(data?.taxability?.value)
                ? `
                    <td fc="countable" style="border:none;padding:0px"   >
                    <table style="width:100%;table-layout:auto">
                    <tr>
                    <td style="text-align:center;width:20%;padding:0px;border-right:solid 1px black"> 
                    ${item.GSTRate !== -1 ? `${item.GSTRate}` : `NIL`}
                    </td>
                    <td class="right" style="width:80%;border-right:solid 1px black"> 
                      ${
                        item.GSTRate !== -1 ? `
                        ${MoneyFormatv3(
                        ((Number(item.taxableAMount) * Number(item.GSTRate)) /100).toFixed(2))} 
                        ` : `0.00`
                      }
                  
                    
                </td>
                </tr>
                </table>
                    </td>`
                : ``
              }
                ${totGstCess > 0 && (registrationType != 3 && ![2,3, 5].includes(data?.taxability?.value))
                ? `<td fc="countable" class="right" style="border:none;border-right:solid 1px black" >${item.GSTCess != 0 ? MoneyFormatv3(item.GSTCess) : "0.00"
                }</td>`
                : ``
              }`
              : ``
            }
                <td fc="countable" class="right "  style="border:none" ><strong>${MoneyFormatv3(
              Number(item.netAmount).toFixed(2)
            )}</strong></td>
        </tr fc="endpatternhereto983y47">`;
        } else if (item.type === "nonitem") {
          row += `
                  <tr fc="startpatternhereto983y4790" style="min-height: 100px">
                      <td 1 fc="countable" style="text-align:center;border-right:1px solid black">${index + 1}</td>
                      <td 2 fc="countable" style="text-align:left;border-right:1px solid black;word-break: break-word;
  white-space: normal;" c colspan="4"><strong>${item.ledgerAccount.label
            }</strong><br/> ${item.description.length ? `(${item.description})` : ``
            }</td>
                      ${InvoiceSettings?.hsnsacode
              ? `<td 3 fc="countable" style="text-align:center;border-right:1px solid black;white-space:nowrap">${item?.HSN?.value ?? ""
              }</td>`
              : ""
            }

            ${
             items.some((item) =>item.itemType)? `
               <td fc="countable" style="border-right:1px solid black;text-align:right">${item?.taxableAMount  ? MoneyFormatv3(Number(item?.taxableAMount).toFixed(2)) : "0.00"}</td>
                      <td fc="countable" style="border-right:1px solid black"></td>
                      <td fc="countable" style="border-right:1px solid black"></td>
                      ${ (calculate("discount") > 0) ? `<td fc="countable" style="border-right:1px solid black;text-align:right">${item?.taxableAMount  ? MoneyFormatv3(Number(item?.taxableAMount).toFixed(2)) : "0.00"}</td>` : `` }
              ` : ``
            }
                     

            ${calculate("discount") > 0
              ? `   <td fc="countable" class="right" style="border:none;border-right:1px solid black">${item.dicount != 0 ? MoneyFormatv3(item.dicount) : "0.00"
              }</td>`
              : ``
            }

                     ${RegisterationType != 1
              ? `
                      ${RegisterationType != 3
                ? `<td 5 fc="countable" class="right" style="border-right:solid 1px black">${MoneyFormatv3(
                  item.taxableAMount,
                  "en-IN"
                )}</td>`
                : ' '
              }
                ${registrationType != 3 && ![3, 5].includes(data?.taxability?.value)
                        ? `
                          <td fc="countable" style="border:none;padding:0px;height: 40px;">
                            <table style="width:100%; height: 100%;table-layout:auto">
                              <tr style="height: 100%;">
                                <td style="text-align:center;width:20%;padding:0px;border-right:1px solid black;height:100%; background:#f9f9f9;"> 
                                  ${item.GSTRate !== -1 ? `${item.GSTRate}` : `NIL`}
                                </td>
                                <td class="right" style="width:80%; height:100%;"> 
                                ${
                                  item.GSTRate !== -1 ? `
                                  ${MoneyFormatv3(
                                    (
                                      (Number(item.taxableAMount) * Number(item.GSTRate)) / 100
                                    ).toFixed(2)
                                  )}
                                  `  : `0.00`
                                }
                                </td>
                              </tr>
                            </table>
                          </td>`
                        : ""
                      }
                       ${(registrationType != 3 && ![3, 5].includes(data?.taxability?.value)) && totGstCess > 0
                ? `<td 9 fc="countable" class="right" style="border-left:1px solid black">${Number(item?.GSTCess).toFixed(2) != 0
                  ? MoneyFormatv3(
                    Number(item?.GSTCess).toFixed(2),
                    "en-IN"
                  )
                  : "0.00"
                }</td> `
                : ``
              }`
              : ``
            }
              <td 10 fc="countable" class="right" style="width:250px;border-left:1px solid black"><strong>${MoneyFormatv3(
              Number(item?.netAmount).toFixed(2),
              "en-IN"
            )}</strong></td>
                  </tr fc="endpatternhereto983y4790">`;
        }
      });
    }
    return row;
  };

  const cItem = (p) => {
    if (items && items.length > 0) {
      if (p === "discount") {
        let total = 0;
        for (let i = 0; i < items.length; i++) {
          total += parseFloat(items[i].dicount);
        }
        return total;
      } else if (p === "igst" || p === "cgst" || p === "sgst") {
        let total = 0;
        for (let i = 0; i < items.length; i++) {
          if(p === "igst") {
            if(items[i].GSTRate !== -1){
            total +=
              (Number(items[i].taxableAMount) * Number(items[i].GSTRate)) /
              100;
            }
          }else{
              if(items[i].GSTRate !== -1){
            total +=
              (Number(items[i].taxableAMount) * Number(items[i].GSTRate)) /
              100;
            }
          }
        }
        return total;
      } else if (p === "total") {
        let total = 0;
        for (let i = 0; i < items.length; i++) {
          total +=
            (Number(items[i].taxableAMount) * Number(items[i].GSTRate)) / 100 +
            items[i].taxableAMount +
            Number(items[i].GSTCess);
        }
        return total;
      } else if (p === "taxablevalue") {
        let total = 0;
        for (let i = 0; i < items.length; i++) {
          total += Number(items[i].taxableAMount);
        }
        return total;
      } else if (p === "gstcess") {
        let total = 0;
        for (let i = 0; i < items.length; i++) {
          total += Number(items[i].GSTCess);
        }
        return total;
      }
    } else {
      return 0;
    }
  };
  const cNon = (p) => {
    if (nonItems && nonItems.length > 0) {
      if (p === "discount") {
        let total = 0;
        for (let i = 0; i < nonItems.length; i++) {
          total += parseFloat(nonItems[i].dicount ?? 0);
        }
        return total;
      } else if (p === "igst" || p === "cgst" || p === "sgst") {
        let total = 0;
        for (let i = 0; i < nonItems.length; i++) {
          if(p === "igst") {
            if(nonItems[i].GSTRate !== -1){
            total +=
              (Number(nonItems[i].taxableAMount) * Number(nonItems[i].GSTRate)) /
              100;
            }
          }else{
           if(nonItems[i].GSTRate !== -1){
            total +=
              (Number(nonItems[i].taxableAMount) * Number(nonItems[i].GSTRate)) /
              100;
            }
          }
          
        }
        return total;
      } else if (p === "total") {
        let total = 0;
        console.log(nonItems);
        for (let i = 0; i < nonItems.length; i++) {
          total +=
            (Number(nonItems[i].taxableAMount) * Number(nonItems[i].GSTRate)) /
              100 +
            nonItems[i].taxableAMount +
            Number(items[i].GSTCess);
        }
        console.log(total);
        return total;
      } else if (p === "taxablevalue") {
        let total = 0;
        for (let i = 0; i < nonItems.length; i++) {
          total += Number(nonItems[i].taxableAMount);
        }
        return total;
      } else if (p === "gstcess") {
        let total = 0;
        for (let i = 0; i < nonItems.length; i++) {
          total += Number(nonItems[i].GSTCess);
        }
        return total;
      }
    } else {
      return 0;
    }
  };
  const calculate = (p) => {
    if (items && items.length > 0) {
      let total = 0;
      total = cItem(p) + cNon(p);
      return total;
    }
  };
  let height = 360;
  height = height - 12 * (items?.length ?? 0 + nonItems?.length ?? 0);
  height = height > 0 ? height : 10;
  let showShippingAddress = InvoiceSettings?.customershippingaddress;

  const hasBankDetails = [
  InvoiceSettings?.ac_name,
  InvoiceSettings?.ac_no,
  InvoiceSettings?.bank_name,
  InvoiceSettings?.branch,
  InvoiceSettings?.ifsc,
  InvoiceSettings?.swift_code
].some(Boolean);


function covertCaseing(value) {
  if (!value) return ""; // handles "", null, undefined
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}

  let temp = `
    <html>
    <head>
    <meta name="viewport" />
    <style rel="stylesheet">

@media print {
  @page {
    margin: 0;
  }

  .header,
  .footer {
    display: none;
  }
}
    table{
    table-layout:fixed;
    }
  .body984u094, 
.body984u094 * {
    box-sizing: border-box !important;
}
    .right{
      text-align:right !important;
    }
    .trbody{
      font-size: 10px;
     }
     .trhead{
       font-size: 12px;
     }
       thead td{
       font-size: 12px;
     }

     tfoot td{
     font-size:12px;
     }
       tbody td {
      font-size: 10px;
     }
   .firsttable thead td{
    font-size: 12px;
  }
   .firsttable tbody td {
   font-size: 10px;
  }
   .thirdDiv thead td {
    font-size: 9px;
    padding:0px;
  }

  .thirdDiv tbody td {
    font-size: 10px;
  }

  .thirdDiv tfoot td {
    font-size: 14px;
  }
  .firstDiv{
  font-size:12px;
  }
  table, th, td {

  border-collapse: collapse;
  }
  .fourthTable thead td {
  font-size: 12px;
  }
  .fourthTable tbody td {
  font-size: 10px;
  }
  .prefirstTable tbody td {
    border:none;
  }

  .item-table tbody td{
  padding:2px;
  vertical-align: baseline;
  font-size:10px;
  border:none;
  padding-right:2px;
  }
  .item-table thead td{
    padding:1px;
    font-size:10px;
    
    border-bottom:1px solid black;
border-left:1px solid black;
  }
  .item-table tfoot td{
    padding:1px;
    font-size:11px;
  }
  .prefirstTable tbody td{
    padding:1px 5px;

    }
    .hsn-table tbody td{
    padding:1px;
    border:none;
    }
      .print-nobreak {
        page-break-inside: avoid;
        page-break-before: auto;
        page-break-after: auto;
    }
      @media print { .kbody {
            margin: 10px;
            padding: 0;
            font-family: Arial, sans-serif;
            width: 100%;
            height:100%;
            position:absolute;
            top:0px;
            left:0px;
            bottom:0px;
            margin-top: 0px !important;
            padding:10px;
        }
    }

     .container-main {
    width: 100%;
    font-family: Arial, sans-serif;
    font-size: 10px;
    box-sizing: border-box;
  }

  .container-main .container-header,
  .container-main .container-body {
    display: flex;
    width: 100%;
  }


.container-main .container-body > div {
  flex: 1;
  padding: 10px;
  box-sizing: border-box;


  border: 1px solid gray; /* ✅ solid black border on right */

  /*border-left: none;*/
}


.container-main .container-header > div {
  flex: 1;
  padding: 10px;
  box-sizing: border-box;


  border: 1px solid gray; /* ✅ solid black border on right */
border-bottom: none;
  /*border-left: none;*/
}

  .container-main .container-header {
    background-color:rgba(224, 155, 213, 0.77);
    font-weight: bold;
    text-align: center;
  }

  .container-main ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .container-main ul li {
    padding: 4px 0;
    /*border-bottom: 1px dashed #ddd;*/
  }
.container-main ul li:empty {
    padding: 0;
  }

  .container-main ul li:last-child {
    border-bottom: none;
  }
    
    ${
      showShippingAddress !== 1
        ? `
       .shippingaddress{
    display: none;
  }
  `
        : ""
    }}
   </style>
  </head>
  <body class="body984u094" style="margin:0px;background:white;">
  <div class="kbody" style="background:white;width:95%;min-height:100vh;margin:auto;min-width:760px">
  <table style="height:100%">
  <thead>
  <tr>
  <th>
  
  
<div style="min-width:450px !important;">
    <div style=" display: flex;flex-direction:column; justify-content: flex-start; align-items: flex-start; padding: 0px 0px 10px 0px;">
      <span style="font-size: 18px; font-weight: bolder; ">
       ${
        (RegisterationType == 3 || RegisterationType == 1)
          ? InvoiceSettings.bosinvoiceheading
          : (((data.voucherNumber)?.includes("BOS") || [2,3,5].includes(data?.taxability?.value))
              ? InvoiceSettings.bosinvoiceheading
              : InvoiceSettings.invoiceheading)
      }
          </span>
          ${
            RegisterationType == 3
              ? `( We are under composition scheme. Not Eligible to collect Tax on supplies )`
              : ""
          }
    </div>
    <div style="  margin-right: auto;width:100%;
    margin-left: auto; margin-right: auto; padding-top: 0px;">
    <div style="width: 100%; float: center;">
    <div style="display: flex; flex-direction:column; padding: 0px 0px 0px 0px;border: solid 1px gray;">
    <div style="display:flex; flex-direction:row-reverse; justify-content:space-between;padding:0px 10px;">
    <div style="border-left:solid 1px gray; flex:0 0 25%; display:flex; align-items: center; justify-content: center;" >
    ${
      InvoiceSettings?.companylogo
        ? `
    ${
      companyDetails?.relatedcompanydetailsnew?.[0].companylogourl ==
        `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/` ||
      companyDetails?.relatedcompanydetailsnew?.[0].companylogourl == ""
        ? `
   
    `
        : `
    <img F1 src="${companyDetails?.relatedcompanydetailsnew?.[0].companylogourl}"
    alt="CompanyLogo" width="80px" height="80px">
    `
    }
        `
        : ``
    }
      </div >

      <div style="font-size:12px;border-left:solid 1px gray; flex:0 0 25%; " >          
           <div style="padding:5px;display:flex;flex-direction:column;gap:5px;align-items:flex-start; justify-content:flex-start;">
            <span style="font-weight:bold">${
             InvoiceSettings?.invoicenumber
               ? `Inv.No : <span style="white-space:nowrap;">${data.seriesVouchers?.label}</span>`
               : ``
           }</span>
              <span style="white-space:nowrap;">${
                InvoiceSettings?.invoicedate
                  ? `Inv.Date : &nbsp;${
                      data.invoiceDate === ""
                        // ? moment(new Date()).format("DD-MM-YYYY")
                        // : moment(data.invoiceDate).format("DD-MM-YYYY")
                        ? formatDate(new Date())
                        : formatDate(data.invoiceDate)
                    }`
                  : ``
              }</span>
            <span>${
              data.dueDate && InvoiceSettings?.paymentduedate
                ? `Due Date : ${formatDate(data.dueDate)}`
                : ""
            }</span> 
          
            ${
              data?.creditPeriod !== "0" &&
              data?.creditPeriod &&
              InvoiceSettings?.creditperiod
                ? `<span>Credit Period : ${data.creditPeriod}</span>`
                : ``
            }
         ${
              data?.orderNumber?.length &&
              InvoiceSettings?.customerordernoanddate
                ? 
                `<table style="width: 100%; border-collapse: collapse;">
                    <tr style="vertical-align: top;">
                      <td style="white-space: nowrap; width:40%;font-size:12px;text-align: left;">
                        Cust. Order No:
                      </td>
                      <td style="
                        width:60%;
                        text-align: left;
                        word-break: break-word;
                        white-space: normal;
                        font-size:12px
                      ">
                      ${data.orderNumber}
                      </td>
                    </tr>
                  </table>
                 <!----- <span>Customer Order Number :</span> <span> ${data.orderNumber} </span> -----> 
                  `
                : ``
            }
         ${
              data?.customerOrderDate?.length &&
              InvoiceSettings?.customerordernoanddate
                ? 
                `<span>Cust.Order Dt : ${formatDate(data.customerOrderDate)} </span> `
                : ``
            }
            ${data?.taxability?.label ? `<span>Taxability : ${data?.taxability?.value === 3  ? `Non-Taxable` : `${data?.taxability?.label}`} </span>` : ``}
            ${
            data.reverseChargeFlag == 1 ? `<span>Reverse Charge : Yes </span> ` : `<span>Reverse Charge : No </span>`
          }
           </div>
      </div>


      <div style="word-break:break-word;text-align:left; flex:0 0 50%;" >
      ${
        InvoiceSettings?.companyname
          ? `<span style="font-size: 13px; padding-bottom: 5px;
     font-weight:bold;">
     ${companyDetails?.companyname}
    </span><br/>
    `
          : ""
      }
  
    <span style="font-size: 12px;max-width:50%;font-weight:normal ">
          ${
            companyDetails?.line1?.replace(/[**,]+/g, "")
              ? companyDetails?.line1?.replace(/[**,]+/g, " ") + ", "
              : ""
          }</span>   <span style="font-size: 12px;font-weight:normal">${
    companyDetails?.city ? companyDetails?.city + ", " : ""
  }${
    companyDetails?.district?.replace("District", "")
      ? companyDetails?.district?.replace("District", "") + ", "
      : ""
  }${
    companyDetails?.statename?.replace("District", "")
      ? companyDetails?.statename?.replace("District", "") + ", "
      : ""
  }${companyDetails?.countrycode?.replace("State", "")}</span>
          <span style="font-size: 12px;font-weight:normal
         ">${
           companyDetails?.pincode &&
           ", " + companyDetails?.pincode?.split("**").join("\n")
         }
    </span>
      ${
        RegisterationType !== 1
          ? `
  
   
    ${
      InvoiceSettings?.companygstin &&
      companyDetails?.relatedcompanyentity?.[0]?.gstin
        ? `  <br/> <span style="font-size: 12px;font-weight:normal">
    GSTIN : ${
      companyDetails?.relatedcompanyentity?.[0]?.gstin == undefined
        ? ""
        : companyDetails?.relatedcompanyentity?.[0]?.gstin
    }  </span> `
        : ``
    }
  `
          : ""
      }
     ${
       companyDetails?.relatedcompanydetailsnew?.[0]?.pannumber?.length &&
       InvoiceSettings?.companypan
         ? `<span style="font-size: 12px; margin-left:10px;font-weight:normal">PAN :${companyDetails?.relatedcompanydetailsnew?.[0]?.pannumber}</span>`
         : ``
     }


    ${
      companyDetails?.relatedcompanydetailsnew?.[0]?.cinregistrationnumber
        ?.length && InvoiceSettings?.companycin
        ? `<br/><span style="font-size: 12px;font-weight:normal">CIN : ${companyDetails?.relatedcompanydetailsnew?.[0]?.cinregistrationnumber}</span>`
        : ``
    }   
    ${
      companyDetails?.relatedcompanydetailsnew?.[0]?.websiteurl?.length &&
      InvoiceSettings?.companywebsite
        ? `<br/><span style="font-size: 12px;font-weight:normal">WEB : ${companyDetails?.relatedcompanydetailsnew?.[0]?.websiteurl}</span>`
        : ``
    }
    ${
      companyDetails?.relatedemailcontacts?.[0]?.emailaddress?.length &&
      InvoiceSettings?.companyemail
        ? `<br/><span style="font-size: 12px;font-weight:normal">MAIL : ${companyDetails?.relatedemailcontacts?.[0]?.emailaddress}</span>`
        : ``
    }
    ${
      companyDetails?.relatedphonecontacts?.[0]?.phonenumber?.length &&
      InvoiceSettings?.companycontactnumber
        ? `<span style="font-size: 12px;margin-left:10px;font-weight:normal">MOB : ${companyDetails?.relatedphonecontacts?.[0]?.phonenumber}</span>`
        : ``
    }
  
  
    </div>


    </div>
  
    </div>
    </div>
  </th>
  </tr>
  </thead>
  <tbody>
  <td> 
  <div style="display: flex;flex-direction: column;height: 100%;margin-Top:-3px" >
    <div>
      <div class="container-main" >
        <div class="container-header">
          <div style="">Billing Address</div>
           <div class="shippingaddress" style="border-left:none;margin-left:4px;">Shipping To Address</div>
        </div>
        <div class="container-body">
          <div II class="" style="border-bottom:none;border-top:none">
            
         <div style="display:flex;flex-direction:column;gap:2px">
           <div style="font-weight:bold;font-size:11px">
    ${
       data.partyName.value != ""
        ? data?.partyName?.label + "<br/>" || ""
        : ""
    }
           </div>
            <div>
             ${
               data.partyName.value != ""
                 ? `
    <span>
      ${
        billingAddressDetails?.billingAddress !== ""
          ? billingAddressDetails?.billingAddress?.replace(/[**,]+/g, ",") || ""
          : data?.billingAddress?.replace(/[**,]+/g, ",") || ""
      }
    </span>
    ${
      billingAddressDetails?.stateCD !== "" || stateName?.label !== ""
        ? `
     <span>
              ${[
                billingAddressDetails?.city?.label,
                covertCaseing(billingAddressDetails?.districtCD?.label),
                billingAddressDetails?.stateCD?.label,
                billingAddressDetails?.countryCD?.label,
              ]
                .filter(Boolean)
                .join(', ')}
                ${billingAddressDetails?.pincode ? `- ${billingAddressDetails.pincode}` : null}
            </span>
`
        : `
      <span>
        ${countryName?.label ?? (countryName?.label || "")}${billingAddressDetails.pincode ? `-${billingAddressDetails.pincode}` : ``}
      </span>`
    }
  `
                 : ``
             }
           </div>
        <div>
            ${
           ( RegisterationType !== 1) && (data.gstin )
              ? `<span>GSTIN,if any : ${data.gstin ? data.gstin : ""}</span>  <br/>`
              : ""
             
          }
          ${
            RegisterationType !== 3 && InvoiceSettings?.placeofsupply
              ? `Place of Supply : ${
                  (data?.placeOfSupply?.label || "")
                    ?.replace(/\s*\(.*?\)\s*/g, "")
                    ?.trim() || ""
                } `
              : ``
          }
       </div>
       <!---
        <div>
        ${InvoiceSettings?.customercontactperson ? `Contact Person` : ``}
        </div> -->
         </div>
          </div>
          <div III class="shippingaddress" style="border-bottom:none;border-left:none;margin-left:4px;border-top:none">
            
         <div  style="display:flex;flex-direction:column;gap:2px">

           <div style="font-weight:bold;font-size:11px">
              ${
                InvoiceSettings?.customerdisplayname
                  ? data?.consigneeName + "<br/>" || ""
                  : ""
              }
           </div>


            <div>
            ${
              data.partyName.value != ""
                ? `
            <span>
            ${
              deliveryAddressDetails?.deliveryAddress !== ""
                ? deliveryAddressDetails?.deliveryAddress?.replace(/[**,]+/g, ",") || ""
                : data.deliveryAddress?.replace(/[**,]+/g, ",") || ""
            }
            </span>
            <span>
              ${[
                deliveryAddressDetails?.city?.label,
               covertCaseing (deliveryAddressDetails?.districtCD?.label),
                deliveryAddressDetails?.stateCD?.label,
                deliveryAddressDetails?.countryCD?.label,  
              ]
                .filter(Boolean)
                .join(', ')
              }
              ${ [deliveryAddressDetails?.pincode ? `- ${deliveryAddressDetails.pincode}` : null].filter(Boolean)}
            </span>

             <!----- ${
                deliveryAddressDetails?.stateCD !== "" || stateName !== ""
                  ? `
                <span  >
                  ${
                    deliveryAddressDetails?.stateCD?.label
                      ? deliveryAddressDetails?.stateCD?.label + ","
                      : stateName?.label ?? stateName?.label + ","
                  }
                  ${countryName?.label ?? (countryName?.label || "")}
                </span>`
                  : `
                <span  >
                ${countryName?.label ?? (countryName?.label || "")}
                </span>`
              } ---->
              `
            : ``
            }
          </div>

            ${
             ( RegisterationType !== 1) && ( data.consigneeGST) ?
                 `<span>GSTIN : ${
                    data.consigneeGST ? data.consigneeGST : ""
                  }</span>`
                : ""
            }

          <div>
              ${
                data?.partyName?.value !== ""
                  ? deliveryAddressDetails?.states?.label !== ""
                    ? `<span>State Name: ${String(deliveryAddressDetails.stateCD?.label).toUpperCase()}</span>`
                  : ``
                : ``
              }
          </div>

         </div>
          </div>
        </div>
      </div>
      

    <table class="prefirstTable" border="1" cellpadding="5" cellspacing="0" width="100%"
    style="margin-left: auto; margin-right: auto; margin-top:auto;display:none; ">
  <thead style="background-color:rgba(224, 155, 213, 0.77); font-weight: bold;">
    <tr style="text-align: center;">
        <td>Invoice&nbsp;Details</td>
        <td>Billing Address</td>
       ${showShippingAddress == 1 ? `<td>Shipping Address</td>` : ""}
    </tr>
  </thead>
  <tbody>
  <tr><td style="height:5px;border:none" colspan="*" rowspan="*" ></td></tr>
  <tr style="min-height: 100px">
  <td style="font-weight: bold;">${
    InvoiceSettings?.invoicenumber
      ? `Invoice No : <span style="white-space:nowrap;">${data.voucherNumber}</span>`
      : ``
  }</td>
  <td style="">${
    InvoiceSettings?.customerdisplayname
      ? data?.partyName?.label + "<br/>" || ""
      : ""
  }${data?.partyName?.legalName || ""}</td>
   ${
     showShippingAddress == 1
       ? ` <td style=""> ${
           InvoiceSettings?.customerdisplayname
             ? data?.partyName?.label + "<br/>" || ""
             : ""
         }${data?.partyName?.legalName || ""}</td>`
       : ""
   }

  </tr>
  <tr style="min-height: 100px">
  <td style="white-space:nowrap;">${
    InvoiceSettings?.invoicedate
      ? `Invoice Date : &nbsp;${
          data.invoiceDate === ""
            ? moment(new Date()).format("DD-MM-YYYY")
            : moment(data.invoiceDate).format("DD-MM-YYYY")
        }`
      : ``
  }</td>
  <td style="">${
    data.partyName.value != ""
      ? `
    <span>
      ${
        billingAddressDetails?.billingAddress !== ""
          ? billingAddressDetails?.billingAddress?.replace(/[**,]+/g, ",") || ""
          : data?.billingAddress?.replace(/[**,]+/g, ",") || ""
      }
    </span>
    ${
      billingAddressDetails?.stateCD !== "" || stateName?.label !== ""
        ? `
      <span>${
        billingAddressDetails?.stateCD?.label
          ? billingAddressDetails?.stateCD?.label + ","
          : stateName?.label
          ? stateName?.label + ","
          : ""
      }
        ${countryName.label ?? (countryName?.label || "")}${billingAddressDetails.pincode ? `-${billingAddressDetails.pincode}` : ``}
      </span>`
        : `
      <span>
        ${countryName?.label ?? (countryName?.label || "")}${billingAddressDetails.pincode ? `-${billingAddressDetails.pincode}` : ``}
      </span>`
    }
  `
      : ``
  }</td>
  ${
    showShippingAddress == 1
      ? `  <td style=""> ${
          data.partyName.value != ""
            ? `
  <span>
  ${
    deliveryAddressDetails?.deliveryAddress !== ""
      ? deliveryAddressDetails?.deliveryAddress?.replace(/[**,]+/g, ",") || ""
      : data.deliveryAddress?.replace(/[**,]+/g, ",") || ""
  }
  </span>
  ${
    deliveryAddressDetails?.stateCD !== "" || stateName !== ""
      ? `
    <span  >
      ${
        deliveryAddressDetails?.stateCD?.label
          ? deliveryAddressDetails?.stateCD?.label + ","
          : stateName?.label ?? stateName?.label + ","
      }
       ${countryName?.label ?? (countryName?.label || "")}
    </span>`
      : `
    <span  >
    ${countryName?.label ?? (countryName?.label || "")}
    </span>`
  }
  `
            : ``
        } </td> `
      : ""
  }
  </tr>
  ${
    data.reverseChargeFlag == 1
      ? `
  <tr style="min-height: 100px">
  <td style="">Reverse Charge (Y/N) : ${
    data.reverseChargeFlag == 1 ? "Yes" : "No"
  }</td>
  <td></td>
    ${showShippingAddress == 1 ? `<td></td>` : ""}
  </tr>`
      : ""
  }
  <tr style="min-height: 100px">
  <td style="">${
    data?.creditPeriod !== "0" &&
    data?.creditPeriod &&
    InvoiceSettings?.creditperiod
      ? `Credit Period : ${data.creditPeriod}`
      : ` `
  }</td>
  <td style="">${
    InvoiceSettings?.customercontactperson ? `Contact Person` : `Person Name`
  }</td>
    ${showShippingAddress == 1 ? `<td></td>` : ""}
  </tr>
  <tr style="min-height: 100px">
    <td style="">${
      data?.orderNumber?.length && InvoiceSettings?.customerordernoanddate
        ? `Customer Order Number : ${data.orderNumber}`
        : ``
    }</td>
    <td></td>
     ${showShippingAddress == 1 ? ` <td></td>` : ``}
    </tr>
  <tr style="min-height: 100px">
  <td  style="">${
    data.dueDate && InvoiceSettings?.paymentduedate
      ? `Due Date : ${moment(data.dueDate).format("DD-MM-YYYY")}`
      : ""
  }</td>
  <td style=""> GSTIN : ${data.gstin ? data.gstin : ""}</td>
    ${
      showShippingAddress == 1
        ? `<td style="">GSTIN,if any : ${data.gstin ? data.gstin : ""}</td>`
        : ``
    }
  </tr>
  <tr style="min-height: 100px">
  <td></td>
  ${
    RegisterationType !== 3 && InvoiceSettings?.placeofsupply
      ? `<td style="">Place of Supply : ${
          (data?.placeOfSupply?.label || "")
            ?.replace(/\s*\(.*?\)\s*/g, "")
            ?.trim() || ""
        } </td>`
      : `<td></td>`
  }
    ${
      showShippingAddress == 1
        ? `<td style="">State Name : ${
            deliveryAddressDetails.stateCD !== ""
              ? String(
                  deliveryAddressDetails.stateCD?.label || ""
                ).toLocaleUpperCase() || ""
              : String(stateName?.label || "").toLocaleUpperCase() || ""
          }</td>`
        : ""
    }
  </tr>
  <tr>
  <td style="">${
    data?.customerOrderDate?.length && InvoiceSettings?.customerordernoanddate
      ? ` Date : ${moment(data.customerOrderDate).format("DD-MM-YYYY")}`
      : ``
  }</td>
  <td></td>
    ${showShippingAddress == 1 ? `<td></td>` : ""}
  </tr>
        <tr><td style="height:5px;border:none" colspan="*" rowspan="*" ></td></tr>

  </tbody>
  </table>
  </div>
 <div style="margin:0px 0px;flex-grow:1;display:flex;flex-direction:column;border:1px solid gray;border-top:none;border-bottom:none" >
<table class="item-table" style="border:none" cellpadding="5" cellspacing="0" width="100%"
        style="margin-left: auto; margin-right: auto; text-align: center;">
    <thead style="background-color: rgba(224, 155, 213, 0.77); font-weight: bold;border-top:1px solid gray">
        <tr style="">
            <td style="width:30px;border-left:none;text-align:center">Sl. No</td>
            <td colspan="4" style="min-width:60px;max-width:190px;text-overflow:ellipsis;text-align:center">Item Name</td>
            ${InvoiceSettings?.hsnsacode ? `<td style="width:50px;text-align:center" >HSN Code</td>` : ``}
            ${
              items.some((item) =>item.itemType) ? `<td style="width:90px;text-align:center">Rate</td>
            <td style="width:40px;text-align:center">Qty</td>
            <td style="width:25px;text-align:center">Unit</td>
           ${(calculate("discount") > 0) ? `<td style="width:90px;text-align:center">Amount</td>` : ``} ` : ``
            }
            
            ${calculate("discount") > 0
            ? `<td style="width:90px;text-align:center">Discount</td>`
            : ``
    }
    ${RegisterationType != 1
      ? `
        ${RegisterationType != 3 ? `
            <td  style="width:85px;text-align:center">Taxable Amount </td>
`: ''}
            ${registrationType != 3 && ![2,3, 5].includes(data?.taxability?.value)
        ? `
            <td  style="padding:0px;height: 45px;width:98px;
            vertical-align: unset;">
            <div style="height:100%;">
            <table  style="width:100%;height:100%;table-layout:auto">
            <tr>
            <td colspan="2" style="text-align:center;vertical-align: middle;font-weight:bold;border-left:none;border-right:none;border-top:none;text-align:center">           ${
              companyDetails.statecode == data.placeOfSupply.value
                ? `C&SGST`
                : `IGST`
            }</td>
            </tr>
            <tr style="border-top:1px solid;border-color: inherit">
              <td style="text-align:center;width:20%;border-right: 1px solid;border-color: inherit;vertical-align: middle;font-weight:bold;border: none">&nbsp;%&nbsp;</td>
              <td style="text-align:center;width:80%;vertical-align: middle;font-weight:bold;border-top:none;border-right:none;border-bottom:none;">Amount</td>
            </tr>
          </table>
          </div>
          </td>
  `
        : ``
      }
  ${totGstCess > 0 && (registrationType != 3 && ![2,3, 5].includes(data?.taxability?.value))
        ? ` <td style="width:80px;text-align:center">GST Cess</td>`
        : ``
      }`
      : ``
    }
            <td style="text-align:center;width:90px;text-align:center">Net Amount</td>
        </tr>
    </thead>
    <tbody>
         

       ${renderRow()}

    </tbody >
     
 
  </table > 
           
                

<table width="100%"  class="item-table" border  style="margin-top:auto;border-bottom:none;border-left:none;border-right:none" >
  <tfoot style="font-weight: bold;" countablefooter>
            <tr fc="start3u434459">
                <td fc="tstp" colspan="${colspan} fc="tstpend" style="text-align: left;border-right:solid 1px black" countfooter>
                  <div style="display:flex;justify-content:space-between;height:100%">
                     ${ data.reverseChargeFlag == 1 ? ` <div style="width:fit-content;white-space:nowrap;"><strong>Note: GST Payable by you under Reverse Charge</strong></div>` : ``} 
                     <span style="text-align:right;padding:0px 5px;width:100%">TOTAL</span>
                  </div>
                </td>
                
                ${RegisterationType != 1
      ? `
                ${RegisterationType != 3
        ? `<td class="right" style="width:85px;border-right:solid 1px black" countfooter>${MoneyFormatv3(
          totTaxableAmount.toFixed(2),
          "en-IN"
        )}</td>`
        : ""
      }
                ${registrationType != 3 && ![2,3, 5].includes(data?.taxability?.value)
        ? `
                  <td colspan="1" class="right" style="padding:0px;height: 30px;width:98px;border-right:solid 1px black
                " countfooter>
              ${MoneyFormatv3(Number(totGST).toFixed(2), "en-IN")}
                </td>
                `
        : ``
      }           
                ${totGstCess != 0 && (registrationType != 3 && ![2,3, 5].includes(data?.taxability?.value))
        ? `<td class="right" style="width:80px;border-right:solid 1px black" countfooter>${MoneyFormatv3(
          totGstCess.toFixed(2),
          "en-IN"
        )}</td>`
        : ``
      }`
      : ``
    }

                 <td colspan="1" class="right" style="width:89px" countfooter>${MoneyFormatv3(
      nonItemwiseTableAmount.toFixed(2),
      "en-IN"
    )}</td>
            </tr>
        </tfoot countablefooterend >
</table>
  </div>

    

<!-------
<table border cellpadding="5" cellspacing="0" width="100%" style="margin-left: auto; margin-right: auto;text-align: center;margin-top:0px">
  <thead>


  </thead>
  <tbody>
  <tr style="min-height: 100px;">
  <td colspan="3" style= "background-color:rgba(224, 155, 213, 0.77); font-weight: bold;text-align:left" class="trhead">Total Invoice amount in words </td>
  ${
    InvoiceSettings?.showroundoff && Number(data.roundOff) != 0
      ? `
  <td  style="font-weight: bold;border:none;text-align:left">Round Off</td>
  <td class="right" style="font-weight: bold;border:none;"> ${currencySymbol}&nbsp;${
          Number(data.roundOff) != 0
            ? MoneyFormatv3(Number(data.roundOff).toFixed(2), "en-IN")
            : "0.00"
        }</td>`
      : `<td style="font-weight: bold;border:none;border:none;"></td>
        <td style="font-weight: bold;border:none;border:none;"></td>`
  }
  </tr>
  <tr  >
  <td rowspan="4" colspan="3" style="text-align:left" class="trbody"> <strong>
  ${getWords(Number(totNetAmount), data?.currency?.code)}</strong></td>
     ${
       Number(data.adjustments)
         ? `<td style="font-weight: bold;border:none;border:none;text-align:left">Adjustment </td>
      <td class="right" style="border:none;border:none;">${currencySymbol}&nbsp;${MoneyFormatv3(
             data?.adjustments
           )}
          </td>`
         : ``
     }

  </tr>
  ${
    Number(data.tcsAmount)
      ? `<tr >
  <td style="font-weight: bold;border:none;border:none;text-align:left">TCS </td>
  <td class="right" style="border:none;border:none;">${currencySymbol}&nbsp;${MoneyFormatv3(
          data?.tcsAmount
        )}
      </td>
  </tr>`
      : ``
  }
  <tr >
  <td style="font-weight: bold;border:none;text-align:left">Net Amount </td>
  <td class="right" style="font-weight: bold;border:none;">${currencySymbol}&nbsp;${
    Number(totNetAmount) >= 0
      ? MoneyFormatv3(Number(totNetAmount), "en-IN")
      : "0.00"
  }</td>
  </tr>

  </tbody>
  </table>
------>
<div style="border:1px solid gray;display:flex;">
  <div style="width:50%;border-right:solid 1px gray">
    <div style="height:25px;background-color:rgba(224, 155, 213, 0.77);">
      <strong>Total Invoice amount in words</strong>
    </div>
    <div>
      <span>${getWords(Number(totNetAmount), data?.currency?.code)} Only</span>
    </div>
  </div>

  <div style="width:50%;padding:5px 5px;display:flex;flex-direction:column;gap:3px">
    ${Number(data.adjustments) > 0 ? `
      <div style="display:flex;justify-content:space-between">
        <span>Additional Discount</span>
       <strong>${currencySymbol}&nbsp;(-&nbsp;${MoneyFormatv3(data.adjustments)})</strong>
      </div>      
    ` : ``}

    ${Number(data.tcsAmount) ? `
      <div style="display:flex;justify-content:space-between">
        <span>TCS</span>
       <strong>${currencySymbol}&nbsp;${MoneyFormatv3(data?.tcsAmount)}</strong>
      </div>
    ` : ``}


    ${Number(data.roundOff) != 0 ? `
      <div style="display:flex;justify-content:space-between">
        <span>Round Off</span>
        <strong>${data.roundOff >= 0 ? `${currencySymbol}&nbsp;${MoneyFormatv3(Number(data.roundOff).toFixed(2), "en-IN")}` : `${currencySymbol}&nbsp;(${MoneyFormatv3(Number(data.roundOff).toFixed(2), "en-IN")})`}</strong>
      </div>` 
      : ``}
    <div style="display:flex;justify-content:space-between">
      <span>Net Amount</span>
        ${
        Number(totNetAmount) >= 0
          ? `<strong>${currencySymbol}&nbsp;${MoneyFormatv3(Number(totNetAmount), "en-IN")}</strong>`
          : `<strong>${currencySymbol}0.00</strong>`
        }
    </div>
  </div>
</div>



 <div class="print-nobreak">
  <div style="display:flex;width:100%;">

 <div style="flex:1;padding:10px">
 ${
   InvoiceSettings.bankdetails && InvoiceSettings.companybankdetails
     ? `
<b>  Bank Details</b>
  <br>
  <p style="white-space:pre-line;margin-top:3px">${InvoiceSettings.bankdetails}
  </p>
  `
     : ``
 }
  </div>
${
  isValidUPI(InvoiceSettings.upi_id)
    ? `
  <div style="flex:1;justify-content:center;display:flex;padding:10px">
  <div style="flex:1;">
  Payment QR Code<br/>
  UPI ID :${InvoiceSettings.upi_id}
  </div style="flex:1;justify-content:center">
  
  <div>
  
  <img src="${qrupi}" width="70" height="70" />
  </div>

  </div>
  `
    : ""
}
  </div>

  <div>
  
   ${

      InvoiceSettings?.hsnsasummarytable == 1 &&
      data?.taxability?.value != 2 &&
      data?.taxability?.value != 3 &&
      companyDetails?.registrationtype !== 3 &&
      companyDetails?.registrationtype !== 1
       ? `
  <div style="margin-top:5px;width:100%;margin:auto" >

  <table border="0" cellpadding="5" cellspacing="0" 
  style="margin-left: auto; margin-right: auto; margin-top:auto ;text-align: center;border-bottom:none;width:100%;border-top:none;">
  <thead>
  <tr>
    <td style="text-align:left; font-weight: bold; " class="trhead">HSN/SAC Code Summary Table</td>
  </tr>
  </thead>
  </table>
  <table border="1" class="hsn-table" cellpadding="5" cellspacing="0" width="100%"
  style="margin-left: auto; margin-right: auto; margin-top:auto ;text-align: center;">
  <thead style= "background-color:rgba(224, 155, 213, 0.77); font-weight: bold;text-align:center;">
  <tr>
<!-- <td style="width:30px">Sl. No</td> -->
    <td>HSN/SAC Code</td>
   ${RegisterationType != 3 ? `<td>GST Rate (%)</td>` : ""}
    <td>Taxable Value</td>
    ${
      RegisterationType != 3
        ? data.placeOfSupply.value === companyState
          ? `
    <td>CGST</td>
    <td>SGST</td>
    `
          : "<td>IGST</td>"
        : ""
    }


    ${
      RegisterationType != 3
        ? totGstCess != 0
          ? `  <td>GST Cess</td>`
          : ``
        : ""
    }
    <td>Total</td>
  </tr>
  </thead>
  <tbody>

  ${renderRows()}


  </tbody>
  <tfoot >
  <tr style="font-weight: 600;" >
  <td colspan="2" style="text-align:right;" countfooter>TOTAL</td>
 <!--- ${RegisterationType != 3 ? `<td countfooter></td>` : ""} --->
  <td class="right" countfooter >${MoneyFormatv3(
    Number(calculate("taxablevalue")).toFixed(2),
    "en-IN"
  )}</td>
  ${
    RegisterationType != 3
      ? data.placeOfSupply.value === companyState
        ? `
  <td  class="right" countfooter>${
    data.placeOfSupply.value === companyState
      ? `${MoneyFormatv3(Number(calculate("cgst") / 2).toFixed(2), "en-IN")}`
      : "0.00"
  }</td>
  <td  class="right" countfooter>${
    data.placeOfSupply.value === companyState
      ? `${MoneyFormatv3(Number(calculate("sgst") / 2).toFixed(2), "en-IN")}`
      : "0.00"
  }</td>
  `
        : `<td  class="right" countfooter>${
            data.placeOfSupply.value !== companyState
              ? `${MoneyFormatv3(
                  Number(calculate("igst")).toFixed(2),
                  "en-IN"
                )}`
              : "0.00"
          }</td>`
      : ""
  }
          ${
            RegisterationType != 3
              ? totGstCess != 0
                ? `  <td  class="right" countfooter>${MoneyFormatv3(
                    Number(calculate("gstcess")).toFixed(2),
                    "en-IN"
                  )}</td>`
                : ``
              : ""
          }
  <td class="right" countfooter>${MoneyFormatv3(
    nonItemwiseTableAmount,
    "en-IN"
  )}</td>
  </tr>
  </tfoot>
  </table>


  </div>`
       : ``
   }
  
  </div>

  <div style="width:100%;margin:auto;" >
    ${InvoiceSettings?.companybankdetails && hasBankDetails ? 
      `
      <div style="width:100%; box-sizing: border-box;margin-top:5px;margin-bottom:5px;border:solid 1px gray;">
       <div >
         <div  style="font-weight:bold;padding:5px; box-sizing: border-box;font-size:12px">Bank Details</div>
         <div style= "display:flex;gap:5px;margin-left:10px">
          <div style="display:flex;flex-direction:column;gap:5px;width:70px">
            ${InvoiceSettings?.ac_name ? `<span>A/c Name </span>` : ``}
            ${InvoiceSettings?.ac_no ? `<span>A/c Number</span>` : ``}
            ${InvoiceSettings?.bank_name ? `<span>Bank Name</span>` : ``}
            ${InvoiceSettings?.branch ? `<span>Branch</span>` : ``} 
            ${InvoiceSettings?.ifsc ? `<span>IFSC Code</span>` : ``}
            ${InvoiceSettings?.swift_code ?`<span>Swift Code</span>` : ``}
          </div>
          <div style="display:flex;flex-direction:column;gap:5px;">
            ${InvoiceSettings?.ac_name ? `<span>:&nbsp; ${InvoiceSettings?.ac_name}</span>` : ``}
            ${InvoiceSettings?.ac_no ? `<span>:&nbsp; ${InvoiceSettings?.ac_no}</span>` : ``}
            ${InvoiceSettings?.bank_name ? `<span>:&nbsp; ${InvoiceSettings?.bank_name}</span>` : ``}
            ${InvoiceSettings?.branch ? `<span>:&nbsp; ${InvoiceSettings?.branch}</span>` : ``}
            ${InvoiceSettings?.ifsc ? `<span>:&nbsp; ${InvoiceSettings?.ifsc}</span>` : ``}
            ${InvoiceSettings?.swift_code ? `<span>:&nbsp; ${InvoiceSettings?.swift_code}</span>` : `` }
          </div>
         </div>
      </div>
  </div> 
  `
      : ""
  }
     ${
       InvoiceSettings?.invoicedescription && data?.remarks?.length
         ? `
     <div style=" box-sizing: border-box;">
     <div  style="background-color: #DADBDD; font-weight:bold;padding:5px; box-sizing: border-box;">Description</div>
     <div style="min-height: 40px;font-weight: bold;padding:5px" >${trimEdgesOnly(
       data.remarks
     )}</div>
     </div>
     `
         : ``
     }
     </div>

     ${
       InvoiceSettings?.termsandconditionsflag
          ? `
      <div style="display:flex; align-item:space-between;border:solid 1px gray;border-top:solid 1px gray">
     <div style=" flex: 0 0 50%; padding:10px; border-right:solid 1px gray">
        <div class="trbody" style="text-align:justify;" >
            <strong class="trhead">TERMS AND CONDITIONS  </strong>
            <p style="white-space:pre-line;margin-top:5px">${InvoiceSettings?.termsandcondition}</p>
        </div>
    </div>`
          : ``
      }
    ${
      InvoiceSettings?.declarationatfooterflag
        ? `

    <div style=" flex: 0 0 50%; padding:10px">
            <span class="trbody">
            <strong class="trhead">DECLARATION  </strong>
            <p style="white-space:pre-line;margin-top:5px">${trimEdgesOnly(
              InvoiceSettings?.declarationatfooter
            )}</p>
            </span>
        </div>
        `
        : ``
    }  
    </div>
    ${
            InvoiceSettings.dispatchdetails
? `     
          <div style="border:solid 1px gray;border-top:${InvoiceSettings?.termsandconditionsflag? 'none' : 'solid 1px gray'};padding:10px;">
            <div style="font-size:13px;font-weight:bold">Dispatch Details</div>
            <div style="display:flex;gap:10px;font-size:11px;margin-top:5px">
              <!---- ${ dateOfDispatch ? `<span>Date of dispatch: ${dayjs(dateOfDispatch).format("DD-MM-YYYY")}</span>` : ""}--->
              ${ dateOfDispatch ? `<span>Date of dispatch: ${formatDate(dateOfDispatch)}</span>` : ""}
              ${ transportMode ? `<span>Mode of transportation: ${transportMode}</span>` : ""}
              ${ vehicleNumber ? ` <span>Vehicle Number: ${vehicleNumber}</span>`: " "}
              ${ewayBillNo ? `<span>E-way Bill Number: ${ewayBillNo}</span>`  : ""  }
            </div>
          </div>  
      ` : ''
    }
      <div style="margin-left: auto; margin-right: auto; width:100%; display:flex; flex-direction:row;justify-content: space-between; page-break-inside: avoid;">
        <div style=" padding:5px 0px;box-sizing:border-box;">
            <div style = "display:flex; flex-direction:column; gap:25px">
                <div style="text-align: center;">
                    ${InvoiceSettings.acknowledgementflag === 1 ? `<strong class="trhead">${InvoiceSettings.acknowledgement}</strong>` : ``}
                </div>
                <div class="trbody" style="margin-top: 15px; ">
                ${
                  InvoiceSettings?.regularinvoicesignaturefilename?.length
                    ? `<div style="height:30px"  ></div>`
                    : ""
                }
                    <div>Customer Name and Signature</div>
                </div>
            </div>
        </div>
        <div style=" padding:5px 0px; box-sizing:border-box;">
            <div style = "display:flex; flex-direction:column; gap:25px">
                <div class="trhead" style="text-align: center;">
                    <strong>${companyDetails?.companyname}</strong>
                </div>
                <div class="trbody" style="margin-top: 15px; text-align: center;">
                ${
                  InvoiceSettings?.regularinvoicesignaturefilename?.length
                    ? `<img height="30px" style="max-width:160px" replaceherestart  src="${InvoiceSettings?.regularinvoicesignaturefilename}"  replacehereend  />`
                    : ``
                }
                    <div>${
                      InvoiceSettings?.signaturetext
                        ? InvoiceSettings?.signaturetext
                        : "Authorized Signature"
                    }</div>
                </div>
            </div>
        </div>
    </div>
    ${InvoiceSettings.einvoicedetails&& eInvoiceDetails ? `
      <div style="display:flex;gap:10px;margin-top:10px">
        <div> ${isValidUPI( "gfg@hdfcbank") ? `<img src="${qrupi1}" width="70" height="70" />` :  ``} </div>
        <div> 
          <p>IRN : ${eInvoiceDetails.irn}</p>
          <p>Ack No : ${eInvoiceDetails.ack_no}</p>
          <p>Ack Dt : ${eInvoiceDetails.ack_dt}</p>
        </div>
      </div>` : 
      
      ``}
  
  </div>
  </div>

    </td>
  </tbody>


  </table> 

  </div>
 
  </body>
  </html>

    `;
  return ParseTable(temp, isNonItemExist);
};
export const CreditNotePrint = ({
  invTransArr,
  data,
  totGstCess,
  totGST,
  totNetAmount,
  totDiscount,
  totAmount,
  tabelTotAmount,
  totTaxableAmount,
  bankDetails,
  registrationType,
  stateOfSupply,
  countryName,
  stateName,
  suppierAddressDetals,
  companyDetails,
  nonItems,
  items,
  units,
  nonItemwiseTableAmount,
  journalhtmlItems,
  journalhtmlNonItems,
  totGstRate,
  journelReady,
  companyState,
}) => {
  let itemEntry = true;
  let currencySymbol = billingCurrencyOptions.find(
    (elem) => data?.currency?.value == elem.value
  )?.sign;
  currencySymbol = currencySymbol || "";
  console.log(currencySymbol);
  console.log({
    invTransArr,
    data,
    totGstCess,
    totGST,
    totNetAmount,
    totDiscount,
    totAmount,
    tabelTotAmount,
    totTaxableAmount,
    bankDetails,
    registrationType,
    stateOfSupply,
    countryName,
    stateName,
    suppierAddressDetals,
    companyDetails,
    nonItems,
    items,
    units,
    nonItemwiseTableAmount,
    journalhtmlItems,
    journalhtmlNonItems,
    totGstRate,
    journelReady,
    companyState,
  });

  console.log(companyDetails.companyname);
  const renderJournel = () => {
    {
      let ren = "";
      invTransArr = invTransArr.sort((p1) =>
        p1.debitAmt !== 0 ? -1 : p1.creditAmt == 0 ? 0 : 1
      );
      invTransArr.map((ele, ind) => {
        ren += `<tr key={ind}>
                        ${
                          ele.debitAmt == 0 && ele.creditAmt == 0
                            ? ``
                            : `
                                <td
                                    size="small"
                                    sx={{
                                        fontWeight: "bold",
                                        color: ele.debitAmt !== 0 ? "#396afc" : "#20e0cf",
                                        width: "300px",
                                        height: "0px",
                                    }}
                                >
                                    ${
                                      ele.debitAmt !== 0
                                        ? ele.accountName + " " + "Dr"
                                        : "To" + " " + ele.accountName
                                    }
                                </td>
                                <td
                                    align="right"
                                    size="small"
                                    sx={{
                                        fontWeight: "bold",
                                        color: "#396afc",
                                        width: "30px",
                                        height: "0px",
                                    }}
                                >
                                    ${
                                      ele.debitAmt == 0
                                        ? " "
                                        : MoneyFormatv3(
                                            Number(ele.debitAmt).toFixed(2),
                                            "en-IN"
                                          )
                                    }
                                </td>
                                <td
                                    align="right"
                                    size="small"
                                    sx={{
                                        fontWeight: "bold",
                                        color: "#20e0cf",
                                        width: "30px",
                                        height: "0px",
                                    }}
                                >
                                    ${
                                      ele.creditAmt == 0
                                        ? " "
                                        : MoneyFormatv3(
                                            Number(ele.creditAmt).toFixed(2),
                                            "en-IN"
                                          )
                                    }
                                </td>
                           `
                        }
                    </tr>`;
      });
      return ren;
    }

    return;
    if (journelReady) {
      return journelReady;
    }
    let row = "";
    if (itemEntry) {
      journalhtmlItems?.map((item) => {
        if (item.editable === false)
          row += `<tr style="color:#396afc;font-weight: bold;">
                           <td width="60%">${
                             item.purchaseAccount?.label
                           } Dr</td>
                           <td width="20%" align="center">${MoneyFormatv3(
                             Number(item.amountTaxable).toFixed(2),
                             "en-IN"
                           )}</td>
                           <td width="20%" align="center"></td>
                         </tr>
                         `;
      });
    } else {
      //nonItems.map((ele) => {
      journalhtmlNonItems?.map((ele) => {
        if (ele.editable === false)
          row += `<tr style="color:#396afc;font-weight: bold;">
                         <td width="60%"> ${ele.ledgerAccount?.label} Dr</td>
                  
                         <td width="20%" align="center">${MoneyFormatv3(
                           Number(ele.amountTaxable).toFixed(2),
                           "en-IN"
                         )}</td>
                         <td width="20%" align="center"></td>
                       </tr>`;
      });
    }
    return row;
  };
  let isNonItemExist = nonItems?.length ? true : false;
  let isItemExist = items?.length ? true : false;
  console.log(isNonItemExist, isItemExist);
  let colspan = 12;
  if (data.placeOfSupply.value !== companyState) {
    colspan -= 1;
  } else {
    console.log(
      nonItems,
      nonItems?.filter((item) => item.new).length,
      nonItems?.filter((item) => item.new)
    );
    // if (nonItems?.filter(((item) => !item.new)).length == 0) {
    //     colspan -= 1
    // }
  }
  if (totGstCess == 0) {
    colspan -= 1;
  }

  const cItem = (p) => {
    if (items && items.length > 0) {
      if (p === "discount") {
        let total = 0;
        for (let i = 0; i < items.length; i++) {
          total += parseFloat(items[i].dicount);
        }
        return total;
      } else if (p === "igst" || p === "cgst" || p === "sgst") {
        let total = 0;
        for (let i = 0; i < items.length; i++) {
          total +=
            (Number(items[i].taxableAMount) * Number(items[i].GSTRate)) / 100;
        }
        return total;
      } else if (p === "total") {
        let total = 0;
        for (let i = 0; i < items.length; i++) {
          total +=
            (Number(items[i].taxableAMount) * Number(items[i].GSTRate)) / 100 +
            items[i].taxableAMount +
            Number(items[i].GSTCess);
        }
        return total;
      } else if (p === "taxablevalue") {
        let total = 0;
        for (let i = 0; i < items.length; i++) {
          total += Number(items[i].taxableAMount);
        }
        return total;
      } else if (p === "gstcess") {
        let total = 0;
        for (let i = 0; i < items.length; i++) {
          total += Number(items[i].GSTCess);
        }
        return total;
      }
    } else {
      return 0;
    }
  };
  const cNon = (p) => {
    if (nonItems && nonItems.length > 0) {
      if (p === "discount") {
        let total = 0;
        for (let i = 0; i < nonItems.length; i++) {
          total += parseFloat(nonItems[i].dicount ?? 0);
        }
        return total;
      } else if (p === "igst" || p === "cgst" || p === "sgst") {
        let total = 0;
        for (let i = 0; i < nonItems.length; i++) {
          total +=
            (Number(nonItems[i].taxableAMount) * Number(nonItems[i].GSTRate)) /
            100;
        }
        return total;
      } else if (p === "total") {
        let total = 0;
        console.log(nonItems);
        for (let i = 0; i < nonItems.length; i++) {
          total +=
            (Number(nonItems[i].taxableAMount) * Number(nonItems[i].GSTRate)) /
              100 +
            nonItems[i].taxableAMount +
            Number(items[i].GSTCess);
        }
        console.log(total);
        return total;
      } else if (p === "taxablevalue") {
        let total = 0;
        for (let i = 0; i < nonItems.length; i++) {
          total += Number(nonItems[i].taxableAMount);
        }
        return total;
      } else if (p === "gstcess") {
        let total = 0;
        for (let i = 0; i < nonItems.length; i++) {
          total += Number(nonItems[i].GSTCess);
        }
        return total;
      }
    } else {
      return 0;
    }
  };
  const calculate = (p) => {
    if (items && items.length > 0) {
      let total = 0;
      total = cItem(p) + cNon(p);
      return total;
    }
  };
  const renderRow = () => {
    let row = "";
    let all = [];
    if (items?.length > 0) {
      all = items.map((elem) => {
        elem.type = "item";
        return elem;
      });
    }
    if (nonItems?.length > 0) {
      all = [
        ...all,
        ...nonItems.map((elem) => {
          elem.type = "nonitem";
          return elem;
        }),
      ];
    }
    console.log(all);
    all = all.filter((elem) => {
      if (elem.type == "nonitem" && elem?.ledgerAccount?.label) {
        return elem;
      } else if (elem.type == "item" && elem?.itemCode?.label) {
        return elem;
      }
    });

    if (all.length > 0) {
      all.forEach((item, index) => {
        console.log(item, units);
        let unit = units.find((e) => e.value == item.units) || "";
        if (item?.name?.label?.length && item.type == "item") {
          row += `
        <tr fc="startpatternhereto983y47" style="min-height: 100px">
            <td fc="countable" style="border:none">${index + 1}</td>
            <td fc="countable" style="border:none;max-width: 190px;word-break: break-word;overflow:hidden;text-align:left" colspan="4">${
              item.name?.label
            }</td>
        

            <td fc="countable" class="right" style="border:none">${
              item.rate != 0 ? MoneyFormatv3(item.rate) : "0.00"
            }</td>
            <td fc="countable" style="border:none">${item.qty}</td>
            <td fc="countable" style="border:none">${unit?.UQC || ""}</td>
            <td fc="countable" class="right" style="border:none">${
              Number(item.amount) > 0
                ? MoneyFormatv3(Number(item.amount))
                : "0.00"
            }</td>

            ${
              calculate("discount") > 0
                ? `   <td fc="countable" class="right" style="border:none">${
                    item.dicount != 0 ? MoneyFormatv3(item.dicount) : "0.00"
                  }</td>`
                : ``
            }
            <td fc="countable" class="right" style="border:none">${
              item.amount != 0
                ? MoneyFormatv3(Number(item.taxableAMount))
                : "0.00"
            }</td>

            ${
              registrationType != 3
                ? `
                    <td fc="countable" style="border:none;padding:0px"   >
                    <table style="width:100%;table-layout:auto">
                    <tr>
                    <td style="text-align:center;width:20%;padding:0px"> 
                    ${item.GSTRate}
                    </td>
                    <td class="right" style="width:80%"> 
                    ${MoneyFormatv3(
                      (
                        (Number(item.taxableAMount) * Number(item.GSTRate)) /
                        100
                      ).toFixed(2)
                    )}
                </td>
                </tr>
                </table>
                    </td>`
                : ``
            }
                ${
                  totGstCess > 0 && registrationType != 3
                    ? `<td fc="countable" class="right" style="border:none" >${
                        item.GSTCess != 0 ? MoneyFormatv3(item.GSTCess) : "0.00"
                      }</td>`
                    : ``
                }
                <td fc="countable" class="right "  style="border:none" >${MoneyFormatv3(
                  Number(item.netAmount).toFixed(2)
                )}</td>
        </tr fc="endpatternhereto983y47">`;
        } else if (item.type === "nonitem") {
          row += `
                  <tr fc="startpatternhereto983y4790" style="min-height: 100px">
                      <td 1 fc="countable">${index + 1}</td>
                      <td 2 fc="countable" style="text-align:left;" c colspan="4">${
                        item.ledgerAccount.label
                      } ${
            item.description.length
              ? `(${
                  item.description.length > 25
                    ? item.description.slice(0, 22) + "..."
                    : item.description
                })`
              : ``
          }</td>
                      
                      <td fc="countable"></td>
                      <td fc="countable"></td>
                      <td fc="countable"></td>
                      <td fc="countable"></td>
            ${
              calculate("discount") > 0
                ? `   <td fc="countable" class="right" style="border:none">${
                    item.dicount != 0 ? MoneyFormatv3(item.dicount) : "0.00"
                  }</td>`
                : ``
            }

                     
                      ${
                        registrationType != 3
                          ? `<td 5 fc="countable" class="right">${MoneyFormatv3(
                              item.taxableAMount,
                              "en-IN"
                            )}</td>`
                          : ""
                      }
                      ${
                        registrationType != 3
                          ? `
                            <td 8  fc="countable" style="border:none;padding:0px"   >
                            <table style="width:100%">
                            <tr>
                            <td style="text-align:center;width:20%;padding:0px"> 
                            ${item.GSTRate}
                            </td>
                            <td class="right" style="width:80%"> 
                            ${MoneyFormatv3(
                              (
                                (Number(item.taxableAMount) *
                                  Number(item.GSTRate)) /
                                100
                              ).toFixed(2)
                            )}
                        </td>
                        </tr>
                        </table>
                            </td>`
                          : ""
                      }
                       ${
                         registrationType != 3 && totGstCess > 0
                           ? `<td 9 fc="countable" class="right">${
                               Number(item?.GSTCess).toFixed(2) != 0
                                 ? MoneyFormatv3(
                                     Number(item?.GSTCess).toFixed(2),
                                     "en-IN"
                                   )
                                 : "0.00"
                             }</td> `
                           : ``
                       }
              <td 10 fc="countable" class="right" >${MoneyFormatv3(
                Number(item?.netAmount).toFixed(2),
                "en-IN"
              )}</td>
                  </tr fc="endpatternhereto983y4790">`;
        }
      });
    }
    return row;
  };
  const renderRowParticulars = () => {
    let row = "";
    let arr = itemEntry ? items : nonItems;
    console.log(items, nonItems, arr);
    if (arr && arr?.length > 0 && itemEntry) {
      arr.forEach((item, index) => {
        row += `
          <tr style="min-height: 100px">
              <td>Taxable</td>
              <td>${MoneyFormatv3(item.amount)}</td>
           <td style="display:none;">${MoneyFormatv3(item.dicount)}</td>
              <td>${item.GSTRate}</td>
              ${
                data.placeOfSupply.value === companyState
                  ? `
              <td>${
                data.placeOfSupply.value === companyState
                  ? MoneyFormatv3(
                      (
                        (Number(item.taxableAMount) * Number(item.GSTRate)) /
                        200
                      ).toFixed(2)
                    )
                  : "0.00"
              }
                  </td>
                  <td>${
                    data.placeOfSupply.value === companyState
                      ? MoneyFormatv3(
                          (
                            (Number(item.taxableAMount) *
                              Number(item.GSTRate)) /
                            200
                          ).toFixed(2)
                        )
                      : "0.00"
                  }</td>
              `
                  : `<td>${
                      data.placeOfSupply.value !== companyState
                        ? MoneyFormatv3(
                            (
                              (Number(item.taxableAMount) *
                                Number(item.GSTRate)) /
                              100
                            ).toFixed(2)
                          )
                        : "0.00"
                    }</td>`
              }
              
                  ${
                    totGstCess != 0
                      ? ` <td  >${MoneyFormatv3(item.GSTCess)}</td>`
                      : ``
                  }
                  <td>${MoneyFormatv3(Number(item.netAmount).toFixed(2))}</td>
          </tr>`;
      });
      console.log(row);
      return row;
    } else if (arr && arr?.length > 0 && !itemEntry) {
      arr.forEach((item, index) => {
        row += `
          <tr style="min-height: 100px">
              <td>Taxable</td>
              <td>${MoneyFormatv3(item.taxAMount)}</td>
              <td style="display:none;">${MoneyFormatv3(item.dicount)}</td>
              <td>${item.GSTRate}</td>
              ${
                data.placeOfSupply.value === companyState
                  ? `
              <td>${
                data.placeOfSupply.value === companyState
                  ? MoneyFormatv3(
                      (
                        (Number(item.taxAMount) * Number(item.GSTRate)) /
                        200
                      ).toFixed(2)
                    )
                  : "0.00"
              }
                  </td>
                  <td>${
                    data.placeOfSupply.value === companyState
                      ? MoneyFormatv3(
                          (
                            (Number(item.taxAMount) * Number(item.GSTRate)) /
                            200
                          ).toFixed(2)
                        )
                      : "0.00"
                  }</td>
              `
                  : `<td>${
                      data.placeOfSupply.value !== companyState
                        ? MoneyFormatv3(
                            (
                              (Number(item.taxAMount) * Number(item.GSTRate)) /
                              100
                            ).toFixed(2)
                          )
                        : "0.00"
                    }</td>`
              }
              
                  ${
                    totGstCess != 0
                      ? ` <td  >${MoneyFormatv3(item.GSTCess)}</td>`
                      : ``
                  }
                  <td>${MoneyFormatv3(Number(item.netAmount).toFixed(2))}</td>
          </tr>`;
      });
      console.log(row);
      return row;
    }
  };
  return `
  <html>
  <head>
   <meta name="viewport" />
   <style rel="stylesheet">

@media print {
  @page {
    margin: 0;
  }

  .header,
  .footer {
    display: none;
  }
}
.moneyAlign{
    text-align:right
   }
   .firsttable thead td{
    font-size: 12px;
  }
   .firsttable tbody td {
   font-size: 10px;
   border:none;
   padding:1px 5px;
 }
   .thirdDiv thead td {
    font-size: 9px;
    padding:0px;
  }
  
  .thirdDiv tbody td {
    font-size: 10px;
    border:none;
    padding:1px;
    
  }

  .thirdDiv tfoot td {
    font-size: 10px;
    text-align:right;
  }
.firstDiv{
  font-size:12px;
}
table, th, td {

  border-collapse: collapse;
}
.fourthTable thead td {
  font-size: 12px;
}
.fourthTable tbody td {
  font-size: 10px;
  border:none;
}
.hsnTable tbody td {
  font-size: 10px;
  border:none;
}
   </style>
  </head>
  <body>
  
  <div style="min-height: 285px; margin-left: auto; margin-right: auto; width:95%;
  margin-left: auto; margin-right: auto; padding-top: 5px">
  <div style="width: 100%; float: center;">
  <div style="display: flex; flex-direction:column; padding:10px 0px">
  <div style="display:flex; flex-direction:row-reverse; justify-content:space-between;">
  <div >
  ${
    companyDetails?.relatedcompanydetailsnew?.[0].companylogourl ==
      `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/` ||
    companyDetails?.relatedcompanydetailsnew?.[0].companylogourl == ""
      ? `

  `
      : `
  <img src="${companyDetails?.relatedcompanydetailsnew?.[0].companylogourl}"
  alt="CompanyLogo" width="80px" height="80px">
  `
  }
    </div >
    <div style="max-width:40%;word-break:break-word;" >
  <span style="font-size: 15px; padding-bottom: 5px;
   font-weight:bold;">
   ${companyDetails?.companyname}
  </span><br/>
  
  <span style="font-size: 12px;max-width:50% ">
        ${
          companyDetails?.line1?.replace(/[**,]+/g, "")
            ? companyDetails?.line1?.replace(/[**,]+/g, " ") + ", "
            : ""
        }</span>   <span style="font-size: 12px;">${
    companyDetails?.city ? companyDetails?.city + ", " : ""
  }${
    companyDetails?.district?.replace("District", "")
      ? companyDetails?.district?.replace("District", "") + ", "
      : ""
  }${
    companyDetails?.statename.replace("District", "")
      ? companyDetails?.statename.replace("District", "") + ", "
      : ""
  }${companyDetails?.countrycode?.replace("State", "")}</span>
          <span style="font-size: 12px;
         ">${
           companyDetails?.pincode &&
           ", " + companyDetails?.pincode?.split("**").join("\n")
         }
  </span>
    ${
      registrationType !== 1
        ? `
  <br/>
  ${
    companyDetails?.relatedcompanyentity?.[0].gstin
      ? `
  <span style="font-size: 12px;
  ">
  <strong>GSTIN : </strong> ${companyDetails?.relatedcompanyentity?.[0].gstin}
  </span>`
      : ""
  }`
        : ""
    }
  </div>
  </div>

  </div>
  </div>

  <div style=" display: flex;
  flex-direction:row; justify-content: center;padding:0px 10px ">
               <span style="font-size: 18px; font-weight: bolder;  padding:20px 0px ;">
                   CREDIT NOTE
               </span>
           </div>

  <div class="firstDiv" >
      <table border="1" class="firsttable" cellpadding="5" cellspacing="0" width="100%"
      style="margin-left: auto; margin-right: auto; margin-top:auto;">
  <thead style="background-color: #DADBDD; font-weight: bold;">
      <tr>
          <td>Voucher Details</td>
          <td>Supplier Details</td>
      </tr>
  </thead>
  <tbody>
  <tr><td style="height:5px;border:none" colspan="*" rowspan="*" ></td></tr>
   <tr style="min-height: 100px">
   <td style="font-weight: bold;">Voucher No : ${data.voucherNumber}</td>
   <td style="">Supplier Name : ${data?.partyName?.legalName || ""}</td>
   </tr>
  <tr style="min-height: 100px">
  <td style="">Voucher Date : ${
    data.invoiceDate === ""
      ? moment(new Date()).format("DD-MM-YYYY")
      : moment(data.invoiceDate).format("DD-MM-YYYY")
  }</td>
  <td style="">Supplier Address : ${
    data?.partyName?.label != ""
      ? `
      <span>
        ${
          suppierAddressDetals.supplierAddress !== ""
            ? suppierAddressDetals.billingAddress?.replace(/[**,]+/g, ",") || ""
            : data.supplierAddress?.replace(/[**,]+/g, ",") || ""
        }
      </span>
      ${
        suppierAddressDetals.stateCD !== "" || stateName !== ""
          ? `
        <span
  
        >
          ${
            suppierAddressDetals.stateCD?.label
              ? suppierAddressDetals.stateCD.label || ""
              : stateName.label
              ? stateName.label + ","
              : ""
          }
          ${countryName.label || ""}
        </span>`
          : `
        <span
  
        >
          ${countryName.label || ""}
  
        </span>`
      }
  `
      : ``
  }</td>
  </tr>
  ${
    data.reverseChargeFlag == 1
      ? `
  <tr style="min-height: 100px">
  <td style="">Reverse Charge (Y/N) : ${
    data.reverseChargeFlag == 1 ? "Yes" : "No"
  }</td>
    <td></td>
  </tr>`
      : ``
  }
  <tr style="min-height: 100px">
  <td style="">${
    data.creditPeriod !== "0" ? `Credit Period : ${data.creditPeriod}` : ` `
  }</td>
  <td style="">Contact Person :</td>
  </tr>
  <tr style="min-height: 100px">
  <td style=""></td>
  <td style="">Supplier Invoice No : ${data.orderNumber}</td>
  </tr>
  <tr style="min-height: 100px">
  <td  style="">${
    data.dueDate != "Invalid date"
      ? `Due Date : ${moment(data.dueDate).format("DD-MM-YYYY")}`
      : ``
  }</td>
  <td style="">Supplier GSTIN : ${data.gstin}</td>
  </tr>
  ${
    registrationType !== 3
      ? `  <tr style="min-height: 100px">
  <td></td>
<td style="">Place of Supply : ${data?.placeOfSupply?.label} </td>
  </tr>`
      : ``
  }
  <tr><td style="height:5px;border:none" colspan="*" rowspan="*" ></td></tr>

  </tbody>
  </table>
  </div>
  <div style="margin-top:10px"class="thirdDiv" >

<table border="1" t="1" cellpadding="5" cellspacing="0" width="100%"
            style="margin-left: auto; margin-right: auto; text-align: center;">
        <thead style="background-color: #DADBDD; font-weight: bold;">
            <tr>
                <td style="width:30px">Sl .No</td>
                <td colspan="4" style="min-width:80px;max-width:240px;text-overflow:ellipsis">Item Name</td>
                <td>Rate</td>
                <td>Qty</td>
                <td>Unit</td>
                <td>Amount</td>
                ${Number(totDiscount) > 0 ? `<td>Discount</td>` : ``}
                <td style="width:90px;">Taxable Amount</td>
                ${ registrationType !== 3 ||  registrationType !== 1 ?`
          <td  style="padding:0px;height: 45px;width:80px;
          vertical-align: unset;">
          <div style="height:100%;">
          <table  style="width:100%;height:100%;">
          <tr>
          <td colspan="2" style="text-align:center" > GST</td>
          </tr>
          <tr style="border-top:1px solid;border-color: inherit">
              <td style="text-align:center;width:30%;border-right: 1px solid;border-color: inherit">&nbsp;%&nbsp;</td>
              <td style="text-align:center;width:70%">Amount</td>
            </tr>
          </table>
          </div>
        </td>
        `:''}

      ${totGstCess != 0 ? `<td style="width:60px">GST Cess</td>` : ``}
                <td style="text-align:center;width:80px">Net Amount</td>
            </tr>
           
        </thead>
        <tbody>
  <tr><td style="height:5px;border:none" colspan="*" rowspan="*" ></td></tr>

            ${renderRow()}
           
      </tbody >
     
 
  </table > 
    
    
<table width="100%"  class="item-table" border style="margin-top:auto" >
  <tfoot style="font-weight: bold; background-color: #DADBDD;" countablefooter>
            <tr fc="start3u434459">
                <td fc="tstp" colspan="${colspan} fc="tstpend" style="text-align: right" countfooter>TOTAL</td>
                ${
                  registrationType != 3
                    ? `<td class="right" style="width:85px" countfooter>${MoneyFormatv3(
                        totTaxableAmount.toFixed(2),
                        "en-IN"
                      )}</td>`
                    : ""
                }
                ${
                  registrationType != 3 ||registrationType !== 1 
                    ? `
                  <td colspan="1" class="right" style="padding:0px;height: 30px;width:80px;
                " countfooter>
              ${MoneyFormatv3(Number(totGST).toFixed(2), "en-IN")}
                </td>
                `
                    : ``
                }           
                ${
                  totGstCess != 0 && registrationType != 3
                    ? `<td class="right" style="width:60px" countfooter>${MoneyFormatv3(
                        totGstCess.toFixed(2),
                        "en-IN"
                      )}</td>`
                    : ``
                }

                 <td colspan="1" class="right" style="width:80px" countfooter>${MoneyFormatv3(
                   nonItemwiseTableAmount.toFixed(2),
                   "en-IN"
                 )}</td>
            </tr>
        </tfoot countablefooterend >
</table>
    </div>
    <div style="display: grid;grid-template-columns: 3fr 2fr ;margin-left: auto; margin-right: auto; width:100%;
    margin-top: 15px; padding-bottom: 10px;
   box-sizing:border-box;
   ">
       <div >
           <div style="font-size: 12px; margin-top: 10px; margin-bottom: 25px;max-width: 100%;">
            <strong>  Total amount in words : 
               ${getWords(
                 Number(totNetAmount.toFixed(2)),
                 data?.currency?.code
               )}
               </strong>
           </div>
           <div style=" margin-top: 10px; margin-bottom: 25px; width:70%">
           <table class="fourthTable" style="display:none" border="1" cellpadding="5" width="100%"
                  style="text-align: center; margin-left: 10px">
               <thead>
               <tr>
               <td colspan="8" style="font-weight: bold;" >GST RATE WISE SUMMARY
               </td>
               </tr>
                   <tr style="font-weight: bold;">
                       <td>Particulars</td>
                       <td>Amount</td>
                       <td>Rate (%)</td>
                       ${
                         data?.placeOfSupply?.value === companyState
                           ? `   <td>CGST</td>
                       <td>SGST</td>
                       `
                           : `
                       <td>IGST</td>`
                       }
                       ${totGstCess != 0 ? ` <td>GST Cess</td>` : ""}
                       <td>TOTAL</td>

                   </tr>
               </thead>
               <tbody>
               ${renderRowParticulars()}
                   <tr style="display:none;" >
                       <td>Taxable</td>
                       <td>${MoneyFormatv3(
                         totTaxableAmount.toFixed(2),
                         "en-IN"
                       )}</td>
                       <td>${Number(totGstRate).toFixed(2)}</td>
                       ${
                         data.placeOfSupply.value === companyState
                           ? ` 
                       <td>${
                         data.placeOfSupply.value === companyState
                           ? MoneyFormatv3(
                               (Number(totGST) / 2).toFixed(2),
                               "en-IN"
                             )
                           : "0.00"
                       }</td>
                      <td>${
                        data.placeOfSupply.value === companyState
                          ? MoneyFormatv3(
                              (Number(totGST) / 2).toFixed(2),
                              "en-IN"
                            )
                          : "0.00"
                      }</td>`
                           : `<td>${
                               data.placeOfSupply.value !== companyState
                                 ? MoneyFormatv3(
                                     Number(totGST).toFixed(2),
                                     "en-IN"
                                   )
                                 : "0.00"
                             }</td>`
                       }
                   </tr>
                   
               </tbody>
               <tfoot>
               <tr style="font-weight:600;" >
                   <td>Total</td>
                   <td>${MoneyFormatv3(
                     totTaxableAmount.toFixed(2),
                     "en-IN"
                   )}</td>
                   <td></td>
                   ${
                     data.placeOfSupply.value === companyState
                       ? ` <td>${
                           data.placeOfSupply.value === companyState
                             ? MoneyFormatv3(
                                 (Number(totGST) / 2).toFixed(2),
                                 "en-IN"
                               )
                             : "0.00"
                         }</td>
                   <td>${
                     data.placeOfSupply.value === companyState
                       ? MoneyFormatv3((Number(totGST) / 2).toFixed(2), "en-IN")
                       : "0.00"
                   }</td>`
                       : `<td>${
                           data.placeOfSupply.value !== companyState
                             ? MoneyFormatv3(Number(totGST).toFixed(2), "en-IN")
                             : "0.00"
                         }</td>`
                   }
                  ${
                    totGstCess != 0
                      ? `<td>${MoneyFormatv3(
                          Number(totGstCess).toFixed(2),
                          "en-IN"
                        )}</td>`
                      : ""
                  }
                   <td>${MoneyFormatv3(
                     (
                       Number(totNetAmount.toFixed(2)) -
                       Number(data.tdsAmount) +
                       Number(data.adjustments)
                     ).toFixed(2),
                     "en-IN"
                   )}</td>
               </tr>
               </tfoot>
           </table>
           </div>
         
       </div>
       <div >
           <div style="display: flex; flex-direction:column; line-height: 1; ">
               <div style="display: none; flex-direction:row; justify-content: space-between;
                           font-size: 12px; padding-left: 15px;  margin-top: 5px;">
                   <span>Taxable Amount</span>
                   <span>${currencySymbol}&nbsp;${
    Number(totTaxableAmount) > 0
      ? MoneyFormatv3(totTaxableAmount.toFixed(2), "en-IN")
      : "0.00"
  }</span>
               </div>
               <div style="display: flex; flex-direction:row; justify-content: space-between;
                           font-size: 12px; padding-left: 15px;  margin-top: 5px;">
                   <span>Tax</span>
                   <span>${currencySymbol}&nbsp;${
    Number(totGST) + Number(totGstCess) > 0
      ? MoneyFormatv3((Number(totGST) + Number(totGstCess)).toFixed(2), "en-IN")
      : "0.00"
  }</span>
               </div>
               ${
                 Number(data.tdsAmount) > 0
                   ? `
      <div style="display: flex;
       flex-direction:row;
      justify-content: space-between;
                           font-size: 12px;
                            padding-left: 15px;
                              margin-top: 5px;">
        <span>TDS Amount, If Applicable</span>
        <span>${currencySymbol}&nbsp;${
                       Number(data.tdsAmount) > 0
                         ? MoneyFormatv3(
                             Number(data.tdsAmount).toFixed(2),
                             "en-IN"
                           )
                         : "0.00"
                     }</span>
      </div> `
                   : ""
               }
      ${
        Number(data.tcsAmount) > 0
          ? `
      <div style="display: flex;
       flex-direction:row;
      justify-content: space-between;
                           font-size: 12px;
                            padding-left: 15px;
                              margin-top: 5px;">
        <span>TCS Amount, If Applicable</span>
        <span>${currencySymbol}&nbsp;${
              Number(data?.tcsAmount) > 0
                ? MoneyFormatv3(Number(data?.tcsAmount).toFixed(2), "en-IN")
                : "0.00"
            }</span>
      </div> `
          : ""
      }

             ${
               Number(data.adjustments) != 0
                 ? `<div style="display: flex; flex-direction:row; justify-content: space-between;
                           font-size: 12px; padding-left: 15px; margin-top: 5px;">
                           ${
                             Number(data.adjustments) != 0
                               ? `<span>Adjustment</span>
      <span>${currencySymbol}&nbsp;${
                                   Number(data.adjustments) != 0
                                     ? Number(data.adjustments).toFixed(2)
                                     : "0.00"
                                 }</span>`
                               : ``
                           }
    </div>`
                 : ""
             }

            ${
              Number(data.roundOff) != 0
                ? `<div style="display: flex; flex-direction:row; justify-content: space-between;
            font-size: 12px; padding-left: 15px; margin-top: 5px;">
            ${
              Number(data.roundOff) != 0
                ? `<span>Discount/Roundoff</span>
<span>${currencySymbol}&nbsp;${
                    Number(data.roundOff) != 0
                      ? Number(data.roundOff).toFixed(2)
                      : "0.00"
                  }</span>`
                : ``
            }
</div>`
                : ""
            }


               <div style="display: none; flex-direction:row; justify-content: space-between;
                           font-size: 12px; padding-left: 15px;  margin-top: 5px;">
                   <span>Discount</span>
                   <span>${currencySymbol}&nbsp;${
    Number(totAmount) - Number(totTaxableAmount) > 0
      ? MoneyFormatv3(
          (Number(totAmount) - Number(totTaxableAmount)).toFixed(2),
          "en-IN"
        )
      : "0.00"
  }</span>
               </div>
               <!--
    < div style = "display: flex; flex-direction:row; justify-content: space-between;
  font - size: 12px; padding - left: 15px; padding - right: 15px; margin - top: 5px; ">
    < span > CGST</span >
      <span>${currencySymbol}&nbsp;${
    data.placeOfSupply.value === companyState
      ? MoneyFormatv3((Number(totGST) / 2).toFixed(2), "en-IN")
      : "0.00"
  }</span>
               </div >
               <div style="display: flex; flex-direction:row; justify-content: space-between;
                           font-size: 12px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
                   <span>SGST</span>
                   <span>${currencySymbol}&nbsp;${
    data.placeOfSupply.value === companyState
      ? MoneyFormatv3((Number(totGST) / 2).toFixed(2), "en-IN")
      : "0.00"
  }</span>
               </div>
           <div style="display: flex; flex-direction:row; justify-content: space-between;
                           font-size: 12px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
                   <span>IGST</span>
                   <span>${currencySymbol}&nbsp;${
    data.placeOfSupply.value !== companyState
      ? MoneyFormatv3(Number(totGST).toFixed(2), "en-IN")
      : "0.00"
  }</span>
               </div>-->

    <div style="display: flex; flex-direction:row; justify-content: space-between;
                           font-size: 15px; padding-left: 15px;  margin-top: 4px;">
      <strong>Net Payable</strong>
      <strong>${currencySymbol}&nbsp;${MoneyFormatv3(
    Number(totNetAmount.toFixed(2)),
    "en-IN"
  )}</strong>
    </div>
           </div >
       </div >
   </div >
    <div style="margin-left: auto; margin-right: auto; width:100%; box-sizing: border-box;
      border: double; border-width: 1px; border-color: black; margin-top: 15px;display:none;">
      <div >
        <div style="font-size: 14px; margin-top: 10px; margin-bottom: 5px; padding-left: 10px; font-weight:bold">
          Bank Details
        </div>
        <div>
          <div style="display: flex; flex-direction:column; line-height: 1.8;">
            <div style="display: flex; flex-direction:row; justify-content: space-between;
               font-size: 12px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
              <span style="font-weight:bold;">Account Name : ${
                bankDetails?.BankAccountName == undefined
                  ? ""
                  : bankDetails?.BankAccountName
              }</span>
              <span style="font-weight:bold;"></span>
            </div>
            <div style="display: flex; flex-direction:row; justify-content: space-between;
               font-size: 12px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
              <span style="font-weight:bold;">Account Number : ${
                bankDetails?.BankAccountNumber == undefined
                  ? ""
                  : bankDetails?.BankAccountNumber
              }</span>
              <span style="font-weight:bold;"></span>
            </div>
            <div style="display: flex; flex-direction:row; justify-content: space-between;
               font-size: 12px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
              <span style="font-weight:bold;">Bank : ${
                bankDetails?.BankName == undefined ? "" : bankDetails?.BankName
              }</span>
              <span style="font-weight:bold;"></span>
            </div>
            <div style="display: flex; flex-direction:row; justify-content: space-between;
               font-size: 12px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
              <span style="font-weight:bold;">IFSC Code : ${
                bankDetails?.IFSCCode == undefined ? "" : bankDetails?.IFSCCode
              }</span>
              <span style="font-weight:bold;">
              </span>
            </div>
          </div>
        </div>

      </div>
    </div> 
    <div style="font-size:10px">
    <div >

    Payment Type : ${data.paymentType}
    ${
      data.paymentType == "Credit"
        ? `
    
    <div>
    
    Credit Period : ${data.creditPeriod}<br/>
    Due Date : ${moment(data.dueDate).format("DD-MM-YYYY")}
    
    </div>
    
    `
        : ``
    }
    </div>

    ${
      data?.paymentType == "Bank"
        ? `
    <div> Paid Amount : ${data.receivedAmount}  </div>
    <div> Bank Reference No : ${data.bankReferenceNo}  </div>
    <div> Bank : ${data?.receivedAccount?.label || ""}  </div>
    </div>
    `
        : ``
    }
    ${
      data?.paymentType == "Cash"
        ? `
    <div>
    Paid Amount : ${data?.receivedAmount}
    </div>
    `
        : ``
    }
    </div>
    
${
  data?.remarks?.length
    ? `
<div style="font-size: 14px; ">
  <div  style="background-color: #DADBDD; font-weight:bold;padding:5px; box-sizing: border-box;">Description</div>

              <p style="padding-left: 5px;"> ${data.remarks}</p>
          </div>

          `
    : ``
}
   <div style="width:100%; margin-top:12px;display:none"><span style="font-size: 14px;
   text-align: center; font-weight:bold;">
    Journal Entry
   </span>
                          </div>
   <div style="margin-left: auto; margin-right: auto; display:none;
               border: 1px solid black;  margin-top: 15px;padding:5px;">
               <table cellpadding="2" cellspacing= "0" width="100%" 
               style="margin-left: auto; margin-right: auto; margin-top: 10px;">
               <thead>
               </thead>
               <tbody style="font-size:12px;">
               <tr style="font-weight: bold;">
               <td width="60%">Particulars</td>
               <td width="20%" align="right">Debit(₹)</td>
               <td width="20%" align="right">Credit(₹)</td>
             </tr>
               ${renderJournel()}
                 
               </tbody>
             </table>
   </div>
  </body >
  </html >
    `;
};
export const DebitNotePrint = ({
  invTransArr,
  data,
  totGstCess,
  totGST,
  totNetAmount,
  totDiscount,
  totAmount,
  tabelTotAmount,
  totTaxableAmount,
  bankDetails,
  registrationType,
  stateOfSupply,
  countryName,
  stateName,
  suppierAddressDetals,
  companyDetails,
  nonItems,
  items,
  units,
  nonItemwiseTableAmount,
  journalhtmlItems,
  journalhtmlNonItems,
  totGstRate,
  journelReady,
  companyState,
}) => {
  let itemEntry = true;
  let currencySymbol = billingCurrencyOptions.find(
    (elem) => data?.currency?.value == elem.value
  )?.sign;
  currencySymbol = currencySymbol || "";

  console.log({
    invTransArr,
    data,
    totGstCess,
    totGST,
    totNetAmount,
    totDiscount,
    totAmount,
    tabelTotAmount,
    totTaxableAmount,
    bankDetails,
    registrationType,
    stateOfSupply,
    countryName,
    stateName,
    suppierAddressDetals,
    companyDetails,
    nonItems,
    items,
    units,
    nonItemwiseTableAmount,
    journalhtmlItems,
    journalhtmlNonItems,
    totGstRate,
    journelReady,
    companyState,
  });

  console.log(companyDetails.companyname);
  const renderJournel = () => {
    {
      let ren = "";
      invTransArr = invTransArr.sort((p1) =>
        p1.debitAmt !== 0 ? -1 : p1.creditAmt == 0 ? 0 : 1
      );
      invTransArr.map((ele, ind) => {
        ren += `<tr key={ind}>
                        ${
                          ele.debitAmt == 0 && ele.creditAmt == 0
                            ? ``
                            : `
                                <td
                                    size="small"
                                    sx={{
                                        fontWeight: "bold",
                                        color: ele.debitAmt !== 0 ? "#396afc" : "#20e0cf",
                                        width: "300px",
                                        height: "0px",
                                    }}
                                >
                                    ${
                                      ele.debitAmt !== 0
                                        ? ele.accountName + " " + "Dr"
                                        : "To" + " " + ele.accountName
                                    }
                                </td>
                                <td
                                    align="right"
                                    size="small"
                                    sx={{
                                        fontWeight: "bold",
                                        color: "#396afc",
                                        width: "30px",
                                        height: "0px",
                                    }}
                                >
                                    ${
                                      ele.debitAmt == 0
                                        ? " "
                                        : MoneyFormatv3(
                                            Number(ele.debitAmt).toFixed(2),
                                            "en-IN"
                                          )
                                    }
                                </td>
                                <td
                                    align="right"
                                    size="small"
                                    sx={{
                                        fontWeight: "bold",
                                        color: "#20e0cf",
                                        width: "30px",
                                        height: "0px",
                                    }}
                                >
                                    ${
                                      ele.creditAmt == 0
                                        ? " "
                                        : MoneyFormatv3(
                                            Number(ele.creditAmt).toFixed(2),
                                            "en-IN"
                                          )
                                    }
                                </td>
                           `
                        }
                    </tr>`;
      });
      return ren;
    }

    return;
    if (journelReady) {
      return journelReady;
    }
    let row = "";
    if (itemEntry) {
      journalhtmlItems?.map((item) => {
        if (item.editable === false)
          row += `<tr style="color:#396afc;font-weight: bold;">
                           <td width="60%">${
                             item.purchaseAccount?.label
                           } Dr</td>
                           <td width="20%" align="center">${MoneyFormatv3(
                             Number(item.amountTaxable).toFixed(2),
                             "en-IN"
                           )}</td>
                           <td width="20%" align="center"></td>
                         </tr>
                         `;
      });
    } else {
      //nonItems.map((ele) => {
      journalhtmlNonItems?.map((ele) => {
        if (ele.editable === false)
          row += `<tr style="color:#396afc;font-weight: bold;">
                         <td width="60%"> ${ele.ledgerAccount?.label} Dr</td>
                  
                         <td width="20%" align="center">${MoneyFormatv3(
                           Number(ele.amountTaxable).toFixed(2),
                           "en-IN"
                         )}</td>
                         <td width="20%" align="center"></td>
                       </tr>`;
      });
    }
    return row;
  };
  let isNonItemExist = nonItems?.length ? true : false;
  let isItemExist = items?.length ? true : false;
  console.log(isNonItemExist, isItemExist);
  let colspan = 11;
  if (data.placeOfSupply.value !== companyState) {
    colspan -= 1;
  } else {
    console.log(
      nonItems,
      nonItems?.filter((item) => item.new).length,
      nonItems?.filter((item) => item.new)
    );
    // if (nonItems?.filter(((item) => !item.new)).length == 0) {
    //     colspan -= 1
    // }
  }
  if (totGstCess == 0) {
    colspan -= 1;
  }
  const renderRowNon = () => {
    let row = "";

    if (nonItems && nonItems?.length > 0) {
      console.log(nonItems);
      nonItems.forEach((item, index) => {
        row += `
          <tr style="min-height: 100px">
          <td>${index + 1}</td>
          <td style="text-align:left">${item.ledgerAccount.label}</td>
          <td>${item?.HSN?.value}</td>
          <td class="moneyAlign">${MoneyFormatv3(
            item.taxableAMount,
            "en-IN"
          )}</td>
          ${
            data.placeOfSupply.value === companyState
              ? `
          <td style="border:none;padding:0px" colspan="" >
        <table style="width:100%">
        <tr>
        <td style="text-align:center;width:50%"> 
        ${item.GSTRate / 2}
        </td>
        <td style="text-align:right;width:50%"> 
        ${
          data.placeOfSupply.value === companyState
            ? MoneyFormatv3(
                (
                  (Number(item.taxableAMount) * Number(item.GSTRate)) /
                  200
                ).toFixed(2)
              )
            : "0.00"
        }
        </td>
        </tr>
        </table>
            </td>
            <td  style="border:none;padding:0px"  >
            <table style="width:100%">
            <tr>
            <td style="text-align:center;width:50%"> 
            ${item.GSTRate / 2}
            </td>
            <td style="text-align:right;width:50%"> 
            ${
              data.placeOfSupply.value === companyState
                ? MoneyFormatv3(
                    (
                      (Number(item.taxableAMount) * Number(item.GSTRate)) /
                      200
                    ).toFixed(2)
                  )
                : "0.00"
            }
            </td>
            </tr>
            </table>
                </td>`
              : `
                <td style="border:none;padding:0px"  >
                <table style="width:100%">
                <tr>
                <td style="text-align:center;width:50%"> 
                ${item.GSTRate}
                </td>
                <td style="text-align:right;width:50%"> 
                ${
                  data.placeOfSupply.value !== companyState
                    ? MoneyFormatv3(
                        (
                          (Number(item.taxableAMount) * Number(item.GSTRate)) /
                          100
                        ).toFixed(2)
                      )
                    : "0.00"
                }
            </td>
            </tr>
            </table>
                </td>`
          }
                ${
                  totGstCess != 0
                    ? ` <td class="moneyAlign">${MoneyFormatv3(
                        Number(item?.GSTCess).toFixed(2),
                        "en-IN"
                      )}</td>`
                    : ""
                }
          <td class="moneyAlign">${MoneyFormatv3(
            item?.netAmount?.toFixed(2),
            "en-IN"
          )}</td>
      </tr>`;
      });
      return row;
    }
  };

  const cItem = (p) => {
    if (items && items.length > 0) {
      if (p === "discount") {
        let total = 0;
        for (let i = 0; i < items.length; i++) {
          total += parseFloat(items[i].dicount);
        }
        return total;
      } else if (p === "igst" || p === "cgst" || p === "sgst") {
        let total = 0;
        for (let i = 0; i < items.length; i++) {
          total +=
            (Number(items[i].taxableAMount) * Number(items[i].GSTRate)) / 100;
        }
        return total;
      } else if (p === "total") {
        let total = 0;
        for (let i = 0; i < items.length; i++) {
          total +=
            (Number(items[i].taxableAMount) * Number(items[i].GSTRate)) / 100 +
            items[i].taxableAMount +
            Number(items[i].GSTCess);
        }
        return total;
      } else if (p === "taxablevalue") {
        let total = 0;
        for (let i = 0; i < items.length; i++) {
          total += Number(items[i].taxableAMount);
        }
        return total;
      } else if (p === "gstcess") {
        let total = 0;
        for (let i = 0; i < items.length; i++) {
          total += Number(items[i].GSTCess);
        }
        return total;
      }
    } else {
      return 0;
    }
  };
  const cNon = (p) => {
    if (nonItems && nonItems.length > 0) {
      if (p === "discount") {
        let total = 0;
        for (let i = 0; i < nonItems.length; i++) {
          total += parseFloat(nonItems[i].dicount ?? 0);
        }
        return total;
      } else if (p === "igst" || p === "cgst" || p === "sgst") {
        let total = 0;
        for (let i = 0; i < nonItems.length; i++) {
          total +=
            (Number(nonItems[i].taxableAMount) * Number(nonItems[i].GSTRate)) /
            100;
        }
        return total;
      } else if (p === "total") {
        let total = 0;
        console.log(nonItems);
        for (let i = 0; i < nonItems.length; i++) {
          total +=
            (Number(nonItems[i].taxableAMount) * Number(nonItems[i].GSTRate)) /
              100 +
            nonItems[i].taxableAMount +
            Number(items[i].GSTCess);
        }
        console.log(total);
        return total;
      } else if (p === "taxablevalue") {
        let total = 0;
        for (let i = 0; i < nonItems.length; i++) {
          total += Number(nonItems[i].taxableAMount);
        }
        return total;
      } else if (p === "gstcess") {
        let total = 0;
        for (let i = 0; i < nonItems.length; i++) {
          total += Number(nonItems[i].GSTCess);
        }
        return total;
      }
    } else {
      return 0;
    }
  };
  const calculate = (p) => {
    if (items && items.length > 0) {
      let total = 0;
      total = cItem(p) + cNon(p);
      return total;
    }
  };
  const renderRow = () => {
    let row = "";
    let all = [];
    if (items?.length > 0) {
      all = items.map((elem) => {
        elem.type = "item";
        return elem;
      });
    }
    if (nonItems?.length > 0) {
      all = [
        ...all,
        ...nonItems.map((elem) => {
          elem.type = "nonitem";
          return elem;
        }),
      ];
    }
    console.log(all);
    all = all.filter((elem) => {
      if (elem.type == "nonitem" && elem?.ledgerAccount?.label) {
        return elem;
      } else if (elem.type == "item" && elem?.itemCode?.label) {
        return elem;
      }
    });

    if (all.length > 0) {
      all.forEach((item, index) => {
        console.log(item, units);
        let unit = units.find((e) => e.value == item.units) || "";
        if (item?.name?.label?.length && item.type == "item") {
          row += `
        <tr fc="startpatternhereto983y47" style="min-height: 100px">
            <td fc="countable" style="border:none">${index + 1}</td>
            <td fc="countable" style="border:none;max-width: 190px;word-break: break-word;overflow:hidden;text-align:left" colspan="4">${
              item.name?.label
            }</td>
        

            <td fc="countable" class="right" style="border:none">${
              item.rate != 0 ? MoneyFormatv3(item.rate) : "0.00"
            }</td>
            <td fc="countable" style="border:none">${item.qty}</td>
            <td fc="countable" style="border:none">${unit?.UQC || ""}</td>
            <td fc="countable" class="right" style="border:none">${
              Number(item.amount) > 0
                ? MoneyFormatv3(Number(item.amount))
                : "0.00"
            }</td>

            ${
              calculate("discount") > 0
                ? `   <td fc="countable" class="right" style="border:none">${
                    item.dicount != 0 ? MoneyFormatv3(item.dicount) : "0.00"
                  }</td>`
                : ``
            }
            <td fc="countable" class="right" style="border:none">${
              item.amount != 0
                ? MoneyFormatv3(Number(item.taxableAMount))
                : "0.00"
            }</td>

            ${
              registrationType != 3
                ? `
                    <td fc="countable" style="border:none;padding:0px"   >
                    <table style="width:100%;table-layout:auto">
                    <tr>
                    <td style="text-align:center;width:20%;padding:0px"> 
                    ${item.GSTRate}
                    </td>
                    <td class="right" style="width:80%"> 
                    ${MoneyFormatv3(
                      (
                        (Number(item.taxableAMount) * Number(item.GSTRate)) /
                        100
                      ).toFixed(2)
                    )}
                </td>
                </tr>
                </table>
                    </td>`
                : ``
            }
                ${
                  totGstCess > 0 && registrationType != 3
                    ? `<td fc="countable" class="right" style="border:none" >${
                        item.GSTCess != 0 ? MoneyFormatv3(item.GSTCess) : "0.00"
                      }</td>`
                    : ``
                }
                <td fc="countable" class="right "  style="border:none" >${MoneyFormatv3(
                  Number(item.netAmount).toFixed(2)
                )}</td>
        </tr fc="endpatternhereto983y47">`;
        } else if (item.type === "nonitem") {
          row += `
                  <tr fc="startpatternhereto983y4790" style="min-height: 100px">
                      <td 1 fc="countable">${index + 1}</td>
                      <td 2 fc="countable" style="text-align:left;" c colspan="4">${
                        item.ledgerAccount.label
                      } ${
            item.description.length
              ? `(${
                  item.description.length > 25
                    ? item.description.slice(0, 22) + "..."
                    : item.description
                })`
              : ``
          }</td>
                      
                      <td fc="countable"></td>
                      <td fc="countable"></td>
                      <td fc="countable"></td>
                      <td fc="countable"></td>
            ${
              calculate("discount") > 0
                ? `   <td fc="countable" class="right" style="border:none">${
                    item.dicount != 0 ? MoneyFormatv3(item.dicount) : "0.00"
                  }</td>`
                : ``
            }

                     
                      ${
                        registrationType != 3
                          ? `<td 5 fc="countable" class="right">${MoneyFormatv3(
                              item.taxableAMount,
                              "en-IN"
                            )}</td>`
                          : ""
                      }
                      ${
                        registrationType != 3
                          ? `
                            <td 8  fc="countable" style="border:none;padding:0px"   >
                            <table style="width:100%">
                            <tr>
                            <td style="text-align:center;width:20%;padding:0px"> 
                            ${item.GSTRate}
                            </td>
                            <td class="right" style="width:80%"> 
                            ${MoneyFormatv3(
                              (
                                (Number(item.taxableAMount) *
                                  Number(item.GSTRate)) /
                                100
                              ).toFixed(2)
                            )}
                        </td>
                        </tr>
                        </table>
                            </td>`
                          : ""
                      }
                       ${
                         registrationType != 3 && totGstCess > 0
                           ? `<td 9 fc="countable" class="right">${
                               Number(item?.GSTCess).toFixed(2) != 0
                                 ? MoneyFormatv3(
                                     Number(item?.GSTCess).toFixed(2),
                                     "en-IN"
                                   )
                                 : "0.00"
                             }</td> `
                           : ``
                       }
              <td 10 fc="countable" class="right" >${MoneyFormatv3(
                Number(item?.netAmount).toFixed(2),
                "en-IN"
              )}</td>
                  </tr fc="endpatternhereto983y4790">`;
        }
      });
    }
    return row;
  };
  const renderRowParticulars = () => {
    let row = "";
    let arr = itemEntry ? items : nonItems;
    // console.log(items, nonItems, arr);
    if (arr && arr?.length > 0 && itemEntry) {
      arr.forEach((item, index) => {
        row += `
          <tr style="min-height: 100px">
              <td>Taxable</td>
              <td>${MoneyFormatv3(item.amount)}</td>
           <td style="display:none;">${MoneyFormatv3(item.dicount)}</td>
              <td>${item.GSTRate}</td>
              ${
                data.placeOfSupply.value === companyState
                  ? `
              <td>${
                data.placeOfSupply.value === companyState
                  ? MoneyFormatv3(
                      (
                        (Number(item.taxableAMount) * Number(item.GSTRate)) /
                        200
                      ).toFixed(2)
                    )
                  : "0.00"
              }
                  </td>
                  <td>${
                    data.placeOfSupply.value === companyState
                      ? MoneyFormatv3(
                          (
                            (Number(item.taxableAMount) *
                              Number(item.GSTRate)) /
                            200
                          ).toFixed(2)
                        )
                      : "0.00"
                  }</td>
              `
                  : `<td>${
                      data.placeOfSupply.value !== companyState
                        ? MoneyFormatv3(
                            (
                              (Number(item.taxableAMount) *
                                Number(item.GSTRate)) /
                              100
                            ).toFixed(2)
                          )
                        : "0.00"
                    }</td>`
              }
              
                  ${
                    totGstCess != 0
                      ? ` <td  >${MoneyFormatv3(item.GSTCess)}</td>`
                      : ``
                  }
                  <td>${MoneyFormatv3(Number(item.netAmount).toFixed(2))}</td>
          </tr>`;
      });
      // console.log(row);
      return row;
    } else if (arr && arr?.length > 0 && !itemEntry) {
      arr.forEach((item, index) => {
        row += `
          <tr style="min-height: 100px">
              <td>Taxable</td>
              <td>${MoneyFormatv3(item.taxAMount)}</td>
              <td style="display:none;">${MoneyFormatv3(item.dicount)}</td>
              <td>${item.GSTRate}</td>
              ${
                data.placeOfSupply.value === companyState
                  ? `
              <td>${
                data.placeOfSupply.value === companyState
                  ? MoneyFormatv3(
                      (
                        (Number(item.taxAMount) * Number(item.GSTRate)) /
                        200
                      ).toFixed(2)
                    )
                  : "0.00"
              }
                  </td>
                  <td>${
                    data.placeOfSupply.value === companyState
                      ? MoneyFormatv3(
                          (
                            (Number(item.taxAMount) * Number(item.GSTRate)) /
                            200
                          ).toFixed(2)
                        )
                      : "0.00"
                  }</td>
              `
                  : `<td>${
                      data.placeOfSupply.value !== companyState
                        ? MoneyFormatv3(
                            (
                              (Number(item.taxAMount) * Number(item.GSTRate)) /
                              100
                            ).toFixed(2)
                          )
                        : "0.00"
                    }</td>`
              }
              
                  ${
                    totGstCess != 0
                      ? ` <td  >${MoneyFormatv3(item.GSTCess)}</td>`
                      : ``
                  }
                  <td>${MoneyFormatv3(Number(item.netAmount).toFixed(2))}</td>
          </tr>`;
      });
      // console.log(row);
      return row;
    }
  };
  return `
  <html>
  <head>
   <meta name="viewport" />
   <style rel="stylesheet">

@media print {
  @page {
    margin: 0;
  }

  .header,
  .footer {
    display: none;
  }
}
.moneyAlign{
    text-align:right
   }
   .firsttable thead td{
    font-size: 12px;
  }
   .firsttable tbody td {
   font-size: 10px;
   border:none;
   padding:1px 5px;
 }
   .thirdDiv thead td {
    font-size: 9px;
    padding:0px;
  }
  
  .thirdDiv tbody td {
    font-size: 10px;
    border:none;
    padding:1px;
    
  }

  .thirdDiv tfoot td {
    font-size: 12px;
    text-align:right;
  }
.firstDiv{
  font-size:12px;
}
table, th, td {

  border-collapse: collapse;
}
.fourthTable thead td {
  font-size: 12px;
}
.fourthTable tbody td {
  font-size: 10px;
  border:none;
}
.hsnTable tbody td {
  font-size: 10px;
  border:none;
}
   </style>
  </head>
  <body>
  
  <div style="min-height: 285px; margin-left: auto; margin-right: auto; width:95%;
  margin-left: auto; margin-right: auto; padding-top: 5px">
  <div style="width: 100%; float: center;">
  <div style="display: flex; flex-direction:column; padding:10px 0px">
  <div style="display:flex; flex-direction:row-reverse; justify-content:space-between;">
  <div >
  ${
    companyDetails?.relatedcompanydetailsnew?.[0].companylogourl ==
      `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/` ||
    companyDetails?.relatedcompanydetailsnew?.[0].companylogourl == ""
      ? `
 
  `
      : `
  <img src="${companyDetails?.relatedcompanydetailsnew?.[0].companylogourl}"
  alt="CompanyLogo" width="80px" height="80px">
  `
  }
    </div >
    <div style="max-width:40%;word-break:break-word;" >
  <span style="font-size: 15px; padding-bottom: 5px;
   font-weight:bold;">
   ${companyDetails?.companyname}
  </span><br/>
  
  <span style="font-size: 12px;max-width:50% ">
        ${
          companyDetails?.line1?.replace(/[**,]+/g, "")
            ? companyDetails?.line1?.replace(/[**,]+/g, " ") + ", "
            : ""
        }</span>   <span style="font-size: 12px;">${
    companyDetails?.city ? companyDetails?.city + ", " : ""
  }${
    companyDetails?.district?.replace("District", "")
      ? companyDetails?.district?.replace("District", "") + ", "
      : ""
  }${
    companyDetails?.statename.replace("District", "")
      ? companyDetails?.statename.replace("District", "") + ", "
      : ""
  }${companyDetails?.countrycode?.replace("State", "")}</span>
          <span style="font-size: 12px;
         ">${
           companyDetails?.pincode &&
           ", " + companyDetails?.pincode?.split("**").join("\n")
         }
  </span>
    ${
      registrationType !== 1
        ? `
  <br/> 
  ${
    companyDetails?.relatedcompanyentity?.[0].gstin
      ? `
  <span style="font-size: 12px;
  ">
  <strong>GSTIN : </strong> ${companyDetails?.relatedcompanyentity?.[0].gstin}
  </span>`
      : ""
  }`
        : ""
    }
  </div>
  </div>

  </div>
  </div>

  <div style=" display: flex;
  flex-direction:row; justify-content: center;padding:0px 10px ">
               <span style="font-size: 18px; font-weight: bolder;  padding:20px 0px ;">
                   DEBIT NOTE
               </span>
           </div>

  <div class="firstDiv" >
      <table border="1" class="firsttable" cellpadding="5" cellspacing="0" width="100%"
      style="margin-left: auto; margin-right: auto; margin-top:auto;">
  <thead style="background-color: #DADBDD; font-weight: bold;">
      <tr>
          <td>Voucher Details</td>
          <td>Supplier Details</td>
      </tr>
  </thead>
  <tbody>
  <tr><td style="height:5px;border:none" colspan="*" rowspan="*" ></td></tr>
   <tr style="min-height: 100px">
   <td style="font-weight: bold;">Voucher No : <span style="white-space:nowrap">${
     data.voucherNumber
   }</span></td>
   <td style="">Supplier Name : ${data?.partyName?.legalName || ""}</td>
   </tr>
  <tr style="min-height: 100px">
  <td style="white-space:nowrap">Voucher Date : ${
    data.invoiceDate === ""
      ? moment(new Date()).format("DD-MM-YYYY")
      : moment(data.invoiceDate).format("DD-MM-YYYY")
  }</td>
  <td style="">Supplier Address : ${
    data?.partyName?.label != ""
      ? `
      <span>
        ${
          suppierAddressDetals.supplierAddress !== ""
            ? suppierAddressDetals.billingAddress?.replace(/[**,]+/g, ",") || ""
            : data.supplierAddress?.replace(/[**,]+/g, ",") || ""
        }
      </span>
      ${
        suppierAddressDetals.stateCD !== "" || stateName !== ""
          ? `
        <span
  
        >
          ${
            suppierAddressDetals.stateCD?.label
              ? suppierAddressDetals.stateCD.label
              : stateName.label || stateName.label + ","
          }
          ${countryName.label || ""}
        </span>`
          : `
        <span
  
        >
          ${countryName.label || ""}
  
        </span>`
      }
  `
      : ``
  }</td>
  </tr>
  ${
    data.reverseChargeFlag == 1
      ? `
  <tr style="min-height: 100px">
  <td style="">Reverse Charge (Y/N) : ${
    data.reverseChargeFlag == 1 ? "Yes" : "No"
  }</td>
    <td></td>
  </tr>`
      : ``
  }
  <tr style="min-height: 100px">
  <td style="">${
    data.creditPeriod !== "0" ? `Credit Period : ${data.creditPeriod}` : ` `
  }</td>
  <td style="">Contact Person :</td>
  </tr>
  <tr style="min-height: 100px">
  <td style=""></td>
  <td style="">Supplier Invoice No : ${data.orderNumber}</td>
  </tr>
  <tr style="min-height: 100px">
  <td  style="">${
    data.dueDate != "Invalid date"
      ? `Due Date : ${moment(data.dueDate).format("DD-MM-YYYY")}`
      : ``
  }</td>
  <td style="">Supplier GSTIN : ${data.gstin}</td>
  </tr>
  ${
    registrationType !== 3
      ? `  <tr style="min-height: 100px">
  <td></td>
<td style="">Place of Supply : ${data?.placeOfSupply?.label} </td>
  </tr>`
      : ``
  }
  <tr><td style="height:5px;border:none" colspan="*" rowspan="*" ></td></tr>

  </tbody>
  </table>
  </div>
  <div style="margin-top:10px"class="thirdDiv" >
<table border="1" t="1" cellpadding="5" cellspacing="0" width="100%"
            style="margin-left: auto; margin-right: auto; text-align: center;">
        <thead style="background-color: #DADBDD; font-weight: bold;">
            <tr>
                <td style="width:30px">Sl .No</td>
                <td colspan="4" style="min-width:80px;max-width:240px;text-overflow:ellipsis">Item Name</td>
                <td>Rate</td>
                <td>Qty</td>
                <td>Unit</td>
                <td>Amount</td>
                ${Number(totDiscount) > 0 ? `<td>Discount</td>` : ``}
                <td style="width:90px;">Taxable Amount</td>
          <td  style="padding:0px;height: 45px;width:80px;
          vertical-align: unset;">
          <div style="height:100%;">
          <table  style="width:100%;height:100%;">
          <tr>
          <td colspan="2" style="text-align:center" > GST</td>
          </tr>
          <tr style="border-top:1px solid;border-color: inherit">
              <td style="text-align:center;width:30%;border-right: 1px solid;border-color: inherit">&nbsp;%&nbsp;</td>
              <td style="text-align:center;width:70%">Amount</td>
            </tr>
          </table>
          </div>
        </td>

      
      ${totGstCess != 0 ? `<td style="width:60px">GST Cess</td>` : ``}
                <td style="text-align:center;width:80px">Net Amount</td>
            </tr>
           
        </thead>
        <tbody>
  <tr><td style="height:5px;border:none" colspan="*" rowspan="*" ></td></tr>

            ${renderRow()}
    </tbody >
     
 
  </table > 
    
    
<table width="100%"  class="item-table" border style="margin-top:auto" >
  <tfoot style="font-weight: bold; background-color: #DADBDD;" countablefooter>
            <tr fc="start3u434459">
                <td fc="tstp" colspan="${colspan} fc="tstpend" style="text-align: right" countfooter>TOTAL</td>
                ${
                  registrationType != 3
                    ? `<td class="right" style="width:85px" countfooter>${MoneyFormatv3(
                        totTaxableAmount.toFixed(2),
                        "en-IN"
                      )}</td>`
                    : ""
                }
                ${
                  registrationType != 3
                    ? `
                  <td colspan="1" class="right" style="padding:0px;height: 30px;width:80px;
                " countfooter>
              ${MoneyFormatv3(Number(totGST).toFixed(2), "en-IN")}
                </td>
                `
                    : ``
                }           
                ${
                  totGstCess != 0 && registrationType != 3
                    ? `<td class="right" style="width:60px" countfooter>${MoneyFormatv3(
                        totGstCess.toFixed(2),
                        "en-IN"
                      )}</td>`
                    : ``
                }

                 <td colspan="1" class="right" style="width:80px" countfooter>${MoneyFormatv3(
                   nonItemwiseTableAmount.toFixed(2),
                   "en-IN"
                 )}</td>
            </tr>
        </tfoot countablefooterend >
</table>
    </div>
    <div style="display: grid;grid-template-columns: 3fr 2fr ;margin-left: auto; margin-right: auto; width:100%;
    margin-top: 15px; padding-bottom: 10px;
   box-sizing:border-box;
   ">
       <div >
           <div style="font-size: 12px; margin-top: 10px; margin-bottom: 25px;max-width: 100%;">
            <strong>  Total amount in words : 
               ${getWords(
                 Number(totNetAmount.toFixed(2)),
                 data?.currency?.code
               )}
               </strong>
           </div>
           <div style=" margin-top: 10px; margin-bottom: 25px; width:70%">
           <table class="fourthTable" style="display:none" border="1" cellpadding="5" width="100%"
                  style="text-align: center; margin-left: 10px">
               <thead>
               <tr>
               <td colspan="8" style="font-weight: bold;" >GST RATE WISE SUMMARY
               </td>
               </tr>
                   <tr style="font-weight: bold;">
                       <td>Particulars</td>
                       <td>Amount</td>
                       <td>Rate (%)</td>
                       ${
                         data?.placeOfSupply?.value === companyState
                           ? `   <td>CGST</td>
                       <td>SGST</td>
                       `
                           : `
                       <td>IGST</td>`
                       }
                       ${totGstCess != 0 ? ` <td>GST Cess</td>` : ""}
                       <td>TOTAL</td>

                   </tr>
               </thead>
               <tbody>
               ${renderRowParticulars()}
                   <tr style="display:none;" >
                       <td>Taxable</td>
                       <td>${MoneyFormatv3(
                         totTaxableAmount.toFixed(2),
                         "en-IN"
                       )}</td>
                       <td>${Number(totGstRate).toFixed(2)}</td>
                       ${
                         data.placeOfSupply.value === companyState
                           ? ` 
                       <td>${
                         data.placeOfSupply.value === companyState
                           ? MoneyFormatv3(
                               (Number(totGST) / 2).toFixed(2),
                               "en-IN"
                             )
                           : "0.00"
                       }</td>
                      <td>${
                        data.placeOfSupply.value === companyState
                          ? MoneyFormatv3(
                              (Number(totGST) / 2).toFixed(2),
                              "en-IN"
                            )
                          : "0.00"
                      }</td>`
                           : `<td>${
                               data.placeOfSupply.value !== companyState
                                 ? MoneyFormatv3(
                                     Number(totGST).toFixed(2),
                                     "en-IN"
                                   )
                                 : "0.00"
                             }</td>`
                       }
                   </tr>
                   
               </tbody>
               <tfoot>
               <tr style="font-weight:600;" >
                   <td>Total</td>
                   <td>${MoneyFormatv3(
                     totTaxableAmount.toFixed(2),
                     "en-IN"
                   )}</td>
                   <td></td>
                   ${
                     data.placeOfSupply.value === companyState
                       ? ` <td>${
                           data.placeOfSupply.value === companyState
                             ? MoneyFormatv3(
                                 (Number(totGST) / 2).toFixed(2),
                                 "en-IN"
                               )
                             : "0.00"
                         }</td>
                   <td>${
                     data.placeOfSupply.value === companyState
                       ? MoneyFormatv3((Number(totGST) / 2).toFixed(2), "en-IN")
                       : "0.00"
                   }</td>`
                       : `<td>${
                           data.placeOfSupply.value !== companyState
                             ? MoneyFormatv3(Number(totGST).toFixed(2), "en-IN")
                             : "0.00"
                         }</td>`
                   }
                  ${
                    totGstCess != 0
                      ? `<td>${MoneyFormatv3(
                          Number(totGstCess).toFixed(2),
                          "en-IN"
                        )}</td>`
                      : ""
                  }
                   <td>${MoneyFormatv3(
                     (
                       Number(totNetAmount.toFixed(2)) -
                       Number(data.tdsAmount) +
                       Number(data.adjustments)
                     ).toFixed(2),
                     "en-IN"
                   )}</td>
               </tr>
               </tfoot>
           </table>
           </div>
         
       </div>
       <div >
           <div style="display: flex; flex-direction:column; line-height: 1; ">
               <div style="display: none; flex-direction:row; justify-content: space-between;
                           font-size: 12px; padding-left: 15px;  margin-top: 5px;">
                   <span>Taxable Amount</span>
                   <span>${currencySymbol}&nbsp;${
    Number(totTaxableAmount) > 0
      ? MoneyFormatv3(totTaxableAmount.toFixed(2), "en-IN")
      : "0.00"
  }</span>
               </div>
               <div style="display: flex; flex-direction:row; justify-content: space-between;
                           font-size: 12px; padding-left: 15px;  margin-top: 5px;">
                   <span>Tax</span>
                   <span>${currencySymbol}&nbsp;${
    Number(totGST) + Number(totGstCess) > 0
      ? MoneyFormatv3((Number(totGST) + Number(totGstCess)).toFixed(2), "en-IN")
      : "0.00"
  }</span>
               </div>
               ${
                 Number(data.tdsAmount) > 0
                   ? `
      <div style="display: flex;
       flex-direction:row;
      justify-content: space-between;
                           font-size: 12px;
                            padding-left: 15px;
                              margin-top: 5px;">
        <span>TDS Amount, If Applicable</span>
        <span>${currencySymbol}&nbsp;${
                       Number(data.tdsAmount) > 0
                         ? MoneyFormatv3(
                             Number(data.tdsAmount).toFixed(2),
                             "en-IN"
                           )
                         : "0.00"
                     }</span>
      </div> `
                   : ""
               }
      ${
        Number(data.tcsAmount) > 0
          ? `
      <div style="display: flex;
       flex-direction:row;
      justify-content: space-between;
                           font-size: 12px;
                            padding-left: 15px;
                              margin-top: 5px;">
        <span>TCS Amount, If Applicable</span>
        <span>${currencySymbol}&nbsp;${
              Number(data?.tcsAmount) > 0
                ? MoneyFormatv3(Number(data?.tcsAmount).toFixed(2), "en-IN")
                : "0.00"
            }</span>
      </div> `
          : ""
      }

             ${
               Number(data.adjustments) != 0
                 ? `<div style="display: flex; flex-direction:row; justify-content: space-between;
                           font-size: 12px; padding-left: 15px; margin-top: 5px;">
                           ${
                             Number(data.adjustments) != 0
                               ? `<span>Adjustment</span>
      <span>${currencySymbol}&nbsp;${
                                   Number(data.adjustments) != 0
                                     ? Number(data.adjustments).toFixed(2)
                                     : "0.00"
                                 }</span>`
                               : ``
                           }
    </div>`
                 : ""
             }

            ${
              Number(data.roundOff) != 0
                ? `<div style="display: flex; flex-direction:row; justify-content: space-between;
            font-size: 12px; padding-left: 15px; margin-top: 5px;">
            ${
              Number(data.roundOff) != 0
                ? `<span>Discount/Roundoff</span>
<span>${currencySymbol}&nbsp;${
                    Number(data.roundOff) != 0
                      ? Number(data.roundOff).toFixed(2)
                      : "0.00"
                  }</span>`
                : ``
            }
</div>`
                : ""
            }


               <div style="display: none; flex-direction:row; justify-content: space-between;
                           font-size: 12px; padding-left: 15px;  margin-top: 5px;">
                   <span>Discount</span>
                   <span>${currencySymbol}&nbsp;${
    Number(totAmount) - Number(totTaxableAmount) > 0
      ? MoneyFormatv3(
          (Number(totAmount) - Number(totTaxableAmount)).toFixed(2),
          "en-IN"
        )
      : "0.00"
  }</span>
               </div>
               <!--
    < div style = "display: flex; flex-direction:row; justify-content: space-between;
  font - size: 12px; padding - left: 15px; padding - right: 15px; margin - top: 5px; ">
    < span > CGST</span >
      <span>${currencySymbol}&nbsp;${
    data.placeOfSupply.value === companyState
      ? MoneyFormatv3((Number(totGST) / 2).toFixed(2), "en-IN")
      : "0.00"
  }</span>
               </div >
               <div style="display: flex; flex-direction:row; justify-content: space-between;
                           font-size: 12px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
                   <span>SGST</span>
                   <span>${currencySymbol}&nbsp;${
    data.placeOfSupply.value === companyState
      ? MoneyFormatv3((Number(totGST) / 2).toFixed(2), "en-IN")
      : "0.00"
  }</span>
               </div>
           <div style="display: flex; flex-direction:row; justify-content: space-between;
                           font-size: 12px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
                   <span>IGST</span>
                   <span>${currencySymbol}&nbsp;${
    data.placeOfSupply.value !== companyState
      ? MoneyFormatv3(Number(totGST).toFixed(2), "en-IN")
      : "0.00"
  }</span>
               </div>-->

    <div style="display: flex; flex-direction:row; justify-content: space-between;
                           font-size: 15px; padding-left: 15px;  margin-top: 4px;">
      <strong>Net Payable</strong>
      <strong>${currencySymbol}&nbsp;${MoneyFormatv3(
    Number(totNetAmount.toFixed(2)),
    "en-IN"
  )}</strong>
    </div>
           </div >
       </div >
   </div >
    <div style="margin-left: auto; margin-right: auto; width:100%; box-sizing: border-box;
      border: double; border-width: 1px; border-color: black; margin-top: 15px;display:none;">
      <div >
        <div style="font-size: 14px; margin-top: 10px; margin-bottom: 5px; padding-left: 10px; font-weight:bold">
          Bank Details
        </div>
        <div>
          <div style="display: flex; flex-direction:column; line-height: 1.8;">
            <div style="display: flex; flex-direction:row; justify-content: space-between;
               font-size: 12px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
              <span style="font-weight:bold;">Account Name : ${
                bankDetails?.BankAccountName == undefined
                  ? ""
                  : bankDetails?.BankAccountName
              }</span>
              <span style="font-weight:bold;"></span>
            </div>
            <div style="display: flex; flex-direction:row; justify-content: space-between;
               font-size: 12px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
              <span style="font-weight:bold;">Account Number : ${
                bankDetails?.BankAccountNumber == undefined
                  ? ""
                  : bankDetails?.BankAccountNumber
              }</span>
              <span style="font-weight:bold;"></span>
            </div>
            <div style="display: flex; flex-direction:row; justify-content: space-between;
               font-size: 12px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
              <span style="font-weight:bold;">Bank : ${
                bankDetails?.BankName == undefined ? "" : bankDetails?.BankName
              }</span>
              <span style="font-weight:bold;"></span>
            </div>
            <div style="display: flex; flex-direction:row; justify-content: space-between;
               font-size: 12px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
              <span style="font-weight:bold;">IFSC Code : ${
                bankDetails?.IFSCCode == undefined ? "" : bankDetails?.IFSCCode
              }</span>
              <span style="font-weight:bold;">
              </span>
            </div>
          </div>
        </div>

      </div>
    </div> 
    <div style="font-size:10px">
    <div >

    Payment Type : ${data.paymentType}
    ${
      data.paymentType == "Credit"
        ? `
    
    <div>
    
    Credit Period : ${data.creditPeriod}<br/>
    Due Date : ${moment(data.dueDate).format("DD-MM-YYYY")}
    
    </div>
    
    `
        : ``
    }
    </div>

    ${
      data?.paymentType == "Bank"
        ? `
    <div> Paid Amount : ${data.receivedAmount}  </div>
    <div> Bank Reference No : ${data.bankReferenceNo}  </div>
    <div> Bank : ${data?.receivedAccount?.label || ""}  </div>
    </div>
    `
        : ``
    }
    ${
      data?.paymentType == "Cash"
        ? `
    <div>
    Paid Amount : ${data?.receivedAmount}
    </div>
    `
        : ``
    }
    </div>
    
${
  data?.remarks?.length
    ? `
<div style="font-size: 14px; ">
  <div  style="background-color: #DADBDD; font-weight:bold;padding:5px; box-sizing: border-box;">Description</div>

              <p style="padding-left: 5px;"> ${data.remarks}</p>
          </div>

          `
    : ``
}
   <div style="width:100%; margin-top:12px;display:none"><span style="font-size: 14px;
   text-align: center; font-weight:bold;">
    Journal Entry
   </span>
                          </div>
   <div style="margin-left: auto; margin-right: auto; display:none;
               border: 1px solid black;  margin-top: 15px;padding:5px;">
               <table cellpadding="2" cellspacing= "0" width="100%" 
               style="margin-left: auto; margin-right: auto; margin-top: 10px;">
               <thead>
               </thead>
               <tbody style="font-size:12px;">
               <tr style="font-weight: bold;">
               <td width="60%">Particulars</td>
               <td width="20%" align="right">Debit(₹)</td>
               <td width="20%" align="right">Credit(₹)</td>
             </tr>
               ${renderJournel()}
                 
               </tbody>
             </table>
   </div>
  </body >
  </html >
    `;
};
export const ReceiptPrint = ({companyDetails, state, userData, voucherNo, type, vouchers}) =>{
console.log({userData})
    function linkedInvoice(vouchers = []) {
       return (vouchers || [])
        .map(v => v?.ObjectAttribute)
        .filter(Boolean)
        .join(", ");
    }


  console.log(vouchers,"********state")
      return `
      <html>
          <head>
              <meta name="viewport" />
              <style rel="stylesheet">
              @media print {
    @page {
      margin: 0;
    }
  
    .header,
    .footer {
      display: none;
    }
  }
              .moneyAlign{
                  text-align:right
                 }
                 .firsttable thead td{
                  font-size: 12px;
                }
                 .firsttable tbody td {
                 font-size: 10px;
                 border:none;
                 padding:1px 5px;
               }
                 .thirdDiv thead td {
                  font-size: 9px;
                  padding:0px;
                }
                
                .thirdDiv tbody td {
                  font-size: 10px;
                  border:none;
                  padding:1px;
                  
                }
              
                .thirdDiv tfoot td {
                  font-size: 12px;
                  text-align:right;
                }
              .firstDiv{
                font-size:12px;
              }
              table, th, td {
              
                border-collapse: collapse;
              }
              .fourthTable thead td {
                font-size: 12px;
              }
              .fourthTable tbody td {
                font-size: 10px;
                border:none;
              }
              .hsnTable tbody td {
                font-size: 10px;
                border:none;
              }
                 </style>
          </head>
          <!--
          <body>
            
    <div style="min-height: 285px; margin-left: auto; margin-right: auto; width:95%;
    margin-left: auto; margin-right: auto; padding-top: 5px">
    <div style="width: 100%; float: center;">
    <div style="display: flex; flex-direction:column; padding:10px 0px;">
    <div style="display:flex; flex-direction:row-reverse; justify-content:space-between;">
    <div >
    ${
      companyDetails?.relatedcompanydetailsnew?.[0].companylogourl == `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/` ||
      companyDetails?.relatedcompanydetailsnew?.[0].companylogourl == ''
        ? `
   
    `
        : `
    <img src="${companyDetails?.relatedcompanydetailsnew?.[0].companylogourl}"
    alt="CompanyLogo" width="80px" height="80px">
    `
    }
      </div >
      <div style="max-width:40%;word-break:break-word;" >
    <span style="font-size: 15px; padding-bottom: 5px;
     font-weight:bold;">
     ${companyDetails?.companyname}
    </span><br/>
    <span style="font-size: 12px;max-width:50% ">
          ${
            companyDetails?.line1?.replace(/[**  ,]+/g, '') ? companyDetails?.line1?.replace(/[**  ,]+/g, ' ') + ', ' : ''
          }</span>   <span style="font-size: 12px;">${companyDetails?.city ? companyDetails?.city + ', ' : ''}${
        companyDetails?.district?.replace('District', '') ? companyDetails?.district?.replace('District', '') + ', ' : ''
      }${companyDetails?.statename ? companyDetails?.statename.replace('District', '') + ', ' : ''}${companyDetails?.countrycode?.replace(
        'State',
        ''
      )}</span>
          <span style="font-size: 12px;
         ">${companyDetails?.pincode && ', ' + companyDetails?.pincode?.split('**').join('\n')}
    </span> 
   
    ${
      companyDetails?.relatedcompanyentity?.[0].gstin && companyDetails?.relatedcompanydetailsnew?.[0].registrationtype !== 3
        ? `
    <span style="font-size: 12px;
    ">
    <strong>GSTIN : </strong> ${companyDetails?.relatedcompanyentity?.[0].gstin}
    </span>`
        : ''
    }
    </div>
    </div>
    </div>
    </div>
           <div style=" display:flex; flex-direction:column; justify-content: space-between; align-items: end;">
              <span style="">Receipt No: ${state?.vouchernumber !== '' ? state.vouchernumber : voucherNo}</span>
              <span style="">Receipt Date: ${state?.date ? moment(state?.date).format('DD-MM-YYYY') : ''}</span>
          </div>
       <div>
     <br>
     ${type === "Receipt" ? `Received From M/s
         ${state.receivedFrom.label} Rs ${MoneyFormatv3(Number(state.receivableAmount).toFixed(2))} ( ${getWords(
        Number(state.receivableAmount).toFixed(2)
      )} )` :` Paid To M/s      
             ${state.paidTo.label} Rs ${MoneyFormatv3(Number(state.payableAmount).toFixed(2))} ( ${getWords(
            Number(state.payableAmount).toFixed(2)
          )} only )`}

    <span style="white-space:nowrap;"> By ${
      state.method == 'CashReceipt'
        ? `Cash${state.Towards ? `, towards : ${state.Towards}.` : '.'}`
        : `Bank${state.bankRefNo?.length > 0 ? `, Ref No: ${state.bankRefNo}` : ''}${state.Towards ? `, towards : ${state.Towards}.` : '.'}`
    } ${Number(state?.tdsAmount) ? `<br>TDS Rs ${MoneyFormatv3(Number(state?.tdsAmount))} deducted.` : ''}
     </div>
  <br>
  <div style="display:flex;flex-direction:row;justify-content: space-between; ">
  <div>
  Name : ${userData.name ?? ''}<br>${userData.designation?.length ? `Designation : ${userData.designation}` : ``}
  </div >
  <div >
  Signature 
  </div>  
  </div>
  </div >
  </body >
  -->

  <body style="">
    <div style="padding:20px;border:solid 1px black;dispaly:flex;justify-content:center;box-sizing: border-box;">
      <!--head portion-->
      <div style="display: flex; justify-content: space-between; align-items: flex-start;font-size:15px;min-height:30px">
        <div>
        ${type === "Receipt" ? `<span>Receipt</span>` : `<span>Payment</span>`}
        </div>

        <div>
           ${
            companyDetails?.relatedcompanydetailsnew?.[0].companylogourl == `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/` ||
            companyDetails?.relatedcompanydetailsnew?.[0].companylogourl == ''
              ? `
              `
                  : `
              <img src="${companyDetails?.relatedcompanydetailsnew?.[0].companylogourl}"
              alt="CompanyLogo" width="60px" height="60px">
              `
              }
        </div>
      </div>
      <hr style="height: 4px; background-color:rgb(159, 3, 159); border: none;">

      <!--mid portion-->

      <div style="display: flex; justify-content: space-between; align-items: flex-start;min-height:80px">
          <div style="width:40%">
            <div style="word-break:break-word;" >
              <span style="font-size: 15px; margin-bottom:px;font-weight:bold;">
                ${companyDetails?.companyname}
              </span><br/>

              <div style="line-height:1;margin-top:5px;">
                  <span style="font-size: 12px;max-width:50%;">
                    ${
                      companyDetails?.line1?.replace(/[**  ,]+/g, '') ? companyDetails?.line1?.replace(/[**  ,]+/g, ' ') + ',' : ''
                    }
                  </span> 
                  <div style="line-height:1">
                       <span style="font-size: 12px;">${companyDetails?.city ? companyDetails?.city + ', ' : ''}
                        ${
                        companyDetails?.district?.replace('District', '') ? companyDetails?.district?.replace('District', '') + ', ' : ''
                        }
                        ${companyDetails?.statename ? companyDetails?.statename.replace('District', '') + ', ' : ''}
                        ${companyDetails?.countrycode?.replace(
                        'State',
                        ''
                        )}
                        </span>
                        <span style="font-size: 12px;
                        ">${companyDetails?.pincode && ', ' + companyDetails?.pincode?.split('**').join('\n')}
                        </span>                
                  </div>
                  <div style="line-height:1">
                                          
                  </div>     
                  <div style="display:flex;flex-direction:column;gap:3px;margin-top:3px">
                       
                        ${companyDetails?.relatedphonecontacts?.[0]?.phonenumber? `<div style="font-size:12px">Phone: ${companyDetails?.relatedphonecontacts?.[0]?.phonenumber}</div>` : ``}
                        ${companyDetails?.relatedemailcontacts?.[0]?.emailaddress? `<div style="font-size:12px">email: ${companyDetails?.relatedemailcontacts?.[0]?.emailaddress}</div>` : ``}

                   </div>      
              </div>             
            </div>
          </div>

          <div style=" display:flex; flex-direction:column; gap:3px;font-size:12px;">
              ${type === "Receipt" ? `<span style="white-space: nowrap">Receipt No: ${state?.vouchernumber !== '' ?  state.vouchernumber : ''}</span>
              <span style="white-space: nowrap">Receipt Date: ${state?.date ? formatDate(state?.date) : ''}</span>
              ` : 
              `<span style="white-space: nowrap">Payment No: ${state?.vouchernumber !== '' ? state.vouchernumber : ''}</span>
              <span style="white-space: nowrap">Payment Date: ${state?.date ? formatDate(state?.date) : ''}</span>`}

                 ${
                        companyDetails?.relatedcompanyentity?.[0].gstin && companyDetails?.relatedcompanydetailsnew?.[0].registrationtype !== 3
                        ? `
                        <span style="font-size: 12px;
                        ">
                        <strong>GSTIN : </strong> ${companyDetails?.relatedcompanyentity?.[0].gstin}
                        </span>`
                        : ''
                        }  
                 ${companyDetails.relatedcompanydetailsnew[0].pannumber? `<div style="font-size:12px">Pan: ${companyDetails.relatedcompanydetailsnew[0].pannumber}</div>` : `` } 
              
              <!----<div style="display:flex;align-items:center;height:20px;border:solid 2px black;padding:2px;white-space: nowrap;padding:5px"> 
                <span> 
                  ${type === "Receipt" ? `${state.method == 'CashReceipt' ? `Cash` : `Bank`} : ${MoneyFormatv3(Number(state.receivableAmount).toFixed(2))}` : 
                  `${state.method == 'CashPayment' ? `Cash` : `Bank`} : ${MoneyFormatv3(Number(state.payableAmount).toFixed(2))}`} 
                  ₹  
              </div>--->
          </div>  
      </div>
      
      <hr style="height: 4px; background-color: rgb(159, 3, 159); border: none;">

      <!--end portion-->
      <div style="min-height:100px">
         <div style="padding-left:0px;padding-right:0px;">
            <div style="font-size:12px; margin-top:20px;">
                ${type === "Receipt" ? `${[1, 2].includes(state.receivedFrom.AccountTypeFlag)? ` Received From M/s` : `Received for`} ${state.receivedFrom.label} the sum of Rupees ${MoneyFormatv3(Number(state.receivableAmount-state?.tdsAmount).toFixed(2))} ( ${getWords(
                Number(state.receivableAmount-state?.tdsAmount).toFixed(2))}only),by ${state.method == 'CashReceipt' ? `cash`:`Bank`}${state.Towards ? `,towards ${state.Towards}` : ``} ${vouchers.length > 0? `against Invoice No: ${linkedInvoice(vouchers)}` : ``}
                
                <div style="margin-top:15px;display:flex; gap:5px ;align-items:center;display:none">
                   <div style="display:flex;align-items:center;height:20px;border:solid 2px black;padding:2px;white-space: nowrap;padding:5px;display:none"> 
                    <span> 
                      ${type === "Receipt" ? `${state.method == 'CashReceipt' ? `Cash` : `Bank`} :  ₹ ${MoneyFormatv3(Number(state.receivableAmount - state.tdsAmount).toFixed(2))}` : 
                      `${state.method == 'CashPayment' ? `Cash` : `Bank`} :  ₹ ${MoneyFormatv3(Number(state.payableAmount - state.tdsAmount).toFixed(2))}`}                                                        
                      ${state.method == 'CashReceipt' ? `` : state.bankRefNo ?  `cheque/Bank Reference No:${state.bankRefNo}`:`cheque/Bank Reference No: ..................................... `}`
                   :
                
                `${[1, 2].includes(state.paidTo.AccountTypeFlag)? `Paid To M/s` : `Paid for`} ${state.paidTo?.label} the sum of Rupees ${MoneyFormatv3(Number(state.payableAmount - state.tdsAmount).toFixed(2))} ( ${getWords(
                Number(state.payableAmount - state.tdsAmount).toFixed(2))}only), by ${state.method == 'CashPayment' ? `cash`:`Bank`}${state.Towards ? `,towards ${state.Towards}` : ``}${vouchers.length > 0? `against Invoice No: ${linkedInvoice(vouchers)}` : ``}
                  <div style="margin-top:15px;display:flex; gap:5px ;align-items:center;display:none">
                    <div style="display:flex;align-items:center;height:20px;border:solid 2px black;padding:2px;white-space: nowrap;padding:5px;min-width:160px;display:none"> 
                      <span> 
                        ${type === "Receipt" ? `${state.method == 'CashReceipt' ? `Cash` : `Bank`} : ₹${MoneyFormatv3(Number(state.receivableAmount - state.tdsAmount).toFixed(2))}` : 
                        `${state.method == 'CashPayment' ? `Cash` : `Bank`} : ₹${MoneyFormatv3(Number(state.payableAmount - state.tdsAmount).toFixed(2))}`} 
                      </span> 
                    </div>
                    ${state.method == 'CashPayment' ? "" : state.bankRefNo ?  `cheque/Bank Reference No:${state.bankRefNo}`:`cheque/Bank Reference No: ..................................... `}` }   
                  </div>
            </div>
            <div style ="display:flex; justify-content:space-between; align-items:flex-end;margin-top:15px">
                <div style= "display:flex; flex-direction:column; gap:5px">
                  <div style="font-size:12px">
                    ${state.method == 'CashPayment' ||  state.method ==='CashReceipt' ? "" : `${ state.bankRefNo ?  `Cheque/Bank Reference No:${state.bankRefNo}`:`cheque/Bank Reference No:  `}`} 
                  </div> 
                  <div style="display:flex;align-items:center;height:20px;border:solid 2px black;padding:2px;white-space: nowrap;padding:5px;font-size:12px;min-width:120px;width:100%">
                    ${ state.method === 'CashPayment' ||  state.method === 'CashReceipt' ? `Cash` : `Bank`} : ${type ==="Receipt" ? `₹${MoneyFormatv3(Number(state.receivableAmount - state.tdsAmount).toFixed(2))}/-` : `₹${MoneyFormatv3(Number(state.payableAmount - state.tdsAmount).toFixed(2))}/-`  }
                  </div>
                               
                </div>
              <div style="font-size:12px;margin-top:15px">
                <div style="display: flex; flex-direction: column; gap: 5px">
                  <div style="display: flex; gap: 15px; align-items: center;">
                    <div>Signature:</div>
                    <div>&nbsp</div>
                  </div>
                <div style="display: flex; gap: 15px; align-items: center;">
                    <div>Name:</div>
                    <div>${userData.name+' ' ?? ''}${userData?.lastName ?? ''}</div>
                </div>
                </div>
              </div>
            </div>
         </div> 
      </div>
    </div>
  </body>
  </html >`;
  
}


